(function() {
  'use strict';

  /** @namespace estimateMeUi */

  angular
    .module('estimateMeUi', [
      'restangular',
      'ngStorage',
      'ngTouch',
      'ngMaterial',
      'ui.router',
      'angularInlineEdit',
      'as.sortable',
      'RecursionHelper',
      'ui.tree',
      'angularFileUpload',
      'contenteditable',
      'infinite-scroll'
    ]);

})();

(function() {
  'use strict';
  angular
    .module('estimateMeUi')
    .directive('navigatable', navigatable);
  /** @ngInject */
  function navigatable() {
    return {
      restirct: 'A',
      link: link
    };

    function link() {

    }
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
      .directive('workhoursTable', workhoursTable);

  /** @ngInject */
  function workhoursTable() {
    return {
      templateUrl: '/app/components/directives/workhoursTable/workhoursTable.html',
      restrict: 'E',
      scope: {
        item: '=',
        count: '=',
        parent: '=',
        workhourIndex: '=',
        saveWorkhour: '=',
        saveCount: '=',
        roleList: '=',
        phaseList: '=',
        deleteWorkhour: '=',
        tableRow: '=',
        isEditable: '=',
        isPartOfGroup: '=',
        len: '=',
        changeRoleNewTask: '=',
        locale: '='
      },
      controller: 'WorkhoursTableController',
      controllerAs: 'vm',
      bindToController: true
    };
  }
})();

(function() {
  'use strict';
  angular
      .module('estimateMeUi')
      .controller('WorkhoursTableController', WorkhoursTableController);

  /** @ngInject */
  function WorkhoursTableController(EstimatesApi, $mdDialog) {
    var vm = this;
    vm.descriptionOpen = false;
    vm.value = '';
    if (vm.item.role) {
      if (vm.roleList && !vm.item.role.name) {
        vm.roleName = vm.roleList.find(function(role) {
          return role._id === vm.item.role;
        });
      } else {
        vm.roleName = vm.item.role;
      }
    }

    vm.associateWorkhour = function(event) {
      if (vm.isEditable) {
        $mdDialog.show({
            targetEvent: event,
            locals: {
              associated: vm.item.associated
            },
            controller: 'AssociateWorkhourModalController',
            controllerAs: 'vm',
            templateUrl: '/app/components/views/associateWorkhour.html',
            clickOutsideToClose: true,
            fullscreen: true
          })
          .then(function(response) {
            var listPhases = {};
            if (response) {
              listPhases.associated = response.listPhases;
              EstimatesApi.associateWorkhours(vm.item._id, listPhases).then(function(res) {
                vm.item.associated = res;
              });
            }
          });
      }
    };

    vm.isDescriptionButtonVisible = function() {
      if (vm.isEditable) {
        if (vm.locale == 'ru') {
          return (vm.item.description === null || vm.item.description === '');
        } else if (vm.locale == 'en') {
          return (vm.item.descriptionEn === null || vm.item.descriptionEn === '');
        }
      } 
      return false;
    };

    vm.show = function() {
      if (!vm.isEditable) {
        return vm.descriptionOpen && !!vm.item.description;
      }else {
        return vm.descriptionOpen;
      }
    };

    vm.getAssociatedPhases = function() {
      var phasesName = vm.item.associated.map(function(item) {
        var i = vm.phaseList.findIndex(function(phase) {
          return phase._id === item;
        });
        return (i !== -1) ? vm.phaseList[i].name : '';
      });
      return phasesName.join(', ');
    };

    vm.deleteItem = function(event) {
      if (!vm.isPartOfGroup) {
        vm.deleteWorkhour(vm.workhourIndex, vm.parent, event);
      }
    };

    vm.toggleDescription = function() {
      vm.descriptionOpen = !vm.descriptionOpen;
    };

    vm.changeRole = function(e) {
      if (vm.workhourIndex === vm.len - 1) {
        vm.changeRoleNewTask(e, vm.item.role._id);
      }
    };

    vm.error = function(field) {
      return !vm.item[field] || +(vm.item.minHours) > +(vm.item.maxHours);
    };

    vm.roleFilter = function(role) {
      return role && role.name !== 'qa' && role.name !== 'pm';
    };

    vm.validate = function(event) {
      event.stopPropagation();
      if (!vm.count) {
        vm.count = 1;
      }
      if (vm.count != vm.value) {
        var workhour = {
          count: vm.count,
          itemId: vm.item._id
        };
        vm.saveCount(workhour, vm.parent._id);
      }
    };

    vm.setValueCount = function() {
      vm.value = vm.count;
    };

    vm.setValue = function(field) {
      if (vm.item[field] && vm.item[field]._id) {
        vm.value = vm.item[field]._id;
      } else {
        vm.value = vm.item[field];
      }
    };

    vm.compare = function(field) {
      if (vm.item[field] === '' && field !== 'description') {
        vm.item[field] = vm.value;
      }
      if (field === 'minHours' || field === 'maxHours') {
        if (!vm.item[field]) {
          vm.item[field] = 0;
        }
      }
      if (angular.isString(vm.item[field])) {
        vm.item[field] = vm.item[field].replace(/^\s+/, '').replace(/\s+$/, '');
      }
      if (vm.value == vm.item[field] || (vm.item[field]._id && vm.item[field]._id === vm.value)) {return;}
      vm.save(field);
    };

    vm.save = function(field) {
      var item = {};
      item._id = vm.item._id;
      item[field] = vm.item[field];
      vm.saveWorkhour(item);
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('estimateMeUi')
    .directive('typeaheadTaskPhase', typeaheadTaskPhase);
  function typeaheadTaskPhase() {
    return {
      templateUrl: '/app/components/directives/typeaheadTaskPhase/typeaheadTaskPhase.html',
      restrict: 'E',
      scope: {
        newCustomItem: '=',
        newExistingItem: '=',
        groupsDictionary: '=',
        tasksDictionaty: '=',
        isFeature: '=',
        addFeature: '&onAddFeature',
        addTask: '&onAddTask'
      },
      controller: 'typeaheadTaskPhaseController',
      controllerAs: 'vm',
      bindToController: true
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('estimateMeUi')
    .controller('typeaheadTaskPhaseController', typeaheadTaskPhaseController);
  /** @ngInject */
  function typeaheadTaskPhaseController() {
    /* jshint validthis:true */
    var vm = this;
    vm.querySearchTasks = querySearchTasks;
    vm.querySearchFeature = querySearchFeature;
    vm.createCustom = createCustom;
    vm.selectedItemChange = selectedItemChange;
    vm.associatedTasks = getAssociated(vm.tasksDictionaty);
    vm.associatedGroups = getAssociated(vm.groupsDictionary);

    function querySearchTasks(query) {
      return query ? vm.tasksDictionaty.filter(createFilterFor(query)) : vm.tasksDictionaty;
    }

    function querySearchFeature(query) {
      return query ? vm.groupsDictionary.filter(createFilterFor(query)) : vm.groupsDictionary;
    }

    function createCustom(text) {
      if (text === null || text.trim() === '') {
        return;
      }
      vm.newCustomItem(vm.isFeature, text.trim());
      vm.searchText = '';
    }

    function selectedItemChange(item) {
      if (angular.isDefined(item)) {
        vm.newExistingItem(item);
        vm.searchText = '';
      }
    }

    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(item) {
        return (angular.lowercase(item.name).indexOf(lowercaseQuery) >= 0);
      };
    }

    function getAssociated(dictionary) {
      var associatedTasks = {};
      dictionary.forEach(function(task) {
        var list = '';
        task.associated.forEach(function(phase) {
          if (phase.name) { list += phase.name + ', '; }
        });
        associatedTasks[task._id] = list.substring(0, list.length - 2);
      });
      return associatedTasks;
    }
  }
})();

(function() {
  angular
    .module('estimateMeUi')
    .directive('typeaheadTaskInline', typeaheadTaskInline);

  /** @ngInject */
  function typeaheadTaskInline() {
    return {
      templateUrl: '/app/components/directives/typeaheadTaskInline/typeaheadTaskInline.html',
      restrict: 'E',
      scope: {
        newCustomItem: '=',
        newExistingItem: '=',
        phaseItem: '=',
        inputVisib: '=',
        tasksDictionaty: '='
      },
      controller: 'typeaheadTaskInlineController',
      controllerAs: 'vm',
      bindToController: true
    };
  }
})();

(function() {
  angular
    .module('estimateMeUi')
    .controller('typeaheadTaskInlineController', typeaheadTaskInlineController);

  /** @ngInject */
  function typeaheadTaskInlineController($scope, $element, $filter, $document) {
    var vm = this;
    vm.querySearch = querySearch;
    vm.createCustom = createCustom;
    vm.selectedItemChange = selectedItemChange;
    vm.associatedTasks = getAssociated();

    function querySearch(query) {
      return query ? vm.tasksDictionaty.filter(createFilterFor(query)) : vm.tasksDictionaty;
    }

    function createCustom(text) {
      if (text === null || text.trim() === '') {
        return;
      }

      vm.newCustomItem(text.trim(), vm.phaseItem);
      vm.searchText = '';
    }

    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(item) {
        return (angular.lowercase(item.name).indexOf(lowercaseQuery) >= 0);
      };
    }

    function selectedItemChange(item) {
      if (angular.isDefined(item)) {
        vm.newExistingItem(item, vm.phaseItem);
        vm.searchText = '';
      }
    }

    function onDocumentClick(event) {
      var parent = event.target;
      while (parent && parent !== $element[0] && parent.nodeName !== 'MD-VIRTUAL-REPEAT-CONTAINER') {
        parent = parent.parentNode;
      }
      if (!parent) {
        $scope.$apply(vm.inputVisib(event));
      }
    }

    function getAssociated() {
      var associatedTasks = {};
      vm.tasksDictionaty.forEach(function(task) {
        var list = '';
        task.associated.forEach(function(phase) {
          if (phase.name) { list += phase.name + ', '; }
        });
        associatedTasks[task._id] = list.substring(0, list.length - 2);
      });
      return associatedTasks;
    }

    $document.on('click', onDocumentClick);
    $element.on('$destroy', function() {
      $document.off('click', onDocumentClick);
    });

  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
      .directive('tasksTable', tasksTable);

  /** @ngInject */
  function tasksTable() {
    return {
      templateUrl: '/app/components/directives/tasksTable/tasksTable.html',
      restrict: 'E',
      scope: {
        item: '=',
        parent: '=',
        roleList: '=',
        deleteTask: '=',
        undo: '=',
        copy: '=',
        isEditable: '=',
        workhour: '='
      },
      controller: 'TasksTableController',
      controllerAs: 'vm',
      bindToController: true,
      link: function(scope, elem) {
        var item = scope.vm.item;

        if (item._original && !scope.vm.workhour) {
          var workhourWatcher = scope.$watch(function() {
            return scope.vm.workhour;
          }, function(workhour) {
            if (workhour) {
              setHoursWatcher();
              workhourWatcher();
            }
          }, true);
        } else if (scope.vm.workhour) {
          setHoursWatcher();
        }

        function setHoursWatcher() {
          var wh = scope.vm.workhour;
          item.defaultMinHours = +wh.minHours;
          item.defaultMaxHours = +wh.maxHours;

          var hoursWatcher = scope.$watch(function() {
            return item;
          }, function() {
            item.custom = item.defaultMinHours !== +item.minHours || item.defaultMaxHours !== +item.maxHours;
          }, true);

          elem.on('$destroy', function() {
            hoursWatcher();
          });
        }
      }
    };
  }
})();

/* eslint angular/timeout-service: 0*/
(function() {
  'use strict';
  angular
      .module('estimateMeUi')
      .controller('TasksTableController', TasksTableController);

  /** @ngInject */
  function TasksTableController($mdDialog, $scope, PhaseState) {
    var vm = this;
    if (vm.roleList && !vm.isEditable && !vm.item.role.name) {
      var role = vm.roleList.find(function(role) {
        return role._id === vm.item.role;
      });
      if (role) {
        vm.item.role = role;
      }
    }

    vm.showEditBlock = showEditBlock;
    vm.showInputs = {};
    vm.nameValue = vm.item.name;
    var timerId;
    
    function showEditBlock(e, column) {
      if (vm.isEditable) {
        vm.showInputs[column] = true;
      }
    }

    vm.isDescriptionButtonVisible = function() {
      return vm.item.description === null || vm.item.description === '';
    };

    vm.isUndoButtonShown = function() {
      return vm.item._original && vm.item.custom;
    };

    vm.toggle = function(event, field, column) {
      event.preventDefault();
      event.stopPropagation();
      if (timerId) {
        clearTimeout(timerId);
        timerId = null;
        showEditBlock(event, column);
      } else {
        timerId = setTimeout(function() {
          if (vm.isEditable) {
            vm.item[field] = !vm.item[field];
            vm.saveChange(field);
          }
          timerId = null;
        }, 250);
      }
    };

    vm.toggleDescription = function() {
      vm.descriptionOpen = !vm.descriptionOpen;
    };

    vm.setValueModel = function(value, field) {
      vm.item[field] = value;
    };

    vm.validate = function(event, field) {
      event.stopPropagation();
      setTimeout(function() {
        if (!vm.item[field]) {
          vm.item[field] = field === 'count' ? 1 : 0;
        }
        vm.showInputs[field] = false;
        vm.saveChange(field);
      });
      //PhaseState.compareTaskInCurrentPhase(vm.item, field);
    };

    vm.error = function(field) {
      return !vm.item[field] || vm.item[field] === '0' || +(vm.item.minHours) > +(vm.item.maxHours);
    };

    vm.saveChange = function(field) {
      setTimeout(function() {
        var idFeature;
        if (field === 'name') {
          if (!vm.item[field]) {
            vm.item[field] = vm.nameValue;
            return;
          }
          vm.nameValue = vm.item[field];
        }
        if (vm.parent && vm.parent.type === 'feature') {
          idFeature = vm.parent._id;
        }
        if (field === 'minHours' || field === 'maxHours') {
          if (!vm.item[field]) {
            vm.item[field] = 0;
          }
        }
        if (angular.isString(vm.item[field])) {
          vm.item[field] = vm.item[field].trim();
        }
        PhaseState.compareTaskInCurrentPhase(vm.item, field, idFeature);
      });
    };

  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .directive('tabEditable', tabEditable);

  /** @ngInject */
  function tabEditable() {
    return {
      restrict: 'A',
      scope: {
        tabEditable: '=',
        readyToEdit: '='
      },
      link: tabEditableLink
    };

    function tabEditableLink(scope, element) {
      element.text(scope.tabEditable);

      scope.$watch(function() {
        return scope.readyToEdit;
      }, function(newValue, oldValue) {
        if (newValue !== oldValue) {
          element.text(scope.tabEditable);
        }
      });
      element.on('keyup', function(event) {
        var text = element.text();
        if (text === '') {
          return;
        }
        scope.tabEditable = text;
        event.preventDefault();
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .directive('setFixedWhenAtTop', setFixedWhenAtTop);

  /** @ngInject */
  function setFixedWhenAtTop($document) {
    return {
      restrict: 'A',
      scope: {},
      link: setFixedWhenAtTopLink
    };

    function setFixedWhenAtTopLink($scope, element) {
      var offset = element[0].getBoundingClientRect().top;
      var content = $document[0].getElementById('main-content');
      var div = $document[0].createElement('div');
      var ua = navigator.userAgent;
      div.style.width = '100%';
      div.style.display = 'none';
      element.after(div);
      $scope.$watch(
        function() {
          return element[0].getBoundingClientRect().height;
        },
        function(newHeight) {
          div.style.minHeight = newHeight + 'px';
        }
      );

      if (content.scrollTop !== 0) {
        var widthDiff = $document[0].body.clientWidth - element[0].parentNode.clientWidth;
        element[0].style['padding-right'] = widthDiff + 'px';
        element.addClass('fixed');
      }
      if (offset < 0) {
        offset = ($document[0].getElementsByClassName('navbar-content')[0].clientHeight +
                  $document[0].getElementsByClassName('tabs')[0].clientHeight);
      }

      angular.element(content).bind('scroll', function() {
        if (this.scrollTop >= offset) {
          var widthDiff = $document[0].body.clientWidth - element[0].parentNode.clientWidth;
          element[0].style['padding-right'] = (ua.search(/Safari/) > -1 &&  widthDiff === 0 ? 17 : widthDiff) + 'px';
          element.addClass('fixed');
          div.style.display = 'block';
        } else {
          element[0].style['padding-right'] = '0px';
          div.style.display = 'none';
          element.removeClass('fixed');
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .directive('searchEstimate', searchEstimateDirective);

  /** @ngInject */
  function searchEstimateDirective() {
    return {
      restrict: 'A',
      scope: {
        searchEstimate: '&'
      },
      link: searchEstimate
    };

    function searchEstimate($scope, element) {
      element.on('input change keyup', function() {
        $scope.searchEstimate();
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .directive('pwdInputSync', pwdInputSyncDirective);

  /** @ngInject */
  function pwdInputSyncDirective($timeout) {
    return {
      restrict: 'A',
      link: pwdInputSync
    };

    function pwdInputSync(scope, element) {
      var input = element[0].getElementsByClassName('pwd-container');
      $timeout(function() {
        element.off('change');
      }, 100);
      element.on('change', function() {
        angular.element(input[0]).addClass('md-input-has-value');
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .directive('onFinishRender', onFinishRender);

  function onFinishRender($timeout, $parse) {
    return {
      restrict: 'A',
      link: onFinishRenderLink
    };

    function onFinishRenderLink(scope, element, attrs) {
      if (scope.$last) {
        $timeout(function() {
          if (attrs.onFinishRender) {
            $parse(attrs.onFinishRender)(scope);
          }
        });
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .directive('onBlankCheck', onBlankCheck);

  function onBlankCheck() {
    return {
      restrict: 'A',
      scope: {},
      require: 'ngModel',
      link: onBlankCheckLink
    };

    function onBlankCheckLink($scope, element, attrs, ctrl) {
      var unwatch;

      function validateNotNull() {
        unwatch = $scope.$watch(function() {
          return element[0].value;
        }, function(newValue, oldValue) {
          if (!newValue) {
            ctrl.$setViewValue(oldValue);
            ctrl.$render();
          }
        }, true);
      }

      function killWatch() {
        if (unwatch) {
          unwatch();
        }
      }

      element.on('focus', validateNotNull);
      element.on('blur', killWatch);
    }
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .directive('numberInputInt', numberInputInt);

  /** @ngInject */
  function numberInputInt($window) {
    return {
      restrict: 'A',
      scope: {},
      require: 'ngModel',
      link: numberInputIntValidate
    };

    function numberInputIntValidate($scope, element, attrs, ctrl) {
      var maxlength = +attrs.maxlength ? +attrs.maxlength : 4;

      function inputValidate(input) {
        if (input) {
          var newInput = input.replace(/[^0-9]/g, '');
          switch (+(newInput.charAt(0))) {
            case 0:
              newInput = newInput.substring(0, 1);
              break;
            case 1:
              newInput = newInput.substring(1) > 0 ? newInput.substring(0, maxlength - 1) : newInput;
              break;
            default:
              newInput = newInput.substring(0, maxlength - 1);
          }
          if (newInput !== input) {
            ctrl.$setViewValue(newInput);
            ctrl.$render();
          }
          return newInput;
        }
        return undefined;
      }
      ctrl.$parsers.push(inputValidate);
      element.on('focus', function() {
        if (!$window.getSelection().toString()) {
          this.setSelectionRange(0, this.value.length);
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .directive('numberInput', numberInput);

  /** @ngInject */
  function numberInput($window) {
    return {
      restrict: 'A',
      scope: {},
      require: 'ngModel',
      link: numberInputValidate
    };

    function numberInputValidate($scope, element, attrs, ctrl) {

      function inputValidate(input) {
        if (input) {
          var newInput = input.replace(/[^0-9\.]/g, '');
          var count = (newInput.split('.').length - 1);
          if (/[0-9]{5}/.test(newInput)) {
            newInput = newInput.substring(0, 4) + '.' + newInput.substring(4);
          }
          if (count > 0) {
            var n = count === 2 ? newInput.lastIndexOf('.') : newInput.lastIndexOf('.') + 3;
            newInput = newInput.substring(0, n);
          }
          if (newInput !== input) {
            ctrl.$setViewValue(newInput);
            ctrl.$render();
          }
          return newInput;
        }
        return undefined;
      }
      ctrl.$parsers.push(inputValidate);
      element.on('focus', function() {
        if (!$window.getSelection().toString()) {
          this.setSelectionRange(0, this.value.length);
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
      .directive('newTask', newTask);

  /** @ngInject */
  function newTask() {
    return {
      templateUrl: '/app/components/directives/newTask/newTask.html',
      restrict: 'E',
      scope: {
        item: '=',
        index: '=',
        roleList: '=',
        addFilledItem: '=',
        addCallback: '&',
        tableRow: '=',
        phaseList: '=',
        isEditable: '=',
        locale: '='
      },
      controller: 'NewTaskController',
      controllerAs: 'vm',
      bindToController: true
    };
  }
})();

(function() {
  'use strict';
  angular
      .module('estimateMeUi')
      .controller('NewTaskController', NewTaskController);

  /** @ngInject */
  function NewTaskController(EstimatesApi, $mdDialog) {
    var vm = this;
    vm.associateGroup = function(event) {
      $mdDialog.show({
            targetEvent: event,
            locals: {
              associated: vm.item.associated
            },
            controller: 'AssociateWorkhourModalController',
            controllerAs: 'vm',
            templateUrl: '/app/components/views/associateWorkhour.html',
            clickOutsideToClose: true,
            fullscreen: true
          })
          .then(function(response) {
            if (response) {
              var listPhases = response.listPhases;
              vm.item.associated = listPhases;
            }
          });
    };
    vm.getAssociatedPhases = function() {
      var phasesName = vm.item.associated.map(function(item) {
        var i = vm.phaseList.findIndex(function(phase) {
          return phase._id === item;
        });
        return (i !== -1) ? vm.phaseList[i].name : '';
      });
      return phasesName.join(', ');
    };

    vm.addItem = function() {
      var res = !!vm.item.name || !!vm.item.nameEn;
      if (vm.isEditable) {
        res = res && !!vm.item.role;
      }
      if (res) {
        vm.addFilledItem();
      }
    };
    vm.disabled = function() {
      var res = !vm.item.name || !vm.item.name;
      if (vm.isEditable) {
        res = res || !vm.item.role;
      }
      return res;
    };
    vm.addItemOnEnter = function(e) {
      var isKey = e.code || e.char;
      var keyCode = e.charCode || e.keyCode;
      if (isKey && keyCode === 13) {
        vm.addItem(e);
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .directive('middleClick', middleClick);

  /** @ngInject */
  function middleClick($window) {
    return {
      restrict: 'A',
      link: handleMiddleClickEvent
    };

    function handleMiddleClickEvent($scope, element, attrs) {
      element.on('mousedown', function(e) {
        if (e.which === 2) {
          e.preventDefault();
          e.stopPropagation();
          if (attrs.href) {
            var newWindow = $window.open(attrs.href);
            newWindow.blur();
            newWindow.opener.focus();
          }
        }
      });
    }
  }
})();

/* eslint angular/timeout-service: 0 */
(function() {
'use strict';
  angular.module('estimateMeUi')
    .directive('mdTabsFix', mdTabsFix);

  /** @ngInject */
  function mdTabsFix() {
    return {
      restrict: 'A',
      require: ['mdTabs'],
      link: function($scope, element) {
        var elem = element[0].querySelector('md-pagination-wrapper');

        $scope.$watch(function() {
          return elem.clientWidth;
        }, function(newWidth) {
          var sum = 0;

          element[0].parentNode.style.width = newWidth + 12 + 'px';
          setTimeout(function() {
            var tabs = [].slice.call(elem.querySelectorAll('.md-tab'));
            sum = tabs.reduce(function(sum, el) {
              return sum + angular.element(el)[0].clientWidth;
            }, 0);
            var el = angular.element(elem.querySelector('.md-active'))[0];
            if (el) {
              var offset = el.offsetLeft > sum - elem.parentNode.clientWidth ? sum - elem.parentNode.clientWidth : el.offsetLeft;
              elem.style.transform = 'translate3d(-' + offset + 'px, 0px, 0px)';
            }
          });
        }, true);
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .directive('hideTooltip', hideTooltip);

  /** @ngInject */
  function hideTooltip() {
    return {
      restrict: 'A',
      link: hideTooltipLink
    };

    function hideTooltipLink($scope, element) {
      function hide() {
        element.blur();
      }
      element.on('mouseleave', hide);
    }
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .directive('hideElement', hideElement);

  function hideElement($window, $parse) {
    return {
      restrict: 'A',
      link: hideElementLink
    };

    function hideElementLink(scope, element, attrs) {
      var clickOutHandler = $parse(attrs.hideElement)(scope);

      function clickOut() {
        clickOutHandler(scope);
        scope.$apply();
      }

      function clickIn(event) {
        event.stopPropagation();
      }

      angular.element($window).on('click', clickOut);
      element.on('click', clickIn);

      element.on('$destroy', function() {
        angular.element($window).off('click', clickOut);
        element.off('click', clickIn);
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
      .directive('headTable', headTable);

  /** @ngInject */
  function headTable() {
    return {
      templateUrl: '/app/components/directives/headTable/headTable.html',
      restrict: 'E',
      scope: {
        ref: '=',
        currencies: '=',
        save: '=',
        deleteCurrency: '=',
        addCurrency: '=',
        item: '=',
        changeSorting: '=',
        comparator: '=',
        reverse: '=',
        chooseAll: '=',
        isEditable: '=',
        collapseAll: '=',
        expandAll: '='
      },
      controller: 'headTableController',
      controllerAs: 'vm',
      bindToController: true
    };
  }
})();

/* eslint angular/timeout-service: 0 */
(function() {
  'use strict';
  angular
      .module('estimateMeUi')
      .controller('headTableController', headTableController);

  /** @ngInject */
  function headTableController($timeout, PhaseState) {
    var vm = this;
    var timerId;
    vm.readyToEdit = false;
    vm.activeQa = true;
    vm.activePm = true;
    vm.active = {qa: false, pm: false, bugs: false};
    vm.toggleUseSearch = false;
    vm.collapsed = false;

    $timeout(vm.expandAll);

    vm.showEditBlock = showEditBlock;

    function showEditBlock(e, column) {
      if (vm.isEditable) {
        vm.active[column] = true;
      }
    }

    vm.toggle = function() {
      if (!vm.collapsed) {
        vm.collapseAll();
      } else {
        vm.expandAll();
      }
      vm.collapsed = !vm.collapsed;
    };

    vm.setActive = function(e, phase, nameField, column) {
      e.preventDefault();
      e.stopPropagation();
      if (timerId) {
        clearTimeout(timerId);
        timerId = null;
        showEditBlock(e, column);
      } else {
        timerId = setTimeout(function() {
          if (vm.isEditable) {
            var flag = !phase[nameField];
            phase[nameField] = flag;
            phase.items.forEach(function(element) {
              element[nameField] = flag;
              if (element.type === 'feature') {
                element.tasks.forEach(function(task) {
                  task[nameField] = flag;
                });
              }
            });
            vm.saveChanges(nameField);
          }
          timerId = null;
        }, 250);
      }
    };

    vm.changeTasks = function(phase, nameField) {
      if (!phase[nameField]) {
        phase[nameField] = 0;
      }
      var value = phase[nameField];
      vm.active[nameField] = false;
      phase.items.forEach(function(element) {
        element[nameField] = value;
        if (element.type === 'feature') {
          element.tasks.forEach(function(task) {
            task[nameField] = value;
          });
        }
      });
      vm.saveChanges(nameField);
    };

    vm.useSearch = function() {
      vm.chooseAll(vm.toggleUseSearch);
    };

    vm.saveChanges = function(field) {
      PhaseState.compareQaPmBugsInCurrentPhase(vm.item, field);
    };

  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
      .directive('groupsTable', groupsTable);

  /** @ngInject */
  function groupsTable() {
    return {
      templateUrl: '/app/components/directives/groupsTable/groupsTable.html',
      restrict: 'E',
      scope: {
        item: '=',
        index: '=',
        count: '=',
        collapsed: '=',
        toggle: '&',
        addNewTask: '=',
        deleteFeature: '=',
        phaseList: '=',
        isEditable: '=',
        isCountEditable: '=',
        showPhases: '=',
        canBeDeleted: '=',
        saveFeature: '=',
        saveCount: '=',
        locale: '='
      },
      controller: 'GroupsTableController',
      controllerAs: 'vm',
      bindToController: true
    };
  }
})();

(function() {
  'use strict';
  angular
      .module('estimateMeUi')
      .controller('GroupsTableController', GroupsTableController);

  /** @ngInject */
  function GroupsTableController(EstimatesApi, $mdDialog) {
    var vm = this;
    vm.descriptionOpen = false;
    vm.value = '';
    //vm.sumMin = getSumMin();
    //vm.sumMax = getSumMax();
    //vm.sumCount = getSumCount();
    vm.associateGroup = function(event) {
      if (vm.isEditable) {
        $mdDialog.show({
            targetEvent: event,
            locals: {
              associated: vm.item.associated
            },
            controller: 'AssociateWorkhourModalController',
            controllerAs: 'vm',
            templateUrl: '/app/components/views/associateWorkhour.html',
            clickOutsideToClose: true,
            fullscreen: true
          })
          .then(function(response) {
            var listPhases = {};
            if (response) {
              listPhases.associated = response.listPhases;
              EstimatesApi.associateGroups(vm.item._id, listPhases).then(function(res) {
                vm.item.associated = res;
              });
            }
          });
      }
    };
    vm.getAssociatedPhases = function() {
      var phasesName = vm.item.associated.map(function(item) {
        var i = vm.phaseList.findIndex(function(phase) {
          return phase._id === item;
        });
        return (i !== -1) ? vm.phaseList[i].name : '';
      });
      return phasesName.join(', ');
    };

    vm.getSumRole = function() {
      var rolesId = [];
      var rolesName = [];

      vm.item.workhours.forEach(function(item) {
        var i = (item.link.role) ? rolesId.indexOf(item.link.role._id) : 0;
        if (i === -1) {
          rolesId.push(item.link.role._id);
          rolesName.push(item.link.role.name);
        }
      });
      return rolesName.join(', ');
    };
    vm.show = function() {
      if (!vm.isEditable) {
        return vm.descriptionOpen && !!vm.item.description;
      }else {
        return vm.descriptionOpen;
      }
    };
    vm.toggleDescription = function() {
      vm.descriptionOpen = !vm.descriptionOpen;
    };

    vm.setValue = function(field) {
      vm.value = vm.item[field];
    };

    vm.compare = function(field) {
      if (vm.item[field] === '' && field === 'name') {
        vm.item[field] = vm.value;
      }
      vm.item[field] = vm.item[field].replace ? vm.item[field].replace(/^\s+/, '').replace(/\s+$/, '') : vm.item[field];
      if (vm.value === vm.item[field]) {return;}
      var feature = {};
      feature._id = vm.item._id;
      feature[field] = vm.item[field];
      vm.saveFeature(feature);
    };

    vm.setValueCount = function() {
      vm.value = vm.count;
    };

    vm.validate = function(event) {
      event.stopPropagation();
      if (!vm.count) {
        vm.count = 1;
      }
      if (vm.count != vm.value) {
        var item = {
          count: vm.count,
          itemId: vm.item._id
        };
        vm.saveCount(item);
      }
    };

    vm.getSumMin = function() {
      var count = vm.count ? vm.count : 1;
      var result = vm.item.workhours.reduce(function(sum, item) {
        return sum + (item.count ? +item.link.minHours * +item.count : +item.link.minHours);
      }, 0);
      result *= count;
      return result;
    }

    vm.getSumMax = function() {
      var count = vm.count ? vm.count : 1;
      var result = vm.item.workhours.reduce(function(sum, item) {
        return sum + (item.count ? +item.link.maxHours * +item.count : +item.link.maxHours);
      }, 0);
      result *= count;
      return result;
    }

    vm.getSumCount = function() {
      var result = vm.item.workhours.reduce(function(sum, item) {
        var count = item.count || 1;
        return sum + (+count);
      }, 0);
      return result;
    };
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
      .directive('featuresTable', featuresTable);

  /** @ngInject */
  function featuresTable() {
    return {
      templateUrl: '/app/components/directives/featuresTable/featuresTable.html',
      restrict: 'E',
      scope: {
        item: '=',
        deleteFeature: '=',
        collapsed: '=',
        toggle: '&',
        copy: '=',
        tasksDictionaty: '=',
        saveEstimate: '=',
        phaseItem: '=',
        roleList: '=',
        isEditable: '=',
        featureStatistic: '=',
        getTemplateTask: '='
      },
      controller: 'FeaturesTableController',
      controllerAs: 'vm',
      bindToController: true
    };
  }
})();

/* eslint angular/timeout-service: 0 */
(function() {
  'use strict';
  angular
      .module('estimateMeUi')
      .controller('FeaturesTableController', FeaturesTableController);

  /** @ngInject */
  function FeaturesTableController(EstimatesApi, $rootScope, PhaseState) {
    var vm = this;
    vm.inputVisible = false;
    vm.showEditBlock = showEditBlock;
    vm.showInputs = {};
    vm.nameValue = vm.item.name;
    var timerId;
    function showEditBlock(e, column) {
      if (vm.isEditable) {
        vm.showInputs[column] = true;
      }
    }

    vm.setActive = function(e, feature, nameField, column) {
      e.preventDefault();
      e.stopPropagation();
      if (timerId) {
        clearTimeout(timerId);
        timerId = null;
        showEditBlock(e, column);
      } else {
        timerId = setTimeout(function() {
          if (vm.isEditable) {
            var flag = !feature[nameField];
            feature[nameField] = flag;
            feature.tasks.forEach(function(task) {
              task[nameField] = flag;
            });
            vm.saveChange(nameField);
          }
          timerId = null;
        }, 250);
      }
    };

    vm.setValueModel = function(value, field) {
      vm.item[field] = value;
    };

    vm.changeTasks = function(feature, nameField) {
      setTimeout(function(){
        if (!feature[nameField]) {
          feature[nameField] = 0;
        }
        var value = feature[nameField];
        feature.tasks.forEach(function(task) {
          task[nameField] = value;
        });
        vm.showInputs[nameField] = false;
        vm.saveChange(nameField);
      });
    };

    vm.getSumRole = function() {
      var res = '';
      if (vm.featureStatistic && vm.featureStatistic.reduced) {
        var rolesArray = vm.featureStatistic.reduced
          .filter(function (item) {
            return item.role;
          })
          .map(function(item) {
            return item.role.name;
          });
        res = rolesArray.join(', ');
      }
      return res;
    };

    vm.showTaskInput = function(e) {
      if (!vm.inputVisible) {
        if (angular.isDefined(e)) {
          e.stopPropagation();
        }
        vm.inputVisible = true;
      }
    };

    vm.hideTaskInput = function(e) {
      if (vm.inputVisible) {
        if (angular.isDefined(e)) {
          e.stopPropagation();
        }
        vm.inputVisible = false;
      }
    };

    vm.newExistingItem = function(item, phase) {
      EstimatesApi.addTasks(phase, {
        templateIds: [{id: item._id, feature: vm.item._id}]
      }).then(function(response) {
        [].push.apply(vm.item.tasks, response);
        vm.getTemplateTask(response[0]);
        PhaseState.updatePhaseState('add', response[0], vm.item._id);
      });
    };

    vm.newCustomItem = function(text, phase) {
      var role = vm.item.tasks.length > 0 ? angular.copy(vm.item.tasks[0].role) : vm.roleList[0];
      EstimatesApi.addTasks(phase, {
        customNames: [{name: text, role: role, feature: vm.item._id}]
      }).then(function(response) {
        [].push.apply(vm.item.tasks, response);
        PhaseState.updatePhaseState('add', response[0], vm.item._id);
      });
    };

    vm.saveChange = function(field) {
      if (field === 'name') {
        if (!vm.item[field]) {
          vm.item[field] = vm.nameValue;
          return;
        }
        vm.nameValue = vm.item[field];
      }
      if (vm.item[field] && vm.item[field].replace) {
        vm.item[field] = vm.item[field].replace(/^\s+/, '').replace(/\s+$/, '');
      }
      PhaseState.compareFeatureInCurrentPhase(vm.item, field);
    };

    vm.toggleDescription = function() {
      vm.descriptionOpen = !vm.descriptionOpen;
    };

  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .directive('elementBindText', elementBindText);

  /** @ngInject */
  function elementBindText() {
    return {
      restrict: 'A',
      scope: {
        elementBindText: '&',
        elementBindEmpty: '=',
        itemName: '=',
        saveChange: '&'
      },
      link: elementBindTextLink
    };

    function elementBindTextLink($scope, element, attrs) {

      var needCut = !!attrs.maxTitle;
      var maxLength = +attrs.maxTitle || 70;

      if (needCut && $scope.itemName.length > maxLength) {
        cutValue();
      }

      element.on('focus', function () {
        if (needCut) {
          setValue();
        }
      });

      element.on('blur', function() {
        $scope.saveChange();

        if (!element[0].value && $scope.itemName) {
          setValue();
        }
        if (needCut && element[0].value.length > maxLength) {
          cutValue();
          resize();
        }
      });

      element.on('input', function(event) {
        resize();
        if (angular.isUndefined($scope.elementBindEmpty) && event.target.value === '') {
          return;
        }
        $scope.elementBindText({valueField: event.target.value});
      });

      function setValue() {
        element[0].value = $scope.itemName;
        if (needCut) {
          element[0].value.replace(/\n/g, ' ');
        }
        element.triggerHandler('input');
      }

      function cutValue() {
        element[0].value = $scope.itemName.slice(0, maxLength).replace(/\n/g, ' ') + '...';
      }

      function resize() {
        element.css('height', '25px');
        var height = +element[0].scrollHeight + 1;
        element[0].style.height = '' + height + 'px';
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .directive('elementBindDecimal', elementBindDecimal);

  /** @ngInject */
  function elementBindDecimal() {
    return {
      restrict: 'A',
      scope: {
        elementBindDecimal: '&',
        whValue: '='
      },
      link: elementBindDecimalLink
    };

    function elementBindDecimalLink(scope, element) {

      scope.$watch(function () {
          return scope.whValue;
        }, function() {
          element[0].value = scope.whValue;
          element.triggerHandler('input');
      });

      element.on('input', function(event) {
        var input = event.target.value;
        if (input) {
          var newInput = input.replace(/[^0-9\.]/g, '');
          var count = (newInput.split('.').length - 1);
          if (/[0-9]{5}/.test(newInput)) {
            newInput = newInput.substring(0, 4) + '.' + newInput.substring(4);
          }
          if (count > 0) {
            var n = count === 2 ? newInput.lastIndexOf('.') : newInput.lastIndexOf('.') + 3;
            newInput = newInput.substring(0, n);
          }
          if (newInput !== input) {
            element[0].value = newInput;
          }
          scope.elementBindDecimal({valueField: newInput});
        } else {
          scope.elementBindDecimal({valueField: ''});
        }

      });

      element.on('focus', function() {
        var vm = this;
        vm.select();
      })
    }
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .directive('elementBind', elementBind);

  /** @ngInject */
  function elementBind() {
    return {
      restrict: 'A',
      scope: {
        elementBind: '&'
      },
      link: elementBindLink
    };

    function elementBindLink(scope, element, attrs) {
      var maxlength = +attrs.maxlength ? +attrs.maxlength : 4;

      element.on('input', function(event) {
        var input = event.target.value;
        if (input) {
          var newInput = input.replace(/[^0-9]/g, '');
          switch (+(newInput.charAt(0))) {
            case 0:
              newInput = newInput.substring(0, 1);
              break;
            case 1:
              newInput = newInput.substring(1) > 0 ? newInput.substring(0, maxlength - 1) : newInput;
              break;
            default:
              newInput = newInput.substring(0, maxlength - 1);
          }
          if (newInput !== input) {
            element[0].value = newInput;
          }
          scope.elementBind({valueField: newInput});
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
      .directive('copyright', copyright);

  /** @ngInject */
  function copyright() {
    return {
      templateUrl: '/app/components/directives/copyright/copyright.html',
      restrict: 'E',
      replace: true,
      scope: true,
      controller: 'CopyrightController',
      controllerAs: 'vm'
    };
  }
})();

(function() {
  'use strict';
  angular
      .module('estimateMeUi')
      .controller('CopyrightController', CopyrightController);

  /** @ngInject */
  function CopyrightController() {
    var vm = this;
    
    vm.currentYear = new Date().getFullYear();
  }
})();

/* eslint angular/timeout-service: 0 */
(function() {
  'use strict';

  angular.module('estimateMeUi')
    .directive('calcWidthFooter', calcWidthFooter);

  /** @ngInject */
  function calcWidthFooter($document) {
    return {
      restrict: 'A',
      scope: {},
      link: calcWidthFooterLink
    };

    function calcWidthFooterLink($scope, element) {
      var height = 0;
      $scope.$watch(function() {
        height = element[0].offsetHeight;
        return height;
      }, setMarginBottom, true);

      function setMarginBottom() {
        setTimeout(function() {
          if ($document[0].getElementById('margin-bottom')) {
            $document[0].getElementById('margin-bottom').style.marginBottom = height + 10 + 'px';
          }
        }, 100);
      }

    }
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
      .directive('bodyTable', bodyTable);

  /** @ngInject */
  function bodyTable() {
    return {
      templateUrl: '/app/components/directives/bodyTable/bodyTable.html',
      restrict: 'E',
      scope: {
        item: '=',
        ref: '=',
        index: '=',
        currencies: '=',
        saveRole: '=',
        add: '=',
        delete: '=',
        addCallback: '&',
        canBeDeleted: '=',
        editable: '=',
        locale: '='
      },
      controller: 'BodyTableController',
      controllerAs: 'vm',
      bindToController: true
    };
  }
})();

(function() {
  'use strict';
  angular
      .module('estimateMeUi')
      .controller('BodyTableController', BodyTableController);

  /** @ngInject */
  function BodyTableController(EstimatesApi, $mdDialog, statisticComposer, $scope) {
    var vm = this;
    vm.showEditBlock = showEditBlock;
    vm.getIdCurrency = getIdCurrency;

    vm.setNewTaskFormUntouched = function() {
      $scope.nameForm.$setUntouched();
    };

    vm.addCallback({callback: vm.setNewTaskFormUntouched});

    vm.clickDown = function(e) {
      if (e.target.parentNode.parentNode.classList.contains('edit')) {
        e.stopPropagation();
      }
    };

    vm.addTask = function($event) {
      if ($event.charCode === 13) {
        if (angular.isFunction(vm.addFilledTask)) {
          vm.addFilledTask({event: $event, task: vm.item});
        }
      }
    };

    vm.blurInput = function($event) {
      if ($event.charCode === 13) {
        ($event.target || $event.srcElement).blur();
      }
    };

    function showEditBlock(e) {
      if (!vm.notEditable) {
        var el = angular.element(e.currentTarget);
        e.stopPropagation();
        el.addClass('edit-active');
        var input = el.find('input');
        input.focus();
      }
    }

    vm.setValue = function(field) {
      vm.value = field;
    };

    vm.compareRole = function(field) {
      switch (field) {
        case 'name':
        case 'nameEn':
          if (vm.item[field] === '') {
            vm.item[field] = vm.value;
            return;
          }
          if (vm.value === vm.item[field]) {
            return;
          }
          break;
        default:
          if (!vm.item.dict || !vm.item.dict[field] || vm.item.dict[field].value === vm.value) {
            return;
          }
          break;
      }
      if (vm.item._id) {
        vm.saveRole(vm.item, field);
      }
    };

    vm.isEditBlockActive = function(inputModel) {
      return !inputModel && !vm.notEditable;
    };

    function getIdCurrency(role, id) {
      return role.costs.findIndex(function(cost) { return cost.currency == id;});
    }

    vm.isDescriptionButtonVisible = function() {
      return (vm.item.description === null || vm.item.description === '') && vm.showActionButtons;
    };

    vm.isDescriptionVisible =  function() {
      return (vm.item.description !== null && vm.item.description !== '') || $scope.toggle || !vm.showActionButtons;
    };

    vm.isUndoButtonShown = function() {
      return vm.item._original && vm.item.custom;
    };

    vm.isQaPm = function(nameRole) {
      return nameRole === 'qa' || nameRole === 'pm';
    };
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .directive('autosizeTextarea', autosizeTextarea);

  /** @ngInject */
  function autosizeTextarea() {
    return {
      restrict: 'A',
      link: autosizeTextareaHeight
    };

    function autosizeTextareaHeight($scope, element) {
      var resize = function() {
        element[0].style.height = '' + element[0].scrollHeight + 'px';
      };
      var unwatch = $scope.$watch(
        function() { return element[0].scrollHeight; },
        function(newValue) {
          if (newValue) {
            unwatch();
            resize();
          }
        }
      );
    }
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .directive('autofocusInput', autofocusInput);

  /** @ngInject */
  function autofocusInput($window, $timeout) {
    return {
      restrict: 'A',
      link: setInputFocus
    };

    function setInputFocus($scope, element, attrs) {
      $timeout(function() {
        element[0].focus();
      });
      element.on('focus', function() {
        if (!$window.getSelection().toString() && attrs.autofocusInput === 'true') {
          this.setSelectionRange(0, this.value.length);
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .directive('addTitleAttr', addTitleAttr);

  /** @ngInject */
  function addTitleAttr() {
    return {
      restrict: 'A',
      link: addTitleLinkFunc
    };

    function addTitleLinkFunc($scope, element, attrs) {
      var unwatch = $scope.$watch(function () {
        return attrs.addTitleAttr;
      }, function (newTitle) {
        if (!attrs.title && newTitle && (newTitle.length < +attrs.maxTitle)) {
          element.removeAttr('title');
        } else {
          element.attr("title", attrs.addTitleAttr);
        }
      });

      $scope.$on('$destroy', function() {
        unwatch();
      });
    }
  }
})();
(function() {
  'use strict';

  angular.module('estimateMeUi')
      .directive('actionBar', actionBar);

  /** @ngInject */
  function actionBar() {
    return {
      templateUrl: '/app/components/directives/actionBar/actionBar.html',
      restrict: 'E',
      scope: {
        actions: '=',
        undo: '&',
        save: '=',
        addNewTask: '&',
        addNewFeature: '&',
        addNewRole: '&',
        addNewCurrency: '&',
        editEstimate: '='
      },
      controller: 'ActionBarController',
      controllerAs: 'vm',
      bindToController: true
    };
  }
})();

(function() {
  'use strict';
  angular
      .module('estimateMeUi')
      .controller('ActionBarController', ActionBarController);

  /** @ngInject */
  function ActionBarController() {
  }
})();

(function() {
  'use strict';

  angular
      .module('estimateMeUi')
      .controller('TemplateHeaderController', TemplateHeaderController);
  /** @ngInject */
  function TemplateHeaderController(tags, $state, BreadCrumbs, $scope, header, $stateParams, $rootScope) {

    var vm = this;
    var deleteCrumb = BreadCrumbs.addCrumbs(header);
    var phaseId = $state.params.phaseId;
    var stateName = $stateParams.link;
    vm.selected = -1;
    vm.message = false;
    vm.phases = tags;

    var disableStateChangeListen = $rootScope.$on('$stateChangeSuccess', function(event, toState) {
      if (['index.groups', 'index.workhours'].includes(toState.name)) {
        if (vm.phases && vm.phases.length > 0 && !$state.params.phaseId) {
          vm.selected = 0;
          $state.go(stateName, {phaseId: vm.phases[0]._id});
        }
      }
    });

    if (vm.phases && vm.phases.length > 0) {
      if (phaseId) {
        vm.selected = vm.phases.findIndex(function(phase) {
          return phase._id ===  phaseId;
        });
      } else {
        vm.selected = 0;
      }
    } else {
      vm.message = true;
    }

    vm.onPhaseSelected = function(phase) {
      if (phase !== phaseId) {
        $state.go(stateName, {phaseId: phase});
      } else {
        phaseId = false;
      }
    };

    $scope.$on('$destroy', function() {
      deleteCrumb();
      disableStateChangeListen();
    });
  }
})();

(function() {
  'use strict';

  angular
      .module('estimateMeUi')
      .controller('TaskTemplateEditController', TaskTemplateEditController);
  /** @ngInject */
  function TaskTemplateEditController($scope, EstimatesApi, $mdDialog, $stateParams, $document, $q,
      $timeout, header, $controller, $state, Access, tags) {

    var vm = this;
    var phaseId = $stateParams.phaseId;
    vm.showTable = false;
    vm.preloader = true;

    vm.roleList = [];
    vm.canCreate = Access.checkActionPermission({
      action: 'create',
      entity: 'workhour'
    });
    vm.canDelete = Access.checkActionPermission({
      action: 'delete',
      entity: 'workhour'
    });
    vm.canEdit = Access.checkActionPermission({
      action: 'update',
      entity: 'workhour'
    });
    vm.locale = 'ru';

    EstimatesApi.getDictionaryRoles()
    .then(function(response) {
      vm.roleList = response.roles;
    });

    vm.newTask =  {
      name: '',
      role: {},
      maxHours: 0,
      minHours: 0,
      associated: [phaseId]
    };

    vm.task = {};
    vm.task.items = [];

    vm.tableRow = {
      name: 30,
      phases: 20
    };

    vm.phases = tags;
    if (phaseId) {
      getWorkhoursList(phaseId);
    }

    vm.finishRender = function() {
      vm.showTable = true;
    };

    vm.saveWorkhour = function(workhour) {
      EstimatesApi.updateDictionaryWorkhourById(workhour);
    };

    vm.deleteWorkhour = function(workhourIndex, parent, event) {
      var workhour = vm.task.items[workhourIndex];
      var el = angular.element(event.currentTarget);
      el.blur();
      if (angular.isObject(workhour)) {
        $mdDialog.show(
          $mdDialog.confirm()
            .title('Внимание!')
            .content('Вы действительно хотите удалить нормочас?')
            .targetEvent(event)
            .ok('ОК')
            .cancel('Отмена')
          ).then(function() {
            EstimatesApi.deleteDictionaryWorkhour(workhour._id).then(function() {
              vm.task.items.splice(workhourIndex, 1);
            });
          });
      }
    };

    function getWorkhoursList(id) {
      EstimatesApi.getWorkhoursAssociatedWithTag(id)
        .then(function(response) {
          vm.task.items = response || [];
          var itemRoleList = vm.roleList[0];
          if (vm.task.items.length > 0) {
            var len = vm.task.items.length - 1;
            var lastItem = vm.task.items[len];
            if (lastItem.role) {
              lastItem = lastItem.role._id || lastItem.role;
              itemRoleList = vm.roleList.find(function(elem) {
                return elem._id === lastItem;
              });
            }
          } else {
            vm.showTable = true;
          }
          vm.newTask.role = itemRoleList;
          vm.preloader = false;
        });
    }

    vm.addCallbackOnNewTaskCreation = function(callback) {
      vm.setNewTaskFormUntouched = callback;
    };

    vm.addNewTask = function() {
      EstimatesApi.addDictionaryWorkhours(vm.newTask)
        .then(function(response) {
          if (angular.isObject(response[0])) {
            var i = vm.newTask.associated.findIndex(function(id) {
              return id === phaseId;
            });
            if (i !== -1) {
              angular.copy(response[0], vm.newTask);
              vm.task.items.push(vm.newTask);
            }
            var itemRoleList = vm.roleList[0];
            if (vm.task.items.length > 0) {
              var len = vm.task.items.length - 1;
              var lastItem = vm.task.items[len].role._id || vm.task.items[len].role;
              itemRoleList = vm.roleList.find(function(elem) {
                return elem._id === lastItem;
              });
            }
            vm.newTask =  {
              name: '',
              role: itemRoleList,
              maxHours: 0,
              minHours: 0,
              associated: [phaseId]
            };
            if (angular.isFunction(vm.setNewTaskFormUntouched)) {
              vm.setNewTaskFormUntouched();
            }
          }
        });
    };

    vm.changeRoleNewTask = function(e, roleid) {
      var itemRoleList = vm.roleList[0];
      itemRoleList = vm.roleList.find(function(elem) {
        return elem._id === roleid;
      });
      vm.newTask.role = itemRoleList;
    };

    vm.chooseAll = function(argument) {
      if (vm.task.items.length > 1) {
        var items = [];
        for (var i = 0, len = vm.task.items.length; i < len; i++) {
          vm.task.items[i].useSearch = argument;
          items[i] = {};
          items[i].useSearch = argument;
          items[i]._id = vm.task.items[i]._id;
        }
        EstimatesApi.updateDictionaryWorkhours(items).then(function() {
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('estimateMeUi')
    .controller('RoleTemplateEditController', RoleTemplateEditController);

  /** @ngInject */
  function RoleTemplateEditController(
    $scope,
    EstimatesApi,
    $mdDialog,
    $stateParams,
    $document,
    $q,
    $timeout,
    header,
    $controller,
    BreadCrumbs,
    Access
  ) 
  {
    var vm = this;
    var deleteCrumb = BreadCrumbs.addCrumbs(header);
    $scope.$on('$destroy', function() {
      deleteCrumb();
    });
    vm.roles = [];
    vm.locale = 'ru'; // Russian locale by default
    vm.roles.content = [];
    vm.currencies = [];
    vm.newrole = {};
    vm.readyToEdit = false;
    vm.preloader = true;
    vm.access = {
      'role': {
        'create': true,
        'delete': true,
        'update': true
      },
      'currency': {
        'create': true,
        'delete': true,
        'update': true
      }
    };
    for (var entity in vm.access) {
      for (var action in vm.access[entity]) {
        vm.access[entity][action] = Access.checkActionPermission({
          action: action,
          entity: entity
        });
      }
    }

    var sortAsc = 'asc';
    var sortDesc = 'desc';
    vm.sorting = {name: sortAsc};
    vm.changeSorting = changeSorting;

    EstimatesApi.getDictionaryRoles()
        .then(function(response) {
          vm.roles = response.roles || [];
          vm.currencies = response.currency || [];
          vm.roles.forEach(function(role) {
            role.dict = getDict(role.costs, 'currency');
          });
          vm.preloader = false;
        });

    function getArr(dict) {
      var arr = [];
      for (var p in dict) {
        dict[p].currency = p;
        arr.push(dict[p]);
      }
      return arr;
    }

    function getDict(arr, name) {
      var dict = {};
      arr.forEach(function(element) {
        dict[element[name]] = element;
      });
      return dict;
    }

    vm.openEditCurrencies = function() {
      vm.readyToEdit = true;
    };

    vm.addNewRole = function() {
      vm.currencies.forEach(function(element) {
        if (!vm.newrole.dict) {vm.newrole.dict = {};}
        if (!vm.newrole.dict[element._id]) {
          vm.newrole.dict[element._id] = {};
          vm.newrole.dict[element._id].value =  null;
        }
      });
      vm.newrole.costs = getArr(vm.newrole.dict);
      EstimatesApi.addDictionaryRoles(vm.newrole).then(function(res) {
        res.dict = getDict(res.costs, 'currency');
        vm.roles.push(res);
        vm.newrole = {};
      });
    };

    vm.addNewCurrency = function() {
      vm.readyToEdit = true;
      vm.currencies.push({name: 'Валюта'});
    };

    vm.saveCurrencies = function() {
      vm.readyToEdit = false;
      var ready = true;
      vm.currencies.forEach(function(cur) {
        if (!cur._id) {
          ready = false;
          EstimatesApi.addDictionaryCurrencies([cur]).then(function(res) {
            vm.currencies.pop();
            vm.currencies.push(res[0]);
            ready = true;
          });
        }
      });
      if (ready) {
        EstimatesApi.saveDictionaryCurrencies(vm.currencies).then(function() {
        });
      }
    };

    vm.saveRoles = function() {
      vm.roles.forEach(function(role) {
        role.costs = getArr(role.dict);
      });
      EstimatesApi.updateRoles(vm.roles.map(function(role) {
        role.costs.forEach(function(cost) {
          if (cost.value !== null) {
            cost.value = +cost.value;
          }
        });
        return role;
      }));
    };

    vm.saveRole = function(role, field) {
      var changeRole = {
        _id: role._id
      };
      if (field === 'name') {
        changeRole.name = role.name;
      } else if (field === 'nameEn') {
        changeRole.nameEn = role.nameEn;
      } else {
        changeRole.costs = getArr(role.dict);
      }
      EstimatesApi.updateRoles([changeRole]);
    };

    vm.deleteCurrency = function(event, currencyIndex) {
      var currency = vm.currencies[currencyIndex];
      var el = angular.element(event.currentTarget);
      el.blur();
      if (angular.isObject(currency)) {
        $mdDialog.show(
          $mdDialog.confirm()
            .title('Внимание!')
            .content('Вы действительно хотите удалить валюту?')
            .targetEvent(event)
            .ok('ОК')
            .cancel('Отмена')
          ).then(function() {
            if (currency._id) {
              EstimatesApi.deleteDictionaryCurrencies(currency._id).then(function() {
                vm.currencies.splice(currencyIndex, 1);
              });
            }else {
              vm.currencies.pop();
            }

          });
      }
    };

    vm.deleteRole = function(event, roleIndex) {
      var role = vm.roles[roleIndex];
      var el = angular.element(event.currentTarget);
      el.blur();
      if (angular.isObject(role)) {
        $mdDialog.show(
          $mdDialog.confirm()
            .title('Внимание!')
            .content('Вы действительно хотите удалить роль?')
            .targetEvent(event)
            .ok('ОК')
            .cancel('Отмена')
          ).then(function() {
          EstimatesApi.deleteDictionaryRole(role._id)
            .then(function() {
              vm.roles.splice(roleIndex, 1);
            });
        });
      }
    };

    function changeSorting(column) {
      var sort = vm.sorting[column];
      vm.sorting[column] = (!sort || sort === 'desc') ? sortAsc : sortDesc;
      vm.columnActiveSorting = column;

      if (sort === 'asc') {
        vm.reverse = false;
      }else {
        vm.reverse = true;
      }

      switch (column) {
        case 'name':
          vm.predicate = column;
          break;
      }

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('estimateMeUi')
    .controller('RemoveAccauntStateController', RemoveAccauntStateController);

  /** @ngInject */
  function RemoveAccauntStateController(Auth, PreviousState, EstimatesApi, $mdDialog, $localStorage, $http, $state) {
    if (Auth.isAuth()) {
      $mdDialog.show(
          $mdDialog.confirm()
            .title('Внимание! Удаление аккаунта!')
            .content('Все связанные с аккаунтом данные будут потеряны! Вы действительно хотите удалить свой аккаунт?')
            .targetEvent(null)
            .ok('ОК')
            .cancel('Отмена')
          ).then(function() {
            EstimatesApi.removeAccaunt()
              .then(function () {
                delete $localStorage.userToken;
                delete $http.defaults.headers.common.Authorization;
                $state.go('login');
              });
          })
          .catch(function () {
            $state.go(PreviousState.Name, PreviousState.Params);
          });
    }
  }
})();
(function() {
  'use strict';

  angular
      .module('estimateMeUi')
      .controller('PhaseTemplatesController', PhaseTemplatesController);
  /** @ngInject */
  function PhaseTemplatesController($rootScope, $scope, EstimatesApi, $mdDialog, header, BreadCrumbs, Access, tags, $state, $window, $q) {
    var vm = this;
    var deleteCrumb = BreadCrumbs.addCrumbs(header);
    $scope.$on('$destroy', function() {
      deleteCrumb();
      disableStateChangeListen();
    });
    vm.selectedIndex = -1;
    vm.locale = $window.sessionStorage.getItem('locale') || 'ru';

    vm.phases = tags;
    countStatistics();

    $scope.$watchCollection(function () {
      return vm.phases;
    }, function() {
      countStatistics();
    });

    if ($state.is('index.tags.edit')) {
      vm.phaseOpened = true;
    } else {
      vm.phaseOpened = false;
    }
    var disableStateChangeListen = $rootScope.$on('$stateChangeSuccess', function(event, toState) {
      if (toState.name === 'index.tags.edit') {
        vm.phaseOpened = true;
      } else {
        vm.phaseOpened = false;
      }
      vm.locale = $window.sessionStorage.getItem('locale') || 'ru';
    });
    vm.displayPhaseList = Access.checkActionPermission(
      {
        entity: 'tag',
        action: 'view'
      }
    );
    vm.canCreate = Access.checkActionPermission(
      {
        entity: 'tag',
        action: 'create'
      }
    );
    vm.canDelete = Access.checkActionPermission(
      {
        entity: 'tag',
        action: 'delete'
      }
    );
    vm.canEdit = Access.checkActionPermission(
      {
        entity: 'tag',
        action: 'update'
      }
    );
    vm.addNewPhaseOnEnter = addNewPhaseOnEnter;
    vm.addNewPhase = addNewPhase;
    vm.newPhaseName = '';
    vm.deletePhase = deletePhase;
    vm.savePhaseName = savePhaseName;
    vm.reverse = false;
    vm.comparator = '';
    vm.onPhaseSelected = function(phase) {
      $state.go('index.tags.edit', {phaseId: phase._id});
    };
    vm.selectPhaseIndex = function(phaseId) {
      var i = vm.phases.findIndex(function(phase) {
        return phase._id === phaseId;
      });
      if (i !== -1) {
        vm.selectedIndex = i;
        $state.go('index.tags.edit', {phaseId: phaseId});
      }
    };
    if ($state.params.phaseId) {
      vm.selectPhaseIndex($state.params.phaseId);
    }
    vm.savePhaseNameOnEnter = function(e, phase) {
      var isKey = e.code || e.char;
      var keyCode = e.charCode || e.keyCode;
      if (isKey && keyCode === 13) {
        savePhaseName(phase);
      }
    };

    vm.changeSorting = function(comparator) {
      var r = vm.reverse;
      vm.reverse = !(!vm.comparator || r);
      vm.comparator = (!vm.comparator || !r) ? comparator : '';
    };

    vm.getLocalePhaseName = function(phase) {
      return (vm.locale === 'ru') ? phase.name : phase.nameEn;
    };

    function countStatistics() {
      vm.roles = [];
      vm.countWorkhours = [];
      vm.countFeatures = [];
      vm.phases.forEach(function(phase) {
        vm.roles[phase._id] = '';
        vm.countWorkhours[phase._id] = 0;
        vm.countFeatures[phase._id] = 0;
        phase.reduced.forEach(function(element, i, array) {
          if (element.role) {
            if (element.role._id !== -12 && element.role._id !== -23) {
              vm.roles[phase._id] += element.role.name + ', ';
            }
          }
          if (i === array.length - 1 && vm.roles[phase._id] !== '') {
            vm.roles[phase._id] = vm.roles[phase._id].slice(0, -2);
          }
        });
        phase.items.forEach(function(item) {
          if (item.type && item.type === 'feature') {
            ++vm.countFeatures[phase._id];
            vm.countWorkhours[phase._id] += item.link.workhours.length;
          } else {
            ++vm.countWorkhours[phase._id];
          }
        });
      });
    }

    function deletePhase(event, phase) {
      var el = angular.element(event.currentTarget);
      el.blur();
      $q.all([
        EstimatesApi.getWorkhoursAssociatedWithTag(phase),
        EstimatesApi.getGroupsAssociatedWithTag(phase)
      ]).then(function(entities) {
        var message = 'В данной фазе есть нормочасы, которые привязаны только к этой фазе. Удалив фазу произойдет удаление нормочасов';

        entities = entities[0].concat(entities[1]);

        var index = entities.findIndex(function(entity) {
          return entity.associated.length === 1;
        });
        if (index < 0) {
          message = 'Вы действительно хотите удалить фазу?';
        }
        $mdDialog.show(
          $mdDialog.confirm()
            .title('Внимание!')
            .content(message)
            .targetEvent(event)
            .ok('ОК')
            .cancel('Отмена')
        ).then(function() {
          EstimatesApi.deleteTag(phase)
            .then(function() {
              var i = vm.phases.findIndex(function(item) {
                return phase._id === item._id;
              });
              if (i > -1) {
                vm.phases.splice(i, 1);
              }
            });
        });
      });
    }

    function addNewPhaseOnEnter(e) {
      var isKey = e.code || e.char;
      var keyCode = e.charCode || e.keyCode;
      if (isKey && keyCode === 13) {
        addNewPhase(e);
      }
    }

    function addNewPhase() {
      if (vm.newPhaseName) {
        var bufferPhases = [vm.newPhaseName];
        EstimatesApi.addDictionaryTags(bufferPhases).then(function(res) {
          [].push.apply(vm.phases, res);
          vm.newPhaseName = '';
        });
      }
    }

    function savePhaseName(phase) {
      if (phase.editMode) {
        var data = {
          _id: phase._id
        };
        if (vm.locale === 'ru') {
          data.name = phase.name;
        } else {
          data.nameEn = phase.nameEn;
        }
        EstimatesApi.updateTag(data);
      }
      phase.editMode = !phase.editMode;
    }

    /*vm.updateLocale = function() {
      $window.sessionStorage.setItem('locale', vm.locale);
    };*/

  }
})();

(function() {
  'use strict';

  angular
      .module('estimateMeUi')
      .controller('PhaseTemplateEditController', PhaseTemplateEditController);
  /** @ngInject */
  function PhaseTemplateEditController($scope, EstimatesApi, $mdDialog, $stateParams, $document, $q,
      $timeout, $controller, BreadCrumbs, Mediator, statisticComposer, $state, Access, NotificationManager, tags, $window) {
    var vm = this;
    var deleteCrumb;
    var phaseId = $stateParams.phaseId;
    var unwatch;
    vm.showTable = false;
    vm.isOpen = false;
    vm.preloader = true;
    vm.locale = $window.sessionStorage.getItem('locale') || 'ru';
    vm.actions = {
      save: true
    };
    vm.tableRow = {
      name: 25,
      count: 5
    };
    vm.canEdit = Access.checkActionPermission({
      action: 'update',
      entity: 'tag'
    });

    $scope.$on('$destroy', function() {
      if (deleteCrumb) {
        deleteCrumb();
      }
      if (unwatch) {
        unwatch();
      }
      var i = vm.phases.findIndex(function(phase) {
        return phase._id === phaseId;
      });
      if (i !== -1) {
        vm.phases[i] = vm.phase;
      }
      EstimatesApi.updateTag(vm.phase);
    });

    $scope.phaseTree = { // eslint-disable-line
      accept: function(sourceNodeScope, destNodesScope) {
        var sourceType = sourceNodeScope.$element.attr('data-type');
        var destType = destNodesScope.$parent.$element.attr('data-type');
        if ((sourceType === 'feature' && angular.isDefined(destType)) || destType === 'task') {
          return false;
        } else {
          return true;
        }
      },
      dropped: function(event) {
        var data = {
          taskId: '',
          targetId: null
        };
        if (event.source.nodeScope.task) {
          //таск находится в группе
          data.taskId = event.source.nodeScope.task.link._id;
          if (event.dest.nodesScope.$nodeScope === null) {
            //перемещен в корень тэга
          } else {
            //перемещен в группу
            data.parentId = event.dest.nodesScope.$nodeScope.item.link._id;
          }
        } else {
          //таск в корне тэга
          data.taskId = event.source.nodeScope.item.link._id;
          if (event.dest.nodesScope.$nodeScope === null) {
            //перемещен в корень тэга
          } else {
            //перемещен в группу
            data.parentId = event.dest.nodesScope.$nodeScope.item.link._id;
          }
        }
        var index = event.dest.index;
        if (index > 0) {
          data.targetId = event.dest.nodesScope.$modelValue[index - 1].link._id;
        }
        EstimatesApi.updateTagsOrder(vm.phase._id, data).then(function(response) {
          NotificationManager.notifyMe('save', response.data);
        }, function(error) {
          NotificationManager.notifyMe('error', error.data);
        });
      }
    };

    vm.phases = tags;
    vm.selectedIndex = 0;
    var i = vm.phases.findIndex(function(phase) {
      return phase._id === phaseId;
    });
    if (i !== -1) {
      vm.selectedIndex = i;
    }

    vm.phase = {};
    vm.message = false;
    EstimatesApi.getDictionaryTagById(phaseId)
      .then(function(response) {
        vm.phase = response;
        deleteCrumb = BreadCrumbs.addCrumbs({name: vm.phase.name});
        vm.showTable = vm.phase.items.length === 0;
        if (!vm.phase.isExistAssoc && vm.phase.items.length === 0) {
          vm.message = true;
        }
        unwatch = $scope.$watch(function() {
          return vm.phase.items;
        }, updatePhase, true);
        vm.preloader = false;
      });

    function updatePhase() {
      if (!vm.phase.isExistAssoc) {
        vm.message = vm.phase.items.length === 0;
      }
      vm.phase = statisticComposer.composePhaseStatistic(vm.phase);
    }

    vm.finishRender = function() {
      vm.showTable = true;
    };

    vm.addNewFeature = function(event) {
      vm.isOpen = false;
      $mdDialog.show({
          targetEvent: event,
          locals: {
            isShowTemplate: true,
            isShowCustom: false,
            phases: vm.phases,
            currentPhase: {
              id: vm.phase._id,
              selected: vm.selectedIndex,
              name: vm.phase.name
            }
          },
          controller: 'EstimateEditNewFeatureModalController',
          controllerAs: 'vm',
          templateUrl: '/app/components/views/estimateNewFeature.html',
          clickOutsideToClose: true,
          fullscreen: true
        }).then(function(response) {
          if (response) {
            var listPatterns = {};
            listPatterns.groupIds = response.listPatterns;
            EstimatesApi.addGroupsAndWorkhoursToTag(phaseId, listPatterns)
              .then(function(response) {
                vm.phase = response;
              });
          }
        });
    };

    vm.addNewTask = function(event) {
      vm.isOpen = false;
      $mdDialog.show({
        targetEvent: event,
        locals: {
          isShowTemplate: true,
          isShowCustom: false,
          phases: vm.phases,
          currentPhase: {id: vm.phase._id, selected: vm.selectedIndex},
          parentItem: {name: vm.phase.name, isPhase: true}
        },
        controller: 'EstimateEditNewTaskModalController',
        controllerAs: 'vm',
        templateUrl: '/app/components/views/estimateNewTask.html',
        clickOutsideToClose: true,
        fullscreen: true
      }).then(function(response) {
        var listPatterns = {};
        listPatterns.workhourIds = response.listPatterns;
        EstimatesApi.addGroupsAndWorkhoursToTag(phaseId, listPatterns)
          .then(function(response) {
            vm.phase = response;
          });

      });
    };

    vm.deleteFeature = function(event, featureIndex) {
      var el = angular.element(event.currentTarget);
      el.blur();
      $mdDialog.show(
        $mdDialog.confirm()
          .title('Внимание!')
          .content('Вы действительно хотите удалить группу нормочасов?')
          .targetEvent(event)
          .ok('ОК')
          .cancel('Отмена')
        ).then(function() {
          var feature = vm.phase.items[featureIndex];
          if (angular.isObject(feature)) {
            EstimatesApi.deleteGroupFromTag(vm.phase._id, feature.link._id).then(function() {
              vm.phase.items.splice(featureIndex, 1);
            });
          }
        });
    };

    vm.deleteTask = function(taskIndex, parent, event) {
      var el = angular.element(event.currentTarget);
      el.blur();
      $mdDialog.show(
        $mdDialog.confirm()
          .title('Внимание!')
          .content('Вы действительно хотите удалить нормочас?')
          .targetEvent(event)
          .ok('ОК')
          .cancel('Отмена')
        ).then(function() {
          var task = parent.items[taskIndex];
          if (angular.isObject(task)) {
            EstimatesApi.deleteWorkhourFromTag(parent._id, task.link._id).then(function() {
              parent.items.splice(taskIndex, 1);
            });
          }
        });
    };

    vm.saveChange = function(item) {
      EstimatesApi.updateItemTag(phaseId, item).then(function() {
      });
    };

    /*vm.updateLocale = function() {
      $window.sessionStorage.setItem('locale', vm.locale);
    };*/

  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .controller('navBarController', navBarController);

  /** @ngInject */
  function navBarController($rootScope, $scope,
    $mdSidenav, BreadCrumbs, statisticComposer, Access) {
    /* jshint validthis: true */
    var vm = this;

    var menu = [
      {title: 'Оценки', href: 'index.estimates'},
      {title: 'Словарь', menu: [
        {title: 'Справочник фаз', href: 'index.tags', id: 'tag'},
        {title: 'Справочник фич', href: 'index.groups', id: 'group'},
        {title: 'Справочник нормочасов', href: 'index.workhours', id: 'workhour'},
        {title: 'Справочник ролей', href: 'index.roles', id: 'role'}
        //{title: 'Управление ролями', href: 'index.admin', id: 'user'}
      ]},
      {title: 'Руководство', href: '', link: '/assets/user_guide.pdf'},
      {title: 'Статистика', href: 'index.chart', roles: ['administrator']},
      {title: 'Выход', href: 'logout'}
    ];
    for (var i = 0, lenMenu = menu.length; i < lenMenu; i++) {
      grantAccess(menu[i]);
      if (menu[i].menu) {
        for (var j = 0, len = menu[i].menu.length; j < len; j++) {
          grantAccess(menu[i].menu[j]);
        }
      }
      if (menu[i].roles) {
        grantAccess(menu[i]);
      }
    }

    function grantAccess(menuItem) {
      if (menuItem.id) {
        menuItem.accessDenied = !Access.checkActionPermission({
          entity: menuItem.id,
          action: 'list'
        });
      } else if (menuItem.roles) {
        var roleObject = Access.getUserRole();
        var userRole = roleObject ? roleObject.name : 'unnamed';
        menuItem.accessDenied = menuItem.roles.indexOf(userRole) < 0;
      }
    }
    vm.breadCrumbs = '';
    var deleteListener = BreadCrumbs.addListener(updateBreadcrumbs);

    statisticComposer.init();

    function updateBreadcrumbs(crumbs) {
      vm.breadCrumbs = crumbs;
    }

    angular.extend(vm, {
      menu: menu,
      activeMenuItem: menu[0].title,
      initSideNav: initSideNav
    });

    function initSideNav(position) {
      angular.extend(vm, {
        sideNav: $mdSidenav(position)
      });
    }

    $scope.$on('$destroy', function() {
      deleteListener();
    });

  }
})();

(function() {
  'use strict';

  angular
    .module('estimateMeUi')
    .controller('LogoutStateController',LogoutStateController);

  /** @ngInject */
  function LogoutStateController(Auth) {
    if (Auth.isAuth()) {
      Auth.logout();
    }
  }
})();

/* eslint angular/timeout-service: 0 */
(function() {
  'use strict';

  angular.module('estimateMeUi')
    .controller('LoginFormController',LoginFormController);

  /** @ngInject */
  function LoginFormController(Auth, $state, Redirector, $mdDialog/*, $window*/, $document) {
    var vm = this;
    //var timeout;

    if (Auth.isAuth()) {
      return $state.go('index.estimates');
    }
    vm.message = false;
    vm.processing = false;
    vm.log = log;
    vm.logFaceBook = logFaceBook;
    vm.showLoginButton = false;

    setTimeout(vm.logFaceBook);

    //vm.logFaceBook();

    /*vm.checkAutoFillValues = function() {
      // Check if there are auto-filled values on the page and mark them as having a value
      var inputs = $document[0].querySelectorAll('input:-webkit-autofill');
      if (timeout) {
        clearTimeout(timeout);
      }
      if (!inputs.length) {
        timeout = setTimeout(vm.checkAutoFillValues, 25);
      } else {
        for (var i = 0; i < inputs.length; i++) {
          angular.element(inputs[i]).parent().addClass('md-input-has-value');
        }
      }
    }*/


    function logFaceBook(event) {
       $mdDialog.show({
        targetEvent: event,
        parent: angular.element($document.body),
        controller: 'LoginAgreementModalController',
        controllerAs: 'vm',
        templateUrl: '/app/pages/login/loginAgreementModal.html',
        clickOutsideToClose: true
      }).then(function(response) {
        vm.showLoginButton = false;
        if (response) {
          vm.message = false;
          vm.processing = true;
          Auth
            .fbAuth()
            .then(handleRedirect, handleReject);
        } else {
          vm.showLoginButton = true;
        }
      });
    }

    function log() {
      vm.message = false;
      vm.processing = true;

      Auth
        .authenticate(vm.login,vm.password)
        .then(handleRedirect, handleReject);
    }

    function handleRedirect() {
      vm.processing = false;
      var state = Redirector.getState() || 'index.estimates';
      var params = Redirector.getParams() || [];
      Redirector.setState('', '');
      $state.go(state, params);
    }

    function handleReject(reject) {
      vm.processing = false;
      vm.showLoginButton = true;
      if (reject && reject.data && reject.data.error === 'User has no email') {
        $mdDialog.show(
          $mdDialog.alert()
            .title('Регистрация не выполнена')
            .content('Доступ в приложение невозможен, так как для завершения регистрации требуется email. <a href="https://www.facebook.com/settings?tab=applications&section=active">Удалите</a> приложение Estimate Platform в фейсбуке и авторизуйтесь повторно, разрешив передачу email')
            .ok('OK'))
          .then(function() {
              $state.go('login');
            });
      }

      vm.message = reject ? reject.message : 'Unknown error';
    }
  }
})();

(function() {
  'use strict';

  angular
      .module('estimateMeUi')
      .controller('LoginAgreementModalController', LoginAgreementModalController);

  /** @ngInject */
  function LoginAgreementModalController($mdDialog) {
    /* jshint validthis: true */
    var vm = this;

    vm.public = false;
    vm.personal = false;

    vm.isMobile = isMobile;
    vm.mobileUser = false;
    vm.navigator = navigator;
    

    vm.cancel = cancel;
    vm.ok = ok;

    function isMobile() {
      if ('orientation' in window) {
        vm.mobileUser = true; // deprecated, but good fallback
      } else {
        // Only as a last resort, fall back to user agent sniffing
        var UA = vm.navigator.userAgent;
        vm.mobileUser = (
            /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
            /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
        );
      }

      return vm.mobileUser;
    }

    function cancel() {
       $mdDialog.hide(false);
    }

    function ok () {
      $mdDialog.hide(vm.public && vm.personal);
    }
  }
})();
(function() {
  'use strict';
  angular
      .module('estimateMeUi')
      .controller('FeatureTemplateEditController', FeatureTemplateEditController);
  /** @ngInject */
  function FeatureTemplateEditController($rootScope, $scope, EstimatesApi, $mdDialog, $stateParams, $document, $q,
      $timeout, header, $controller, $state, Access, tags) {

    var vm = this;
    var phaseId = $stateParams.phaseId;
    vm.showTable = false;
    vm.preloader = true;
    vm.locale = 'ru';

    vm.canCreate = Access.checkActionPermission({
      action: 'create',
      entity: 'group'
    });
    vm.canDelete = Access.checkActionPermission({
      action: 'delete',
      entity: 'group'
    });
    vm.canEdit = Access.checkActionPermission({
      action: 'update',
      entity: 'group'
    });

    vm.features = [];
    vm.actions = {
      save: true
    };
    vm.tableRow = {
      name: 25,
      count: 5,
      phases: 20
    };
    vm.roleList = [];
    vm.newFeature =  {
      name: '',
      associated: [phaseId]
    };

    EstimatesApi.getDictionaryRoles()
    .then(function(response) {
      vm.roleList = response.roles;
    });

    vm.phases = tags;
    if (phaseId) {
      getGroupsList(phaseId);
    }

    function getGroupsList(id) {
      EstimatesApi.getGroupsAssociatedWithTag(id)
          .then(function(response) {
            if (!response.error) {
              vm.features = response;
              if (vm.features.length === 0) {
                vm.showTable = true;
              }
            }
          })
          .finally(function () {
            vm.preloader = false;
          });
    }

    vm.finishRender = function() {
      vm.showTable = true;
    };

    vm.addNewTask = function(event, featureIndex) {
      $mdDialog.show({
        targetEvent: event,
        locals: {
          isShowTemplate: true,
          isShowCustom:  false,
          phases: vm.phases,
          currentPhase: {id: phaseId, selected: vm.selected},
          parentItem: {name: vm.features[featureIndex].name, isPhase: false}
        },
        controller: 'EstimateEditNewTaskModalController',
        controllerAs: 'vm',
        templateUrl: '/app/components/views/estimateNewTask.html',
        clickOutsideToClose: true,
        fullscreen: true
      }).then(function(response) {
        if (response) {
          var listPatterns = {};
          listPatterns.customNames = [];
          listPatterns.workhourIds = response.listPatterns;
          var roleNewWorkhour = vm.features[featureIndex].workhours.length > 0 ? vm.features[featureIndex].workhours[0].link.role : vm.roleList[0];
          if (response.bufferTasks.length > 0) {
            listPatterns.customNames = [
              {
                associated: [phaseId],
                name: response.bufferTasks[0],
                role: roleNewWorkhour
              }
            ];
          }
          EstimatesApi.addWorkhoursToGroup(vm.features[featureIndex]._id, listPatterns)
            .then(function(response) {
              vm.features[featureIndex] = response;
            });
        }
      });
    };

    vm.deleteTask = function(taskIndex, parent, event) {
      var task = parent.workhours[taskIndex];
      var el = angular.element(event.currentTarget);
      el.blur();
      if (angular.isObject(task)) {
        $mdDialog.show(
          $mdDialog.confirm()
            .title('Внимание!')
            .content('Вы действительно хотите удалить нормочас?')
            .targetEvent(event)
            .ok('ОК')
            .cancel('Отмена')
          ).then(function() {
            EstimatesApi.deleteWorkhourFromGroup(parent._id, task.link._id).then(function() {
              parent.workhours.splice(taskIndex, 1);
            });
          });
      }
    };

    vm.deleteFeature = function(event, featureIndex) {
      var feature = vm.features[featureIndex];
      var el = angular.element(event.currentTarget);
      el.blur();
      if (angular.isObject(feature)) {
        $mdDialog.show(
          $mdDialog.confirm()
            .title('Внимание!')
            .content('Вы действительно хотите удалить группу нормочасов?')
            .targetEvent(event)
            .ok('ОК')
            .cancel('Отмена')
          ).then(function() {
            EstimatesApi.deleteDictionaryGroup(feature._id).then(function() {
              vm.features.splice(featureIndex, 1);
            });
          });
      }
    };

    vm.addCallbackOnNewTaskCreation = function(callback) {

      vm.setNewTaskFormUntouched = callback;
    };
    vm.addNewFeature = function() {
      EstimatesApi.addDictionaryGroups(vm.newFeature)
        .then(function(response) {
          if (angular.isObject(response[0])) {
            var i = vm.newFeature.associated.findIndex(function(id) {
              return id === phaseId;
            });
            if (i !== -1) {
              angular.copy(response[0], vm.newFeature);
              vm.features.push(vm.newFeature);
            }
            vm.newFeature =  {
              name: '',
              associated: [phaseId]
            };
            if (angular.isFunction(vm.setNewTaskFormUntouched)) {
              vm.setNewTaskFormUntouched();
            }
          }
        });
    };

    vm.saveFeature = function(feature) {
      EstimatesApi.updateGroups([feature])
        .then(function() {
        });
    };

    vm.saveCountWorkhour = function(workhour, idGroup) {
      EstimatesApi.updateCountGroup(idGroup, workhour)
        .then(function() {
      });
    };

  }
})();

(function() {
  'use strict';

  angular
      .module('estimateMeUi')
      .controller('EstimateEditReorderPhaseModalController', EstimateEditReorderPhaseModalController);

  /** @ngInject */
  function EstimateEditReorderPhaseModalController($scope, $mdDialog, EstimatesApi, isShowTemplate, phases) {
    /* jshint validthis:true */

    var vm = this;
    vm.listPatterns = [];
    vm.saveReorderPhases = saveReorderPhases;
    vm.closeModal = closeModal;
    vm.phases = createListPhases(phases);

    function createListPhases(phases) {
      var phasesList = [];
      for (var i = 0, len = phases.length; i < len; i++) {
        var phase = {
          _id: phases[i]._id,
          name: phases[i].name,
          index: angular.isDefined(phases[i].index) ? phases[i].index : null
        };
        phasesList.push(phase);
      }
      phasesList.sort(function(a, b) {
        return a.index - b.index;
      });
      return phasesList;
    }

    function saveReorderPhases() {
      vm.phases.forEach(function(element, i) {
        element.index = i;
      });
      var result = vm.phases.map(function(item) {
        delete item.name;
        return item;
      });
      $mdDialog.hide({
        phasesReordered: result
      });
    }

    function closeModal() {
      $mdDialog.hide();
    }

  }
})();

(function() {
  'use strict';

  angular
      .module('estimateMeUi')
      .controller('EstimateEditNewTaskModalController', EstimateEditNewTaskModalController);

  /** @ngInject */
  function EstimateEditNewTaskModalController($mdDialog, isShowTemplate, isShowCustom, EstimatesApi, phases,
      currentPhase, parentItem) {
    /* jshint validthis: true */
    var vm = this;
    vm.bufferTask = '';
    vm.listPatterns = [];
    EstimatesApi.getDictionaryWorkhours().then(function(res) {
      if (res.length) {
        vm.listPatterns = res;
      }
    });

    vm.saveAddingTasks = saveAddingTasks;
    vm.isShowTemplate = isShowTemplate;
    vm.isShowCustom = isShowCustom;
    vm.hasCheckedTemplate = hasCheckedTemplate;
    vm.closeModal = closeModal;
    vm.phases = phases;
    vm.currentPhase = {
      id: currentPhase.id || 0,
      selected: currentPhase.selected || 0
    };
    vm.parentItem = {
      name: parentItem.name,
      isPhase: parentItem.isPhase
    };
    vm.phaseFilter = function(task) {
      for (var i = 0, len = task.associated.length; i < len; ++i) {
        if (task.associated[i].id === vm.currentPhase.id) {
          return true;
        }
      }
      return false;
    };
    vm.onPhaseSelected = function(phase) {
      vm.currentPhase.id = phase._id;
    };

    function saveAddingTasks() {
      var checkedListPatterns = vm.listPatterns.filter(function(item) {
        return item.checked;
      }).map(function(item) {
        return item._id;
      });
      $mdDialog.hide({
        bufferTasks: (vm.bufferTask) ? [vm.bufferTask] : [],
        listPatterns: checkedListPatterns
      });
    }
    function hasCheckedTemplate() {
      for (var i = vm.listPatterns.length; i--;) {
        if (vm.listPatterns[i].checked) {
          return true;
        }
      }
      return false;
    }
    function closeModal() {
      $mdDialog.hide();
    }

  }
})();

(function() {
  'use strict';

  angular
      .module('estimateMeUi')
      .controller('EstimateEditNewRoleModalController', EstimateEditNewRoleModalController);

  /** @ngInject */
  function EstimateEditNewRoleModalController($mdDialog) {
    /* jshint validthis: true */
    var vm = this;
    vm.bufferRole = '';
    vm.bufferRoles = [];

    vm.addBufferRole = addBufferRole;
    vm.deleteBufferRole = deleteBufferRole;
    vm.saveAddingRoles = saveAddingRoles;

    function saveAddingRoles() {
      $mdDialog.hide({
        bufferRoles: vm.bufferRoles
      });
    }
    function deleteBufferRole(index) {
      vm.bufferRoles.splice(index, 1);
    }
    function addBufferRole(e) {
      var isKey = e.code || e.char;
      var keyCode = e.charCode || e.keyCode;
      if (!isKey || isKey && keyCode === 13) {
        vm.bufferRoles = vm.bufferRoles || [];
        if (vm.bufferRole && vm.bufferRoles.indexOf(vm.bufferRole) === -1) {
          vm.bufferRoles.push(vm.bufferRole);
          vm.bufferRole = undefined;
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
      .module('estimateMeUi')
      .controller('EstimateEditNewPhaseModalController', EstimateEditNewPhaseModalController);

  /** @ngInject */
  function EstimateEditNewPhaseModalController($mdDialog, EstimatesApi, isShowTemplate, $stateParams, phasesLength) {
    /* jshint validthis:true */

    var vm = this;
    vm.bufferPhase = '';
    vm.listPatterns = [];
    vm.phasesListLength = phasesLength;
    vm.checkedListPatterns = [];
    vm.saveAddingPhases = saveAddingPhases;
    vm.isShowTemplate = isShowTemplate;
    vm.hasCheckedTemplate = hasCheckedTemplate;
    vm.closeModal = closeModal;
    vm.formCheckedListPatterns = formCheckedListPatterns;
    EstimatesApi.getDictionaryTags().then(function(res) {
      vm.listPatterns = res.content;
    });

    /**
    * Формируем array из id у чекнутых шаблонов, а так же проверяем, что результрующие количество фаз
    * не выходит за рамки допустимого предела - не больше 20 фаз в проекте.
    * vm.checkedListPatterns.length - то что чекается в самой модалке
    * vm.phasesListLength - текущее количество фаз
    * vm.bufferPhase - фаза создаваемая через инпут
    **/
    function formCheckedListPatterns() {
      vm.checkedListPatterns = vm.listPatterns.filter(function(item) {
        return item.checked;
      }).map(function(item) {
        return item._id;
      });
      if (vm.checkedListPatterns.length + vm.phasesListLength + ((vm.bufferPhase) ? 1 : 0) > 20) {
        return true;
      } else {
        return false;
      }
    }

    function saveAddingPhases() {
      $mdDialog.hide({
        bufferPhases: (vm.bufferPhase) ? [vm.bufferPhase] : [],
        listPatterns: vm.checkedListPatterns
      });
    }

    function hasCheckedTemplate() {
      for (var i = vm.listPatterns.length; i--;) {
        if (vm.listPatterns[i].checked) {
          return true;
        }
      }
      return false;
    }
    function closeModal() {
      $mdDialog.hide();
    }

    vm.addPhaseOnEnter = function (e) {
      var isKey = e.code || e.char;
      var keyCode = e.charCode || e.keyCode;
      if (isKey && keyCode === 13) {
        vm.saveAddingPhases(e);
      }
    };
  }
})();

(function() {
  'use strict';

  angular
      .module('estimateMeUi')
      .controller('EstimateEditNewFeatureModalController', EstimateEditNewFeatureModalController);

  /** @ngInject */
  function EstimateEditNewFeatureModalController($mdDialog, isShowTemplate, isShowCustom, EstimatesApi, phases,
      currentPhase) {
    /* jshint validthis: true */
    var vm = this;
    vm.bufferFeature = '';
    vm.listPatterns = [];
    EstimatesApi.getDictionaryGroups().then(function(res) {
      vm.listPatterns = res.content;
      if (vm.listPatterns) {
        for (var i = 0; i < vm.listPatterns.length; ++i) {
          vm.listPatterns[i].minHours = 0;
          vm.listPatterns[i].maxHours = 0;
          var rolesID = [];
          var rolesName = [];
          for (var j = 0, len = vm.listPatterns[i].workhours.length; j < len; ++j) {
            var workhour = vm.listPatterns[i].workhours[j];
            vm.listPatterns[i].minHours += workhour.link.minHours;
            vm.listPatterns[i].maxHours += workhour.link.maxHours;
            var roleIndex = -1;
            if (workhour.role) {
              roleIndex = findRoleIndex(rolesID, workhour.role._id);
              if (roleIndex === -1) {
                rolesID.push(workhour.role._id);
                rolesName.push(workhour.role.name);
              }
            }
          }
          vm.listPatterns[i].composedRole = rolesName.join(', ');
        }
      }
    });

    function findRoleIndex(rolesID, workhourID) {
      return rolesID.findIndex(function(role) {
        return workhourID === role;
      });
    }

    vm.saveAddingFeatures = saveAddingFeatures;
    vm.isShowTemplate = isShowTemplate;
    vm.isShowCustom = isShowCustom;
    vm.hasCheckedTemplate = hasCheckedTemplate;
    vm.closeModal = closeModal;
    vm.phases = phases;
    vm.currentPhase = {
      id: currentPhase.id || 0,
      selected: currentPhase.selected || 0,
      name: currentPhase.name || ''
    };
    vm.phaseFilter = function(feature) {
      for (var i = 0, len = feature.associated.length; i < len; ++i) {
        if (feature.associated[i].id === vm.currentPhase.id) {
          return true;
        }
      }
      return false;
    };
    vm.onPhaseSelected = function(phase) {
      vm.currentPhase.id = phase._id;
    };
    vm.changeListState = function(event, feature) {
      feature.opened = !feature.opened;
      event.stopPropagation();
    };

    function saveAddingFeatures() {
      var checkedListPatterns = vm.listPatterns.filter(function(item) {
        return item.checked;
      }).map(function(item) {
        return item._id;
      });
      $mdDialog.hide({
        bufferFeatures: (vm.bufferFeature) ? [vm.bufferFeature] : [],
        listPatterns: checkedListPatterns
      });
    }

    function hasCheckedTemplate() {
      if (vm.listPatterns) {
        for (var i = vm.listPatterns.length; i--;) {
          if (vm.listPatterns[i].checked) {
            return true;
          }
        }
      }
      return false;
    }
    function closeModal() {
      $mdDialog.hide();
    }
  }
})();

(function() {
  'use strict';

  angular
      .module('estimateMeUi')
      .controller('EstimateEditNewCurrencyModalController', EstimateEditNewCurrencyModalController);

  /** @ngInject */
  function EstimateEditNewCurrencyModalController($mdDialog) {
    /* jshint validthis: true */
    var vm = this;
    vm.bufferCurrency = '';
    vm.bufferCurrencies = [];

    vm.addBufferCurrency = addBufferCurrency;
    vm.deleteBufferCurrency = deleteBufferCurrency;
    vm.saveAddingCurrencies = saveAddingCurrencies;

    function saveAddingCurrencies() {
      $mdDialog.hide({
        bufferCurrencies: vm.bufferCurrencies
      });
    }
    function deleteBufferCurrency(index) {
      vm.bufferCurrencies.splice(index, 1);
    }
    function addBufferCurrency(e) {
      var isKey = e.code || e.char;
      var keyCode = e.charCode || e.keyCode;
      if (!isKey || isKey && keyCode === 13) {
        vm.bufferCurrencies = vm.bufferCurrencies || [];
        if (vm.bufferCurrency && vm.bufferCurrencies.indexOf(vm.bufferCurrency) === -1) {
          vm.bufferCurrencies.push(vm.bufferCurrency);
          vm.bufferCurrency = undefined;
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
      .module('estimateMeUi')
      .controller('GetFileExportController', GetFileExportController);

  /** @ngInject */
  function GetFileExportController($mdDialog, link) {
    /* jshint validthis:true */
    var vm = this;
    vm.link = link;
    vm.close = closeDialog;

    function closeDialog() {
      $mdDialog.hide();
    }

  }
})(angular, angular.module('estimateMeUi'));

(function() {
  'use strict';

  angular
      .module('estimateMeUi')
      .controller('EditUserRolesController', EditUserRolesController);
  /** @ngInject */
  function EditUserRolesController($scope, $log, BreadCrumbs, header, usersStatuses, Access, Preloader) {
    var vm = this;
    vm.users = usersStatuses.users;
    vm.preloader = true;
    vm.usersCopy = [];
    angular.copy(vm.users, vm.usersCopy);
    vm.userRoles = [];
    vm.actions = {
      save: true
    };
    vm.changeUserRole = changeUserRole;
    vm.changeSorting = changeSorting;
    var asc = false;
    var desc = true;
    vm.sorting = {
      fullName: asc
    };
    vm.columnActiveSorting = 'fullName';

    Access.getRoleList().then(function(response) {
      if (response.content) {
        vm.userRoles = response.content;
      }
    });

    var deleteCrumb = BreadCrumbs.addCrumbs(header);
    $scope.$on('$destroy', function() {
      deleteCrumb();
    });

    var deleteListener = Preloader.addOpenListener(openPreloader);
    function openPreloader() {
      vm.preloader = true;
    }

    vm.closePreloader = function() {
      vm.preloader = false;
    };
    
    $scope.$on('$destroy', function() {
      deleteListener();
    });

    function compare(roleCopy, role) {
      if (!roleCopy) {
        return true;
      }
      return roleCopy._id !== role._id;
    }

    function changeUserRole(user) {
      var userCopy = vm.usersCopy.find(function(copy) {
        return copy._id === user._id;
      });
      if (userCopy && user.role && compare(userCopy.role, user.role)) {
        Access.changeUserRole(user._id, user.role._id).then(function() {
        });
      }
    }
    function changeSorting(column) {
      var sort = vm.sorting[column];
      vm.sorting[column] = (sort) ? asc : desc;
      vm.columnActiveSorting = column;
    }
  }
})();

/* eslint angular/timeout-service: 0 */
(function() {
  'use strict';

  angular.module('estimateMeUi')
    .controller('EstimatesListController', EstimatesListController);

  /** @ngInject */
  function EstimatesListController($scope, $timeout, $log, $rootScope, EstimatesApi, $mdDialog, header, BreadCrumbs,
    $state, ExportExcelService, Access, Mediator, $localStorage) {
    var vm = this;
    vm.arrEstimates = [];
    vm.busy = true;
    vm.loading = false;
    vm.range = [];
    vm.pert = [];
    vm.isNotFound = false;
    vm.filterList = {
      client: {name: 'Клиент', isActive: true},
      name: {name: 'Название', isActive: true},
      status: {name: 'Статус', isActive: false}
      //author: {name: 'Владелец', isActive: false}
    };
    vm.filterResult = true;
    vm.searchStingWithSpaces = true;
    vm.searchText = '';

    var sortAscending = {nameSort: 'asc', icon: 'expand_more'};
    var sortDecending = {nameSort: 'desc', icon: 'expand_less'};
    vm.sorting = {name: sortAscending, created: sortAscending, status: sortAscending,
      customer: sortAscending};

    vm.reverse = false;
    vm.predicate = '';

    vm.changeSorting = changeSorting;
    vm.disableDeletion = disableDeletion;
    vm.disableExport = disableExport;
    vm.disableCopying = disableCopying;
    vm.canCreate = Access.checkActionPermission(
      {
        entity: 'estimate',
        action: 'create'
      }
    );
    vm.displayEstimateList = Access.checkActionPermission(
      {
        entity: 'estimate',
        action: 'list'
      }
    );

    vm.currentUser = $localStorage.userToken.user;

    var deleteCrumb = BreadCrumbs.addCrumbs(header);
    $scope.$on('$destroy', function() {
      deleteCrumb();
      remStatisticUpdateListener();
    });

    /* handers */
    vm.deleteEstimate = deleteEstimate;
    vm.newEstimate = newEstimate;
    vm.excelExport = excelExport;
    vm.copyEstimate = copyEstimate;

    var fields = ['authors', 'created', 'customer', 'name', 'status', 'statistic.E68', 'statistic.E95',
      'statistic.maxHours', 'statistic.minHours', 'statistic.workhoursPercents'];

    var param = {limit: 10, select: fields.join(','), sort: '-created'};
    if (!remStatisticUpdateListener) {
      $timeout(getEstimate(), 100);
    }

    var remStatisticUpdateListener = Mediator.subscribe('statistic_update', function() {
      $timeout(getEstimate(), 100);
    });

    function getEstimate() {
      vm.preloader = true;
      vm.page = 1;
      EstimatesApi.getEstimatesList(angular.extend({}, {page: 0}, param))
      .then(function(responses) {
        if (responses && responses.content && angular.isArray(responses.content)) {
          vm.arrEstimates = responses.content;
          vm.arrEstimates.forEach(function(est) {
            vm.range[est._id] = countHours(est, est.statistic.minHours, est.statistic.maxHours);
            vm.pert[est._id] = countHours(est, est.statistic.E68, est.statistic.E95);
          });
        }
        vm.isNotFound = !responses.content.length;
        vm.preloader = false;
        vm.page = 1;
        vm.maxPage = Math.ceil(responses.total / 10);
      });
    }

    function countHours(est, min, max) {
      var arr = [];
      if (!(Math.round(min) && Math.round(max))) {
        return '';
      }else {
        arr.push(Math.round(min));
        arr.push(Math.round(max));
        return arr.join(' — ');
      }
    }

    vm.nextPage = function() {
      if (vm.busy) {return;}
      vm.busy = true;
      EstimatesApi.getEstimatesList(angular.extend({}, {page: vm.page}, param))
      .then(function(responses) {
        if (angular.isArray(responses.content)) {
          var items = responses.content;
          vm.arrEstimates = vm.arrEstimates.concat(items);
          items.forEach(function(est) {
            vm.range[est._id] = countHours(est, est.statistic.minHours, est.statistic.maxHours);
            vm.pert[est._id] = countHours(est, est.statistic.E68, est.statistic.E95);
          });
        }
        vm.page += 1;
      });
    };

    vm.finishRender = function() {
      vm.endPage = vm.busy = vm.maxPage === vm.page;
    };
    vm.combineArray = function(array, key) {
      var keysArray = array.map(function(item) {
        return item[key];
      });
      return keysArray.join(', ');
    };

    /*vm.closeFab = function() {
      vm.isOpen = false;
    };

    vm.openFab = function(e) {
      e.stopPropagation();
      vm.isOpen = true;
    };*/

    function newEstimate($event, locale) {
      vm.loading = true;
      EstimatesApi.createEstimate(locale)
        .then(function(response) {
          if (angular.isObject(response)) {
            $state.go('index.estimates.edit.edit', {estimate: response._id, newEstimate: true});
          } else if (angular.isString(response)) {
            vm.loading = false;
            $log.log(response);
            $mdDialog.show(
              $mdDialog.alert()
                .title('Внимание!')
                .content(response)
                .ok('OK'));
          }
        }, function(error) {
          $log.log(error);
          vm.loading = false;
        });
    }

    function copyEstimate(e, est) {
      var el = angular.element(e.currentTarget);
      e.stopPropagation();
      e.preventDefault();
      $mdDialog.show(
        $mdDialog.confirm()
          .title('Внимание!')
          .content('Вы действительно хотите скопировать оценку "' + est.name + '" ?')
          .targetEvent(e)
          .ok('OK')
          .cancel('Отмена'))
        .then(function() {
            EstimatesApi.copyEstimate(est._id)
              .then(function(response) {
                if (angular.isObject(response)) {
                  $state.go('index.estimates.edit.edit', {estimate: response._id, newEstimate: false});
                } else if (angular.isString(response)) {
                  $log.log(response);
                  $mdDialog.show(
                    $mdDialog.alert()
                      .title('Внимание!')
                      .content(response)
                      .ok('OK'));
                }
              }, function(error) {
                $log.log(error);
              });
          }, function() {
            el.blur();
          });
    }

    function deleteEstimate(e, est) {
      var el = angular.element(e.currentTarget);
      e.stopPropagation();
      e.preventDefault();
      $mdDialog.show(
        $mdDialog.confirm()
          .title('Внимание!')
          .content('Вы действительно хотите удалить данную оценку?')
          .targetEvent(e)
          .ok('ОК')
          .cancel('Отмена'))
        .then(function() {
          EstimatesApi.deleteEstimate(est._id).then(function() {
            angular.forEach(vm.arrEstimates, function(el, i) {
              if (el._id === est._id) {
                vm.arrEstimates.splice(i, 1);
                return;
              }
            });
          });
        }, function() {
          el.blur();
        });
    }

    function excelExport(e, est) {
      e.stopPropagation();
      ExportExcelService.openExportExcelWindow(e, est);
    }

    function changeSorting(column) {
      var sort = vm.sorting[column];

      vm.sorting[column] = (!sort || sort.nameSort === 'desc') ? sortAscending : sortDecending;
      vm.columnActiveSorting = column;

      if (sort.nameSort === 'asc') {
        vm.reverse = false;
      }else {
        vm.reverse = true;
      }

      switch (column) {
        /*case 'author':
          vm.predicate = 'authors[0].fullName';
          break;*/
        case 'status':
          vm.predicate = 'status.name';
          break;
        case 'name':
          vm.predicate = column;
          break;
        case 'created':
          vm.predicate = column;
          break;
        case 'customer':
          vm.predicate = column;
          break;
      }

    }

    /* search estimates */
    function Detour(cb, time) {
      /*eslint-disable */
      this.cb = cb;
      this.interval = 0;
      this.time = time;
      this.run = function() {
        clearTimeout(this.interval);
        var args = arguments;
        var cb = this.cb;
        this.interval = setTimeout(function() {
          cb.apply(null, args);
        }, this.time);
      };
      this.runNow = function() {
        clearTimeout(this.interval);
        this.cb.apply(null, arguments);
      };
      /*eslint-enable */
    }

    vm.searchCallback = new Detour(function() {
      if (vm.searchText === '') {
        getEstimate();
        return;
      }
      if (vm.searchText.length < 3 || !hasFilters()) {
        return;
      }
      vm.preloader = true;
      var body = {
        searchString: vm.searchText,
        includeSpaces: vm.searchStingWithSpaces,
        client: vm.filterList.client.isActive,
        name: vm.filterList.name.isActive,
        status: vm.filterList.status.isActive
        //author: vm.filterList.author.isActive
      };
      EstimatesApi.searchEstimate(body)
      .then(function(responses) {
        vm.arrEstimates = responses;
        vm.arrEstimates.forEach(function(est) {
          vm.range[est._id] = countHours(est, est.statistic.minHours, est.statistic.maxHours);
          vm.pert[est._id] = countHours(est, est.statistic.E68, est.statistic.E95);
        });
        vm.isNotFound = !responses.length;
        vm.preloader = false;
        vm.page = vm.maxPage = 1;
        vm.finishRender();
      });
    }, 600);

    function hasFilters() {
      for (var key in vm.filterList) {
        if (vm.filterList[key].isActive) {
          return true;
        }
      }
      return false;
    }

    vm.setSpaces = function() {
      if (vm.searchText === '') {return;}
      vm.searchCallback.runNow();
    };

    vm.setFilter = function(value) {
      value.isActive = !value.isActive;
      if (vm.searchText === '') {return;}
      vm.searchCallback.runNow();
    };

    /* rights check */
    function disableDeletion(estimate) {
      return !Access.checkActionPermission(
        {
          owners: estimate.authors,
          entity: 'estimate',
          action: 'delete'
        }
      );
    }

    function disableCopying(estimate) {
      return !Access.checkActionPermission(
        {
          owners: estimate.authors,
          entity: 'estimate',
          action: 'create'
        }
      );
    }

    function disableExport(estimate) {
      return !Access.checkActionPermission(
        {
          owners: estimate.authors,
          action: 'export',
          entity: 'estimate'
        }
      );
    }

  }
})();

(function() {
  'use strict';

  angular
      .module('estimateMeUi')
      .controller('EstimateExportExcelController', EstimateExportExcelController);

  /** @ngInject */
  function EstimateExportExcelController($log, $mdDialog, $scope, est, indexFormat, ExportExcelService, EstimatesApi, statisticComposer, $window) {
    /* jshint validthis:true */

    var vm = this;

    vm.isManager = false; // права на выгрузку стоимости из оценки

    vm.est = est;
    vm.reduced = angular.copy(statisticComposer.getReduced());
    var unwatch;

    vm.format = [{name: 'Диапазон', namekey: 'range'}, {name: 'PERT', namekey: 'pert', tooltip: 'Инженерный метод оценки трудоемкости проекта, для расчета которого используются три точки - оптимистическое время, пессимистическое время и наиболее вероятное время'}];
    vm.indexFormat = indexFormat === 1 ? 1 : 0;
    vm.messageError = [];
    vm.role = {};
    vm.currencies = [];
    vm.sum = '';
    vm.curren = '';
    vm.dictionaryRoles = [];

    vm.close = closeDialog;
    vm.export = exportDialog;

    vm.data = {
      format: vm.format[vm.indexFormat].namekey,
      currency: '',
      roles: [],
      risks: vm.est.risk
    };
    $scope.$on('$destroy', function() {
      if (unwatch) {
        unwatch();
      }
    });

    vm.roleErrorMessage = false;
    
    //incorrect role search
    vm.est.phases.forEach(function(phase) {
      phase.items.forEach(function(item) {
        if(item.type === 'feature') {
          item.tasks.forEach(function(task) {
            if ( (task.role === null) || !task.role ) {
              vm.roleErrorMessage = true;
            }
          });
        } else {
          if ( (item.role === null) || !item.role) {
            vm.roleErrorMessage = true;
          }
        }
      });
    });

    if (!vm.roleErrorMessage) {
      EstimatesApi.getDictionaryRoles().then(function(response) {
        if (!response) {
          return;
        }
        vm.dictionaryRoles = response.roles ? response.roles : [];
        vm.currencies = response.currency ? response.currency : [];
        
        vm.data.currency = vm.currencies.length ? vm.currencies[0]._id : '';
        vm.data.roles = vm.reduced.map(function(role) {
          return getRoleData(role.role);
        });
        ExportExcelService.getDataExport(vm.est._id).then(function(resp) {
          var isEmptyObject = true;
          vm.isManager = resp.isManager; // Право на просмотр стоимости в оценке, только для менеджеров.
          for (var i in resp.lastExportSettings) {
            if (resp.lastExportSettings.hasOwnProperty(i)) {
              isEmptyObject = false;
            }
          }
          vm.messageError = response.errors || vm.messageError;
          if (!isEmptyObject) {
            var currencyIndex = vm.currencies.findIndex(function(currencyItem) {
              return currencyItem._id === resp.lastExportSettings.currency;
            });
            if (currencyIndex !== -1) {
              vm.data.currency = resp.lastExportSettings.currency;
            }
            //vm.data.risks = resp.lastExportSettings.risks;
            resp.lastExportSettings.roles.forEach(function(lastRole) {
              var roleIndex = vm.data.roles.findIndex(function(roleItem) {
                return lastRole._id === roleItem._id;
              });
              if (roleIndex !== -1 && lastRole.dict[vm.data.currency] && lastRole.dict[vm.data.currency].value) {
                vm.data.roles[roleIndex].dict[vm.data.currency] = lastRole.dict[vm.data.currency];
              }
            });
          }
          totalSumm();
          unwatch = $scope.$watch(function() {
            return vm.data;
          }, totalSumm, true);
        });
      });
    }

    function getRoleData(role) {
      var roleId = null;
      var newRole = null;

      if (role) {
        roleId = role._id || role;
        var index = vm.dictionaryRoles.findIndex(function(dictionaryRole) {
          return roleId === dictionaryRole._id || roleId === dictionaryRole.name; //TODO:change name property
        });
        newRole = (index === -1) ? role : vm.dictionaryRoles[index];
        if (role._id === newRole.name) {
          newRole._id = newRole.name;
        }
        newRole.dict = {};
        if (newRole.costs) {
          newRole.costs.forEach(function(cost) {
            newRole.dict[cost.currency] = cost;
          });
        }
      }
      return newRole;
    }

    function getArr(dict, id) {
      var arr = [];
      for (var p in dict) {
        if (p === id) {
          arr.push(dict[p]);
        }
      }
      return arr;
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    function totalSumm() {
      var sumProject = '';
      switch (vm.data.format) {
        case 'range':
          sumProject = getMessageSumm('minHours', 'maxHours');
          break;
        case 'pert':
          sumProject = getMessageSumm('E68', 'E95');
          break;
      }
      return sumProject;
    }

    function getMessageSumm(fieldMin, fieldMax) {
      vm.sum = '';
      vm.curren = '';
      var max = 0;
      var min = 0;
      var allFilled = true;
      var valueCost = null;
      vm.data.roles.forEach(function(element) {
        if (element) {
          valueCost = +element.dict[vm.data.currency].value;
          if (valueCost <= 0) {
            allFilled = false;
            return;
          }
          var i = vm.reduced.findIndex(function(argument) {
            var argRoleID = null;
            if (argument.role) {
              argRoleID = argument.role._id || argument.role;
            }
            return element._id === argRoleID || element.name === argRoleID; //TODO:change name property
          });
          if (i !== -1) {
            var roleEst = vm.reduced[i];
            max = +roleEst[fieldMax] * valueCost + max;
            min = +roleEst[fieldMin] * valueCost + min;
          }
        }
      });
      if (allFilled) {
        var risk = 1 + (+vm.data.risks) / 100;
        var cur = vm.currencies.find(function(argument) {
          return vm.data.currency === argument._id;
        });
        vm.sum = Math.round(min * risk).toLocaleString() + ' — ' + Math.round(max * risk).toLocaleString();
        vm.curren = ' (' + cur.name + ').';
      }
    }

    function save(blob, fileName) {
      if ($window.navigator.msSaveOrOpenBlob) { // For IE:
        navigator.msSaveBlob(blob, fileName);
      } else { // For other browsers:
          var link = document.createElement('a');
          link.href = $window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          $window.URL.revokeObjectURL(link.href);
      }
    }

    function exportDialog() {
      vm.data.roles.forEach(function(role) {
        if (role) {
          role.costs = getArr(role.dict, vm.data.currency);
        }
      });
      vm.data.estimate = angular.copy(vm.est);
      vm.data.estimate.risk = vm.data.risks;
      vm.data.estimate.statistic.risk = vm.data.risks;
      vm.data.estimate.statistic.reduced = vm.reduced;
      statisticComposer.compose(vm.data.estimate.statistic);
      if (vm.messageError.length === 0) {
        ExportExcelService.exportExcel(vm.est._id, vm.data).then(function(response) {
          var fileName = vm.est.name + '.xlsx';
          // Может выгружать только xlsx и csv
          save(new Blob([response.data], { type: response.headers('Content-Type') }), fileName);
          vm.close();
        }, function(error) {
          $log.error(error);
        });
      }
    }

  }
})(angular, angular.module('estimateMeUi'));

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .controller('EstimateEditPhaseController', EstimateEditPhaseController);

  /** @ngInject */
  function EstimateEditPhaseController($scope, $log, $location, $q, $anchorScroll, $timeout, $state, $stateParams, EstimatesApi, header,
   currentTab, BreadCrumbs, $mdDialog, PhaseState, Mediator, Access, project, NotificationManager) {
    var vm = this;
    vm.showError = false;
    vm.project = project;
    vm.phaseWithStatistics = {};
    vm.preloader = true;
    vm.phases = [];

    //infinite scroll
    vm.page = 1;
    vm.busy = true;
    vm.endPage = true;
    vm.isLocked = vm.project.isLocked;
    vm.isSU = false;
    vm.workhours = {};
    vm.getTemplateTask = getTemplateTask;
    vm.isOpen = false;
    vm.addFilledTask = addFilledTask;
    vm.canEdit = Access.checkActionPermission(
      {
        action: 'update',
        owners: vm.project.authors,
        /*participants: project.participants,*/
        entity: 'estimate'
      }
    );
    vm.initialization = initialization;
    vm.isFeature = false;


    $q.all([getUserEditRight(), getPhaseData(), getRolesData(), getGroupsDictionary(), getTasksDictionaty()]).then(function() {
      if (angular.isFunction(vm.initialization)) {
        vm.initialization();
      }
    });

    /*phase statisctic*/
    var events = Mediator.eventList;

    function updatePhase(n, o) {
      Mediator.publish(events.phaseChanged, vm.phase);
      if (!angular.equals(n, o)) {
        setPhaseStatus(false);
      }
    }

    function initialization() {
      vm.preloader = false;
      vm.items = vm.phase.items.slice(0, 10);
      getTemplatesTasks();
      if (vm.project.phases) {
        var phaseIndex = vm.project.phases.findIndex(function(p) {
          return p._id === vm.phase._id;
        });
        if (phaseIndex >= 0) {
          vm.phaseWithStatistics = vm.project.phases[phaseIndex];
        }
      }
      vm.deleteCrumb = BreadCrumbs.addCrumbs({name: vm.phase.name, limit: 50, limitIfLast: 50});
      $scope.$watch('vm.phase.name', function() {
        vm.deleteCrumb(vm.phase.name);
      });
      $scope.$on('PhaseNameChanged', function(event, phase) {
        if (phase._id === vm.phase._id) {
          vm.deleteCrumb(phase.name);
        }
      });

      PhaseState.setPhaseState(vm.phase);
      currentTab.setTab({
        type: 'phase',
        data: vm.phase
      });
    }

    function getDictionaryTags() {
      return EstimatesApi.getDictionaryTags().then(function(response) {
        vm.phases = response.content;
        if (angular.isArray(vm.phases) && vm.phase._original) {
          vm.currentPhaseIndex = vm.phases.findIndex(function(phase) {
            return phase._id === vm.phase._original;
          });
        }
      }).catch(function() {
      });
    }

    function getPhaseData() {
      return EstimatesApi.getPhase($stateParams.phase).then(function(phase) {
        vm.phase = phase;
        return getDictionaryTags();
      }, function(err) {
        if (err.status === 404) {
          NotificationManager.notifyMe('notFind', 'Фаза не найдена');
          $state.go('index.estimates.edit', {estimate: $stateParams.estimate});
        }
        if (err.status === 500) {
          NotificationManager.notifyMe('notFind', 'Фаза не найдена');
          $state.go('index.estimates.edit', {estimate: $stateParams.estimate});
        }
      }
      );
    }

    function getRolesData() {
      return EstimatesApi.getDictionaryRoles().then(function(response) {
        var rolesList = [];
        if (response.roles) {
          rolesList = response.roles.filter(function(role) {
            return role && role.name !== 'qa' && role.name !== 'pm';
          });
        }
        vm.roleList = rolesList;
      });
    }

    function getGroupsDictionary() {
      var q = $q.defer();
      var accessGranted = Access.checkActionPermission({
        entity: 'group',
        action: 'list'
      });
      if (accessGranted) {
        EstimatesApi.getDictionaryGroups().then(function(responses) {
          responses.content.map(function(feature) {
            feature.type = 'feature';
          });
          vm.groupsDictionary = responses.content;
          q.resolve(responses.content);
        }).catch(function() {
          q.reject();
        });
      } else {
        vm.groupsDictionary = [];
        q.resolve([]);
      }

      return q.promise;
    }

    function getTasksDictionaty() {
      var q = $q.defer();
      var accessGranted = Access.checkActionPermission({
        entity: 'workhour',
        action: 'list'
      });
      if (accessGranted) {
        EstimatesApi.getDictionaryWorkhours().then(function(responses) {
          var tasksArr = [];
          responses.map(function(task) {
            task.type = 'task';
          });
          vm.allTasksDictionary = responses;
            tasksArr = responses.filter(function(elem) {
              return elem.useSearch;
            });
          vm.tasksDictionaty = tasksArr;
          q.resolve(tasksArr);
        }).catch(function() {
          q.reject();
        });
      } else {
        vm.tasksDictionaty = [];
        q.resolve([]);
      }
      return q.promise;
    }

    function getUserEditRight() {
      var q = $q.defer();
      EstimatesApi.isRootUser().then(function(response) {
        vm.isSU = response; // is Super user
        q.resolve();
      }).catch(function(err) {
        q.reject(err.data);
      });

      return q.promise;
    }

    function getTemplatesTasks() {
      vm.workhours = {};

      vm.phase.items.forEach(function(item) {
        if (item.tasks) {
          item.tasks.forEach(function(task) {
            getTemplateTask(task);
          });
        } else {
          getTemplateTask(item);
        }
      });
    }

    function getTemplateTask(task) {
      if (task._original) {
        var workhour = vm.allTasksDictionary.find(function(elem) {
          return elem._id === task._original;
        });
        vm.workhours[task._id] = workhour ? workhour : getDictionaryWorkhourById(task._original, task._id);
      }
    }

    function getDictionaryWorkhourById(idTempl, idTask) {
      var accessGranted = Access.checkActionPermission({
        entity: 'workhour',
        action: 'view'
      });
      if (accessGranted) {
        EstimatesApi.getDictionaryWorkhourById(idTempl).then(function(res) {
          vm.workhours[idTask] = res;
        });
      }
    }

    $scope.phaseTree = { // eslint-disable-line
      accept: function(sourceNodeScope, destNodesScope) {
        var sourceType = sourceNodeScope.$element.attr('data-type');
        var destType = destNodesScope.$parent.$element.attr('data-type');
        if ((sourceType === 'feature' && angular.isDefined(destType)) || destType === 'task') {
          return false;
        } else {
          return true;
        }
      },

      dropped: function(event) {
        var data = {
          taskId: '',
          targetId: null,
          parentId: null
        };
        var task;
        var index = event.dest.index;

        //на то же место
        if (event.dest.nodesScope.$parent.$id === event.source.nodesScope.$parent.$id) {
          if (event.dest.index === event.source.index) {
            return false;
          }
        }

        if (event.source.nodeScope.task) {
          //таск находится в фиче
          task = event.source.nodeScope.task;
          data.taskId = task._id;

          if (event.dest.nodesScope.$nodeScope === null) {
            vm.phase.items.splice(event.dest.index, 0, task);
            //перемещен в корень фазы
          } else {
            //перемещен в фичу
            data.parentId = event.dest.nodesScope.$nodeScope.item._id;
          }
        } else {
          //таск в корне фазы
          task = event.source.nodeScope.item;
          data.taskId = task._id;
          vm.phase.items.splice(event.source.index, 1);

          if (event.dest.nodesScope.$nodeScope === null) {
            vm.phase.items.splice(event.dest.index, 0, task);
            //перемещен в корень фазы
          } else {
            //перемещен в фичу
            data.parentId = event.dest.nodesScope.$nodeScope.item._id;
          }
        }

        /*временное решение до выхода фикса модуля, начало*/
          if (index !== 0) {
          //не в начало списка
            var destLength = event.dest.nodesScope.$modelValue.length;
            var indexDiff = index - destLength;
            data.targetId = event.dest.nodesScope.$modelValue[(indexDiff < 0 ? index - 1 : index - 2)]._id;
          }
        /*временное решение, конец*/

        EstimatesApi.updatePhaseOrder(vm.phase._id, data).then(function(response) {
          NotificationManager.notifyMe('save', response.data);
        }, function(error) {
          NotificationManager.notifyMe('error', error.data);
        });
      }
    };

    vm.collapseAll = function() {
      vm.nextPage();
      //nextPage() добавляет новые элементы в DOM, для построения и обработки вынуждено использование timeout
      $timeout(function () {
        $scope.$broadcast('angular-ui-tree:collapse-all');
      });
    };

    vm.expandAll = function() {
      $scope.$broadcast('angular-ui-tree:expand-all');
    };

    $scope.$on('$destroy', function() {
      vm.initialization = false;
      if (vm.deleteCrumb) {
        vm.deleteCrumb();
      }
      if (angular.isFunction(vm.watchPhase)) {
        vm.watchPhase();
      }
    });

    vm.finishRenderPartPhase = function() {
      if (!angular.isFunction(vm.watchPhase)) {
        vm.watchPhase = $scope.$watch(function() {
          return vm.phase.items;
        }, updatePhase, true);
      }
      vm.busy = vm.maxPage === vm.page;
      if (vm.maxPage) {
        vm.endPage = vm.busy;
      }
      if (vm.addEntityByFab) {
        $location.hash('typeahead-form');
        $anchorScroll();
        vm.addEntityByFab = false;
      }
    };

    vm.nextPage = function() {
      if (vm.busy) {return;}
      vm.busy = true;
      vm.maxPage = Math.ceil(vm.phase.items.length / 10);
      if (vm.page < vm.maxPage) {
        vm.page += 1;
      }
      vm.items = vm.phase.items.slice(0, vm.page * 10);
    };

    vm.closeFab = function() {
      vm.isOpen = false;
    };

    vm.openFab = function(e) {
      e.stopPropagation();
      vm.isOpen = true;
    };

    vm.undoTaskToTemplate = function(task, parent) {
      if (vm.workhours[task._id]) {
        var idFeature;
        if (parent.type === 'feature') {
          idFeature = parent._id;
        }
        task.minHours = vm.workhours[task._id].minHours;
        task.maxHours = vm.workhours[task._id].maxHours;
        task.custom = false;
        PhaseState.compareTaskInCurrentPhase(task, ['minHours', 'maxHours'], idFeature);
      }
    };

    vm.deleteFeature = function(event, feature) {
      var el = angular.element(event.currentTarget);
      el.blur();
      if (feature.type === 'feature') {
        $mdDialog.show(
          $mdDialog.confirm()
            .title('Внимание!')
            .content('Вы действительно хотите удалить фичу?')
            .targetEvent(event)
            .ok('ОК')
            .cancel('Отмена')
          ).then(function() {
            EstimatesApi.deleteFeature(feature).then(function() {
              var i = vm.phase.items.findIndex(function(item) {
                return feature._id === item._id;
              });
              if (i > -1) {
                vm.phase.items.splice(i, 1);
                var j = vm.items.findIndex(function(item) {
                  return feature._id === item._id;
                })
                if (j > -1) {
                  vm.items.splice(j, 1);
                }
              }
              PhaseState.updatePhaseState('delete', feature);
            });
          });
      }
    };

    vm.deleteTask = function(event, task, parent) {
      var el = angular.element(event.currentTarget);
      el.blur();
      if (task.type === 'task') {
      $mdDialog.show(
        $mdDialog.confirm()
          .title('Внимание!')
          .content('Вы действительно хотите удалить задачу?')
          .targetEvent(event)
          .ok('ОК')
          .cancel('Отмена')
        ).then(function() {
          EstimatesApi.deleteTask(task).then(function() {
            var itemsList = parent.items || parent.tasks;
            var i = itemsList.findIndex(function(item) {
              return task._id === item._id;
            });

            if (i > -1) {
              itemsList.splice(i, 1);
              i = vm.items.findIndex(function(item) {
                return task._id === item._id;
              });
              if (i >= 0) {
                vm.items.splice(i, 1);
              }
            }
            PhaseState.updatePhaseState('delete', task, (parent._id !== vm.phase._id) ? parent._id : undefined);
          });
        });
      }
    };

    function addFilledTask(event, task) {
      if (angular.isDefined(task) && task.name) {
        var taskList = {
          customNames: [task.name],
          templateIds: []
        };
        EstimatesApi.addTasks(vm.phase._id, taskList).then(function(response) {
          response[0].count = task.count || 1;
          task.count = 1;
          response[0].description = task.description;
          task.description = '';
          response[0].maxHours = task.maxHours || 0;
          task.maxHours = 0;
          response[0].minHours = task.minHours || 0;
          task.minHours = 0;
          response[0].role = {};
          angular.copy(task.role, response[0].role);
          task.role = {};
          task.name = '';
          if (angular.isFunction(vm.setNewTaskFormUntouched)) {
            vm.setNewTaskFormUntouched();
          }
          vm.showError = false;
          response.forEach(function(task) {
            vm.addTask();
            task.type = 'task';
          });
          [].push.apply(vm.phase.items, response);
          [].push.apply(vm.items, response);
          EstimatesApi.updateTask(response[0])
            .then(function(result) {
              $log.log('task:', result);
            }, function(error) {
              $log.error(error);
            });
        });
      } else {
        vm.showError = true;
      }
    }

    vm.addCallbackOnNewTaskCreation = function(callback) {
      vm.setNewTaskFormUntouched = callback;
    };

    vm.addNewFeature = function(event) {
      event.stopPropagation();
      $mdDialog.show({
          targetEvent: event,
          locals: {
            isShowTemplate: true,
            isShowCustom: true,
            phases: vm.phases,
            currentPhase: {
              id: vm.phase._original,
              selected: vm.currentPhaseIndex,
              name: vm.phase.name
            }
          },
          controller: 'EstimateEditNewFeatureModalController',
          controllerAs: 'vm',
          templateUrl: '/app/components/views/estimateNewFeature.html',
          clickOutsideToClose: true,
          fullscreen: true
        }).then(function(response) {
          if (response) {
            var bufferFeatures = response.bufferFeatures;
            var listPatterns = response.listPatterns;
            var phaseId = vm.phase._id;
            if (angular.isUndefined(phaseId)) {
              return;
            }
            vm.busy = true;
            vm.endPage = false;
            var featureList = {
              customNames: bufferFeatures,
              templateIds: listPatterns
            };
            EstimatesApi.addFeatures(phaseId, featureList).then(function(response) {
              vm.phase.items = response;
              afterAddByFab(response);
              PhaseState.updatePhaseState('add', response);
            });
          }
        });
    };

    vm.addNewTask = function(event) {
      event.stopPropagation();
      $mdDialog.show({
        targetEvent: event,
        locals: {
          isShowTemplate: true,
          isShowCustom: true,
          phases: vm.phases,
          currentPhase: {
            id: vm.phase._original,
            selected: vm.currentPhaseIndex
          },
          parentItem: {
            name: vm.phase.name,
            isPhase: true
          }
        },
        controller: 'EstimateEditNewTaskModalController',
        controllerAs: 'vm',
        templateUrl: '/app/components/views/estimateNewTask.html',
        clickOutsideToClose: true,
        fullscreen: true
      }).then(function(response) {
        if (response) {
          var role = getLastTaskRole();
          var listPatterns = response.listPatterns;
          var phaseId = vm.phase._id;
          if (angular.isUndefined(phaseId)) {
            return;
          }
          vm.busy = true;
          vm.endPage = false;
          var taskList = {
            customNames: [],
            templateIds: listPatterns
          };
          if (response.bufferTasks.length > 0) {
            taskList.customNames[0] = {name: response.bufferTasks[0], role: role};
          }
          EstimatesApi.addTasks(phaseId, taskList).then(function(response) {
            [].push.apply(vm.phase.items, response);
            afterAddByFab(response);
            PhaseState.updatePhaseState('add', response);
          });
        }
      });
    };

    function afterAddByFab(response) {
      vm.items = vm.phase.items.slice(0, vm.phase.items.length);
      vm.addEntityByFab = true;
      vm.page = vm.maxPage = vm.maxPage || 1;
      response.forEach(function(item) {
        if (item.tasks) {
          item.tasks.forEach(function(task) {
            getTemplateTask(task);
          });
        } else {
          getTemplateTask(item);
        }
      });
    }

    vm.copyTaskInFeature = function(event, task, feature) {
      var indexFeature = vm.phase.items.findIndex(function(item) {
        return item._id === feature._id && item.type === 'feature';
      });
      var indexTask = feature.tasks.findIndex(function(item) {
        return item._id === task._id;
      });
      EstimatesApi.copyTaskInFeature(feature._id, task).then(function(res) {
        vm.phase.items[indexFeature].tasks.splice(indexTask, 0, res);
        getTemplateTask(res);
        PhaseState.updatePhaseState('copy', {copy: res, id: task._id}, feature._id);
        vm.page = vm.maxPage;
      });
    };

    vm.copyTask = function(event, task) {
      var index = vm.phase.items.findIndex(function(item) {
        return item._id === task._id;
      });
      EstimatesApi.copyTask(vm.phase._id, task).then(function(res) {
        vm.phase.items.splice(index + 1, 0, res);
        vm.items.splice(index + 1, 0, res);
        getTemplateTask(res);
        PhaseState.updatePhaseState('copy', {copy: res, id: task._id});
        vm.page = vm.maxPage;
      });
    };

    vm.copyFeature = function(event, feature) {
      var index = vm.phase.items.findIndex(function(item) {
        return item._id === feature._id;
      });
      EstimatesApi.copyFeature(vm.phase._id, feature).then(function(res) {
        vm.phase.items.splice(index + 1, 0, res);
        if (vm.items.findIndex(function(item) {
            return item._id === res._id;
        }) < 0) {
          vm.items.splice(index + 1, 0, res);
        }
        res.tasks.forEach(function(task) {
          getTemplateTask(task);
        });
        PhaseState.updatePhaseState('copy', {copy: res, id: feature._id});
        vm.page = vm.maxPage;
      });
    };

    /* Alexei Andrianov */
    vm.newCustomItem = function(isFeature, text) {
      if (!isFeature) {
        var role = getLastTaskRole();
        EstimatesApi.addTasks(vm.phase._id, {
          customNames: [{name: text, role: role}]
        }).then(function(response) {
          [].push.apply(vm.phase.items, response);
          vm.items = vm.phase.items.slice(0, vm.phase.items.length);
          PhaseState.updatePhaseState('add', response);
          vm.page = vm.maxPage;
        });
      } else {
        EstimatesApi.addFeatures(vm.phase._id, {
          customNames: [text]
        }).then(function(response) {
          [].push.apply(vm.phase.items, [response[response.length - 1]]);
          vm.items = vm.phase.items.slice(0, vm.phase.items.length);
          PhaseState.updatePhaseState('add', response);
          vm.page = vm.maxPage;
        });
      }
    };
    vm.newExistingItem = function(item) {
      if (item.type === 'task') {
        EstimatesApi.addTasks(vm.phase._id, {
          templateIds: [{id: item._id}]
        }).then(function(response) {
          [].push.apply(vm.phase.items, response);
          vm.items = vm.phase.items.slice(0, vm.phase.items.length);
          getTemplateTask(response[0]);
          PhaseState.updatePhaseState('add', response);
          vm.page = vm.maxPage;
        });
      } else {
        EstimatesApi.addFeatures(vm.phase._id, {
          templateIds: [item._id]
        }).then(function(response) {
          [].push.apply(vm.phase.items, [response[response.length - 1]]);
          vm.items = vm.phase.items.slice(0, vm.phase.items.length);
          getTemplatesTasks();
          PhaseState.updatePhaseState('add', response);
          vm.page = vm.maxPage;
        });
      }
    };
    vm.changePhaseStatus = function() {
      vm.phase.isReady = !vm.phase.isReady;
      savePhaseStatus();
    };

    function getLastTaskRole() {
      var lastTaskRole;
      var itemsLength = vm.phase.items.length - 1;
      while (itemsLength >= 0 && angular.isUndefined(lastTaskRole)) {
        if (angular.isDefined(vm.phase.items[itemsLength].role)) {
          lastTaskRole = vm.phase.items[itemsLength].role;
        }
        itemsLength--;
      }
      return lastTaskRole || vm.roleList[0];
    }

    function setPhaseStatus(phaseStatus) {
      if (vm.phase.isReady !== phaseStatus) {
        vm.phase.isReady = phaseStatus;
        savePhaseStatus();
      }
    }

    function savePhaseStatus() {
      vm.phaseWithStatistics.isReady = vm.phase.isReady;
      var newPhaseParams = {
        _id: vm.phase._id,
        estimate: vm.project._id,
        isReady: vm.phase.isReady
      };
      EstimatesApi.updatePhase(newPhaseParams);
    }

    vm.hasRightToEdit = function() {
      return vm.canEdit && (!vm.isLocked || vm.isSU);
    };

    vm.setIsFeature = function(isFeature) {
      vm.isFeature = isFeature;
    };
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .controller('EstimateEditController', EstimateEditController);

  /** @ngInject */
  function EstimateEditController($scope, $log, $rootScope, $localStorage, EstimatesApi, $mdDialog, $stateParams, $document,
      $q, $timeout, header, project, currentTab, $controller, BreadCrumbs, Mediator, $state,
      FileUploader, API_URL, FileUploadService, PhaseState, ExportExcelService, Access, NotificationManager, roles) {
    var vm = this;
    var COPY_PHASE = 'copiedPhaseId';
    vm.statistic = null;
    vm.list = [];
    vm.project = project;
    vm.estimateID = $stateParams.estimate;
    vm.currentTab = currentTab.getTab;
    vm.refreshEstimate = refreshEstimate;
    vm.selectedIndex = -1;
    vm.roleList = roles.roles;
    vm.project.canEdit = Access.checkActionPermission(
      {
        action: 'update',
        owners: project.authors,
        /*participants: project.participants,*/
        entity: 'estimate'
      }
    );
    vm.project.canExport = Access.checkActionPermission(
      {
        action: 'export',
        owners: project.authors,
        /*participants: project.participants,*/
        entity: 'estimate'
      }
    );
    vm.showStatistic = $state.current.name === 'index.estimates.edit';
    var deleteCrumb1 = BreadCrumbs.addCrumbs(header);
    var deleteCrumb2 = BreadCrumbs.addCrumbs({
      name: vm.project.name,
      link: 'index.estimates.edit',
      props: {estimate: vm.project._id},
      limit: 20,
      limitIfLast: 70
    });
    vm.isLocked = vm.project.isLocked;
    vm.isSU = false;
    vm.hasRightToEdit = calculatePermissions();

    /* Tabs of PHASES handlers */
    vm.openEditPhase = openEditPhase;
    vm.reorderPhase = reorderPhase;
    vm.saveEditPhase = saveEditPhase;
    vm.deletePhase = deletePhase;
    vm.labelClick = labelClick;
    vm.labelKeyDown = labelKeyDown;
    vm.bufferList = [];


    /* Modal windows handlers */
    vm.newPhase = newPhase;
    vm.readyToEdit = false;
    vm.saveRisks = saveRisks;
    vm.excelExport = excelExport;
    vm.oldSelectedIndex = vm.selectedIndex;
    vm.canCopyPhase = canCopyPhase;
    vm.copyPhase = copyPhase;
    vm.canPastePhase = canPastePhase;
    vm.pastePhase = pastePhase;

    vm.actions = {
      edit: {
        show: $state.current.name !== 'index.estimates.edit.phases',
        message: $state.current.name === 'index.estimates.edit'
      },
      addMenu: false,
      undo: false,
      redo: false
    };

    vm.estimateEditUrl = null;//адрес редактирования оценки

    $scope.$on('$destroy', function() {
      deleteCrumb1();
      deleteCrumb2();
      updateStat();
      remComposerListener();
    });

    $scope.$on('EstimateStatusChanged', function(scope, isLocked) {
      vm.isLocked = isLocked;
      vm.project.isLocked = isLocked;
      vm.hasRightToEdit = calculatePermissions();
    });

    $scope.$on('RootUserChanged', function(scope, isRoot) {
      vm.isSU = isRoot;
      vm.hasRightToEdit = calculatePermissions();
    });

    function calculatePermissions() {
      return vm.project.canEdit && (!vm.isLocked || vm.isSU);
    }

    $scope.$watch('vm.project.name', function() {
      deleteCrumb2(vm.project.name);
    });

    /*statistics*/
    var events = Mediator.eventList;
    var remComposerListener = Mediator.subscribe(events.estimateComposingFinished, function(statistic) {
      if (statistic.reduced) {
        checkRolesNames(statistic.reduced);
      }
      vm.statistic = statistic;
      vm.project.statistic = statistic;
    });
    function checkRolesNames(reduced) {
      reduced.forEach(function(group) {
        if (group.role && angular.isString(group.role)) {
          var roleIndex = vm.roleList.findIndex(function(role) {
            return role._id === group.role;
          });
          if (roleIndex !== -1) {
            group.role = {};
            group.role._id = vm.roleList[roleIndex]._id;
            group.role.name = vm.roleList[roleIndex].name;
          }
        }
      });
    }
    Mediator.publish(events.initStatistic, vm.project);
    vm.updateStatisticWithRisk = updateStatictic;

    function updateStatictic() {
      Mediator.publish(events.risksEstimateChange);
    }

    /*uploader*/
    var support = FileUploadService.support();
    $scope.uploader = new FileUploader({ // eslint-disable-line
      url: API_URL + 'estimates/' + vm.project._id + '/files/',
      headers: {Authorization: 'Bearer ' + $localStorage.userToken.token},
      fn: function(item) {
          return support || FileUploadService.isFile(item);
        }
    });
    $scope.uploader.isThumb = function(file) {
      return FileUploadService.isImage(file);
    };

    function labelKeyDown(event) {
      if (!vm.readyToEdit) {
        return;
      }
      event.stopPropagation();
      if (event.key.toLowerCase() == 'enter') {
        vm.saveEditPhase();
      }
    }

    function labelClick(event) {
      if (vm.readyToEdit) {
        event.stopPropagation();
      }
    }

    var savedRisks = vm.project.risk;
    function saveRisks() {
      if (!vm.project.risk) {
        vm.project.risk = 0;
      }
      if (vm.project.risk !== savedRisks) {
        var estimate = {};
        estimate._id = vm.project._id;
        estimate.risk = vm.project.risk;
        EstimatesApi.updateEstimate(estimate, vm.project.authors/*, vm.project.participants*/)
          .then(function(res) {
          savedRisks = vm.project.risk;
          vm.project.riskHistory = res.data.riskHistory;
          });
      }
    }

    function updateStat() {
      EstimatesApi.updateStatistic(vm.statistic, vm.project._id).
        then(function() {
          Mediator.publish('statistic_update', vm.project._id);
        }, function(error) {
          $log.error(error);
        });
    }

    function excelExport(e, est, index) {
      if (vm.project.canExport) {
        e.stopPropagation();
        ExportExcelService.openExportExcelWindow(e, est, index);
      }
    }

    function refreshEstimate() {
      if ($stateParams.estimate) {
        EstimatesApi.getEstimate($stateParams.estimate)
          .then(function(response) {
            if (response) {
              var projectInfo = response || {};
              angular.copy(projectInfo, vm.project);
            }
          },
          function(reject) {
            $log.error(reject.status);
          });
      }
    }

    function newPhase(event) {
      event.stopPropagation();
      $mdDialog.show({
          targetEvent: event,
          locals: {
            isShowTemplate: true,
            phasesLength: vm.project.phases.length
          },
          controller: 'EstimateEditNewPhaseModalController',
          controllerAs: 'vm',
          templateUrl: '/app/components/views/estimateNewPhase.html',
          clickOutsideToClose: true,
          fullscreen: true
        }).then(
        function(response) {
          if (response) {
            var bufferPhases = response.bufferPhases;
            var listPatterns = response.listPatterns;
            var i;
            var estId = vm.project._id;
            var data = {
              customNames: bufferPhases,
              templateIds: listPatterns
            };
            EstimatesApi.addPhases(estId, data).then(function(response) {
              if (response) {
                if (angular.isString(response)) {
                  $mdDialog.show(
                    $mdDialog.alert()
                      .title('Внимание!')
                      .content(response)
                      .ok('OK'));
                } else {
                  [].push.apply(vm.project.phases, response);
                  $state.go('index.estimates.edit.phases', {phase: response[0]._id});
                  Mediator.publish(events.initStatistic, vm.project);
                }
              }
            });

            /* Adding pattern-phases into project */
            for (i = 0; i < listPatterns.length; i++) {
              if (listPatterns[i].checked) {
                vm.project.phases.push({_id: listPatterns[i]._id, name: listPatterns[i].name, items: []});
              }
            }
          }
        }
      );
    }

    vm.isTabActive = function(phaseID) {
      return vm.currentTab().type === 'phase' && vm.currentTab().data._id === phaseID;
    };

    vm.isAboutTabActive = function() {
      return vm.currentTab().type === 'estimate';
    };

    function canCopyPhase() {
      return vm.project.phases.length > 0 && vm.currentTab().type === 'phase';
    }

    function canPastePhase() {
      return vm.getCopiedPhase() != null;
    }

    vm.selectedIndexAbout = (vm.currentTab().type === 'estimate') ? 0 : -1;

    vm.onPhaseSelected = function(to, params) {
      if ($state.current.name === 'index.estimates.edit.edit' && to === 'index.estimates.edit') {
        if (vm.estimateEditUrl) {
          to = vm.estimateEditUrl;
        } else { return; }
      }
      if (!vm.readyToEdit) {
        switch (to) {
          case 'index.estimates.edit.phases':
            vm.selectedIndexAbout = -1;
            vm.actions.edit.show = false;
            vm.showStatistic = false;
            break;
          case 'index.estimates.edit':
            vm.selectedIndex = -1;
            vm.actions.edit.show = true;
            vm.edit = true;
            vm.actions.save = false;
            vm.showStatistic = true;
            break;
          case 'index.estimates.edit.edit':
            vm.selectedIndex = -1;
            vm.actions.edit.show = true;
            vm.edit = false;
            vm.actions.save = true;
            vm.showStatistic = false;
            break;
        }
        $state.go(to, params);
        vm.oldSelectedIndex = vm.selectedIndex;
      } else {
        if (vm.currentTab().type === 'phase') {
          vm.selectedIndex = vm.oldSelectedIndex;
          vm.selectedIndexAbout = -1;
        } else {
          vm.selectedIndex = -1;
          vm.selectedIndexAbout = 0;
        }
      }
    };

    vm.onActionSelected = function() {
      vm.selectedIndex = vm.oldSelectedIndex;
    };

    function openEditPhase() {
      vm.readyToEdit = true;
      $document.on('click', onDocumentClick);
      vm.bufferList = [];
      vm.project.phases.forEach(function(element) {
        var phase = {};
        phase._id = element._id;
        phase.name = element.name;
        vm.bufferList.push(phase);
      });
    }

    function reorderPhase(event) {
      event.stopPropagation();
      var phases = vm.project.phases;
      $mdDialog.show({
          targetEvent: event,
          locals: {
            isShowTemplate: true,
            phases: phases
          },
          controller: 'EstimateEditReorderPhaseModalController',
          controllerAs: 'vm',
          templateUrl: '/app/components/views/estimateReorderPhase.html',
          clickOutsideToClose: true,
          fullscreen: true
        }).then(
        function(response) {
          if (!response) {
            return;
          }
          var phasesReordered = response.phasesReordered;
          EstimatesApi.updateEstimateReorderPhases(vm.estimateID, phasesReordered)
            .then(function() {
              phasesReordered.forEach(function(element, i) {
                var index = phases.findIndex(function(item) {
                  return item._id === element._id;
                });
                if (index > -1) {
                  phases[index].index = i;
                }
              });
            });
        }
      );
    }

    function onDocumentClick(event) {
      var parent = event.target;
      var tabs = $document[0].getElementById('phases-tab-toolbar');
      while (parent && parent !== tabs && parent.nodeName !== 'MD-DIALOG') {
        parent = parent.parentNode;
      }
      if (!parent) {
        $scope.$apply(saveEditPhase());
        $document.off('click', onDocumentClick);
      }
    }

    function saveEditPhase() {
      var savePhases = [];
      vm.project.phases.forEach(function(element) {
        var index = vm.bufferList.findIndex(function(item) {
          return element._id === item._id && element.name !== item.name;
        });
        if (index > -1) {
          element.name = element.name.trim();
          element.name = element.name.replace(/\s+/g, ' ');
           if (element.name.length > 0) {
             var changedPhase = {
               _id: element._id,
               name: element.name,
               estimate: element.estimate
             };
             $scope.$broadcast('PhaseNameChanged', changedPhase);
             savePhases.push(changedPhase);
           } else {
             element.name = vm.bufferList[index].name;
           }
        }
      });
      vm.readyToEdit = false;
      if (savePhases.length > 0) {
        EstimatesApi.updatePhases(savePhases).then(function() {
          $document.off('click', onDocumentClick);
        }, function(err) {
          $log.error('error:', err);
        });
      }
    }

    function deletePhase(event, phase) {
      var el = angular.element(event.currentTarget);
      el.blur();
      var currentPhase = vm.currentTab().data;
      var currentPhaseId = currentPhase ? currentPhase._id : '';
      var id = phase._id || phase;
      if (id) {
        $mdDialog.show(
          $mdDialog.confirm()
            .title('Внимание!')
            .content('Вы действительно хотите удалить фазу ' + phase.name + '?')
            .targetEvent(event)
            .ok('ОК')
            .cancel('Отмена')
          ).then(function() {
            EstimatesApi.deletePhase(vm.project, id).then(function() {
              var i = vm.project.phases.findIndex(function(phase) {
                return phase._id === id;
              });
              if (i > -1) {
                if (currentPhaseId === id) {
                  vm.oldSelectedIndex = -1;
                  $state.go('index.estimates.edit', {estimate: $stateParams.estimate}).then(function() {
                    vm.actions.edit.show = true;
                    vm.edit = true;
                    vm.actions.save = false;
                    vm.showStatistic = true;
                    vm.project.phases.splice(i, 1);
                    vm.readyToEdit = false;
                  });
                } else {
                  vm.project.phases.splice(i, 1);
                }
                Mediator.publish(events.initStatistic, vm.project);
              }
            });
          });
      }
    }

    vm.isCustomerProvided = function() {
      return vm.project.customer && vm.project.name;
    };

    vm.editAbout = function(event) {
      if ($state.current.name === 'index.estimates.edit') {
        vm.edit = false;
        vm.showStatistic = false;
        vm.estimateEditUrl = 'index.estimates.edit.edit';
        $state.go('index.estimates.edit.edit', {estimate: $stateParams.estimate});
      } else {
        if (vm.project.authors.length > 0) {
          vm.edit = true;
          vm.showStatistic = true;
          if (vm.project.phases.length === 0) {
            newPhase(event);
          }
          $state.go('index.estimates.edit', {estimate: $stateParams.estimate});
        } else {return;}
      }

    };

    function copyPhase() {
      if (vm.currentTab() && vm.currentTab().data) {
        var currentPhase = vm.currentTab().data;
        var tabId = currentPhase._id;
        vm.setCopiedPhase(tabId);
        NotificationManager.notifyMe('phaseCopied');
      }
    }

    function pastePhase() {
      EstimatesApi.pastePhaseIntoEstimate(vm.project._id, vm.getCopiedPhase())
        .then(function(phases) {
          if (angular.isString(phases)) {
            $mdDialog.show(
              $mdDialog.alert()
                .title('Внимание!')
                .content(phases)
                .ok('OK'));
          } else {
            vm.project.phases = phases || vm.project.phases;
          }
        });
      vm.setCopiedPhase(null);
    }

    vm.setCopiedPhase = function(phaseId) {
      $localStorage[COPY_PHASE] = phaseId;
    };

    vm.getCopiedPhase = function() {
      return $localStorage[COPY_PHASE];
    };

    /*check current roles in estimate*/
    function checkCurrentRoles() {
      vm.project.phases.forEach(function(phase) {
        phase.items.forEach(function(item) {
          if(item.type === 'feature') {
            item.tasks.forEach(function(task) {
              if (task.role && !vm.roleList.some(function(role) { return (role._id === task.role) || (role._id === task.role._id); }) ) {
                task.role = null;
              }
            });
          } else {
            if (item.role && !vm.roleList.some(function(role) { return (role._id === item.role) || (role._id === item.role._id); }) ) {
              item.role = null;
            }
          }
        });
      });
    }

    checkCurrentRoles();

    // /* WATCHERS PART */
    // var estimateListWatcher = $scope.$watch(function() {
    //   return vm.list;
    // }, vm.watcherList.bind(vm), true);
    //
    // $scope.$on('$destroy', function() {
    //   estimateListWatcher();
    // });
  }
})();

(function () {
  'use strict';

  angular.module('estimateMeUi')
    .controller('EstimateAboutEditController', EstimateAboutEditController);

  /** @ngInject */
  function EstimateAboutEditController(
    $scope,
    EstimatesApi,
    project,
    Preloader,
    /*usersStatuses,*/
    currentTab,
    $stateParams/*,
    $localStorage*/
  ) {
    var vm = this;
    currentTab.setTab({ type: 'estimate' });
    vm.project = project;
    vm.projectName = project.name = $stateParams.newEstimate ? null : project.name;
    //vm.projectLinkToCRM = project.linkToCRM;
    vm.projectDescription = project.description;
    vm.projectCustomer = project.customer;
    //vm.users = usersStatuses.users;
    //vm.participants = angular.copy(vm.project.participants);
    vm.newEstimate = $stateParams.newEstimate;
    vm.projectLocale = project.locale;
    vm.isLocked = project.isLocked;
    vm.querySearch = querySearch;
    vm.preloader = false;

    vm.estimateErrors = {
      estimatorDeleting: ''
    };

    //if (vm.isLocked) {
      // $state.go('index.estimates.edit', {estimate: $stateParams.estimate});
    //}

    var deleteListener = Preloader.addOpenListener(openPreloader);

    function openPreloader() {
      vm.preloader = true;
    }

    $scope.$on('$destroy', function () {
      deleteListener();
      //watchParticipants();
      //watchApprovers();
      //watchManagers();
    });

    /*var watchParticipants = $scope.$watch(function () {
      return vm.participants.length;
    }, function (newLen, oldLen) {
      if (newLen !== oldLen) {
        if (newLen === 0) {
          vm.participants = [];
          //vm.participants = angular.copy(vm.project.participants);
          vm.estimateErrors.estimatorDeleting = '';
        }
        if (!angular.equals(vm.project.participants, vm.participants)) {
          vm.estimateErrors.estimatorDeleting = '';
          vm.project.participants = angular.copy(vm.participants);
          vm.save('participants');
        }
      }
    }, true);*/

    /*var watchApprovers = $scope.$watch(function () {
      return vm.project.approvers.length;
    }, function (newlen, oldLen) {
      if (newlen !== oldLen) {
        vm.save('approvers');
      }
    }, true);*/

    /*var watchManagers = $scope.$watch(function () {
      return vm.project.managers.length;
    }, function (newlen, oldLen) {
      if (newlen !== oldLen) {
        vm.save('managers');
      }
    }, true);*/

    vm.save = function (field) {
      var estimate = {};
      switch (field) {
        case 'name':
          if (angular.isUndefined(vm.project.name)) {
            return;
          }
          if (vm.project.name !== vm.projectName) {
            estimate._id = vm.project._id;
            estimate.name = vm.project.name;
          }
          break;
        /*case 'participants':
          estimate._id = vm.project._id;
          estimate.participants = vm.project.participants;
          break;*/
        /*case 'approvers':
          estimate._id = vm.project._id;
          estimate.approvers = vm.project.approvers;
          break;
        case 'managers':
          estimate._id = vm.project._id;
          estimate.managers = vm.project.managers;
          break;*/
        /*case 'linkToCRM':
          if (vm.project.linkToCRM !== vm.projectLinkToCRM) {
            estimate._id = vm.project._id;
            if (vm.project.linkToCRM.indexOf('http') < 0) {
              vm.project.linkToCRM = 'http://' + vm.project.linkToCRM;
            }
            estimate.linkToCRM = vm.project.linkToCRM;
          }
          break;*/
        case 'customer':
          if (angular.isUndefined(vm.project.customer)) {
            return;
          }
          if (vm.project.customer !== vm.projectCustomer) {
            estimate._id = vm.project._id;
            estimate.customer = vm.project.customer;
          }
          break;
        case 'description':
          if (vm.project.description !== vm.projectDescription) {
            estimate._id = vm.project._id;
            estimate.description = vm.project.description;
          }
          break;
        case 'locale':
          estimate._id = vm.project._id;
          estimate.locale = vm.project.locale;
          break;
        default:
          break;
      }
      if (Object.keys(estimate).length !== 0) {
        EstimatesApi.updateEstimate(estimate, vm.project.authors/*, vm.project.participants*/).then(function (res) {
          project[field] = res.data[field];
        });
      }
    };

    function querySearch(query, array, prop, arrayProject) {
      if (query && query.length < 3) {
        return [];
      }
      var results = query ? array.filter(
        function filterFn(item) {
          var ind = arrayProject.findIndex(function (itemProject) {
            return itemProject._id === item._id;
          });
          if (item[prop]) {
            return (angular.lowercase(item[prop]).indexOf(angular.lowercase(query)) > -1 && ind === -1);
          } else {
            return false;
          }
        }) : array;
      return results;
    }

    vm.getFlag = function (locale) {
      return '/assets/images/' + locale + '.png';
    };
  }
})();
(function() {
  'use strict';

  angular.module('estimateMeUi')
    .controller('EstimateAboutController', EstimateAboutController);

  /** @ngInject */
  function EstimateAboutController($log, $q, project, usersStatuses, Preloader, $scope, currentTab, EstimatesApi,
      Access) {
    var vm = this;
    currentTab.setTab({type: 'estimate'});
    vm.project = project;
    vm.isLocked = vm.project.isLocked;
    vm.isSU = false;
    vm.statusesDictionary = usersStatuses.statuses;
    vm.statuses = usersStatuses.statuses;
    var status = vm.project.status._id;
    vm.preloader = true;

    EstimatesApi.getStatusWorkflow(vm.project._id, status)
      .then(function(statuses) {
        vm.updateAvailableStatuses(statuses);
        vm.project.status = vm.statuses.find(function(status) {
          return status.value === vm.project.status.value;
        });
      });

    $q.all([getUserEditRight()]).then(function() {
      vm.preloader = false;
    });

    vm.canEdit = Access.checkActionPermission(
      {
        action: 'status',
        owners: project.authors,
        entity: 'estimate'/*,
        participants: project.participants*/
      }
    );
    
    var deleteListener = Preloader.addOpenListener(openPreloader);

    function openPreloader() {
      vm.preloader = true;
    }

    $scope.$on('$destroy', function() {
      deleteListener();
    });

    vm.avatar = function(photo) {
      return photo || '/assets/images/noneava.png';
    };

    vm.saveStatus = function() {
      if (vm.project.status._id !== status) {
        status = vm.project.status._id;
        EstimatesApi.saveStatusEstimate(vm.project._id, vm.project.status._id)
          .then(function(res) {
            var estimate = res.data;
            vm.project.statusHistory = estimate.statusHistory;
            vm.isLocked = estimate.isLocked;
            $scope.$emit('EstimateStatusChanged', vm.isLocked);
            return EstimatesApi.getStatusWorkflow(vm.project._id, vm.project.status._id);
          })
          .then(function(statuses) {
            vm.updateAvailableStatuses(statuses);
          })
          .catch(function(error) {
            $log.error(error);
          });
      }
    };

    vm.getFlag = function() {
      var locale = vm.project.locale;
      return '/assets/images/' + locale + '.png';
    };

    vm.updateAvailableStatuses = function(filtered) {
      vm.statuses = vm.statusesDictionary.filter(function(status) {
         return filtered.indexOf(status.value) >= 0;
      });
    };

    function getUserEditRight() {
      var q = $q.defer();
      EstimatesApi.isRootUser()
        .then(function(response) {
          vm.isSU = response; // is Super user
          $scope.$emit('RootUserChanged', vm.isSU);
          q.resolve();
        })
        .catch(function(err) {
          q.reject(err.data);
        });

      return q.promise;
    }

    vm.hasRightToEdit = function() {
      return vm.canEdit /*&& (!vm.isLocked || vm.isSU)*/;
    };
  }
})();

(function() {
  'use strict';

  angular
      .module('estimateMeUi')
      .controller('AssociateWorkhourModalController', AssociateWorkhourModalController);

  /** @ngInject */
  function AssociateWorkhourModalController($mdDialog, EstimatesApi, associated) {
    /* jshint validthis: true */
    var vm = this;
    vm.associated = associated;
    vm.listPhases = [];
    EstimatesApi.getDictionaryTags()
        .then(function(response) {
          vm.listPhases = response.content;
          vm.listPhases.forEach(function(phase) {
            var i = vm.associated.findIndex(function(p) {
              return p === phase._id;
            });
            if (i !== -1) {
              phase.checked = true;
            }
          });
        });

    vm.saveAddingTasks = saveAddingTasks;
    vm.hasCheckedPhase = hasCheckedPhase;
    vm.closeModal = closeModal;

    function saveAddingTasks() {
      var checkedListPhases = vm.listPhases.filter(function(item) {
        return item.checked;
      }).map(function(item) {
        return item._id;
      });
      $mdDialog.hide({
        listPhases: checkedListPhases
      });
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function hasCheckedPhase() {
      for (var i = vm.listPhases.length; i--;) {
        if (vm.listPhases[i].checked) {
          return true;
        }
      }
      return false;
    }
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .config(function($mdDateLocaleProvider, moment) {
      $mdDateLocaleProvider.months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль',
        'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
      $mdDateLocaleProvider.shortMonths =  ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл',
        'Авг', 'Сент', 'Окт', 'Ноя', 'Дек'];
      $mdDateLocaleProvider.days = ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота',
        'Воскресенье'];
      $mdDateLocaleProvider.shortDays = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Bc'];

      $mdDateLocaleProvider.formatDate = function(date) {
       return date ? moment(date).format('DD-MM-YYYY') : '';
      };

      $mdDateLocaleProvider.parseDate = function(dateString) {
       var m = moment(dateString, 'DD-MM-YYYY', true);
       return m.isValid() ? m.toDate() : new Date(NaN);
      };
    });

  angular.module('estimateMeUi')
    .controller('ChartController', ChartController);

  /** @ngInject */
  function ChartController($log, $state, $scope, $stateParams, $timeout, GraphicsApi, BreadCrumbs, $window) {
      var vm = this;
      var deleteCrumb = BreadCrumbs.addCrumbs({name: 'Статистика'});
      vm.pageName = $state.current.name;
      vm.page = 'expert';
      vm.endDate = new Date();
      vm.startDate = new Date();
      vm.startDate.setFullYear(vm.startDate.getFullYear() - 1);
      vm.currentChart = null;

      vm.chartOptions =[
        {type: 'amountOfEstimates', name: 'Количество оценок', disabled: false},
        {type: 'workhours', name: 'Использование нормочасов', disabled: false},
        {type: 'expert', name: 'Количество оценок по экспертам', disabled: false},
        {type: 'scale', name: 'Масштаб оценок', disabled: true}
      ];

      $window.Highcharts.setOptions({
        lang: {
          contextButtonTitle: 'Экспорт данных',
          downloadJPEG: 'Вырузить в JPEG',
          downloadPDF: 'Выгрузить в PDF',
          downloadPNG: 'Выгрузить в PNG',
          downloadSVG: 'Выгрузить в SVG',
          drillUpText: 'Назад в {series.name}',
          loading: 'Загрузка ...',
          noData: 'Нет данных для отображения',
          printChart: 'Распечатать график',
          resetZoom: 'Сбросить масштаб',
          resetZoomTitle: "Вернуть масштаб к 1:1"
        }
      });

      vm.getCharts = function() {
        return vm.chartOptions.filter(function(value) {
          return !value.disabled;
        })
      }

      vm.changeChartByEstimate = function () {
        GraphicsApi.getCommonEstimatesForPeriod(vm.startDate, vm.endDate).then(function(options) {
          createChart(options);
        })
      }

      vm.changeChartWHByEstimate = function() {
        GraphicsApi.getCommonWHPForPeriod(vm.startDate, vm.endDate).then(function(options) {
          createChart(options);
        })
      }

      vm.changeChartByExperts = function() {
        GraphicsApi.getCommonExpertsData(vm.startDate, vm.endDate).then(function(options) {
          createChart(options);
        });
      }

      vm.onChartSelected = function(chart) {
        vm.currentChart = chart;
        vm.page = chart.type;

        if(vm.page == 'expert') {
          vm.changeChartByExperts();
        } else if (vm.page == 'workhours') {
          vm.changeChartWHByEstimate();
        } else if (vm.page == 'scale') {
          //createChart(optionsDepartment);
        } else if (vm.page == 'amountOfEstimates') {
          vm.changeChartByEstimate();
        }
      };

      function createChart(options) {
        vm.chart ? vm.chart.hideLoading() : null;
        vm.chart = $window.Highcharts.chart('container', options);
        if (options.series.length == 0) {
          vm.chart.showLoading('Нет данных для отображения');
        }
      }

      $scope.$on('$destroy', function() {
        deleteCrumb();
      });

    }
})();

(function() {
  'use strict';
  angular.module('estimateMeUi')
    .factory('statisticComposer', statisticComposer);

  /**@ngInject*/
  function statisticComposer(Mediator) {
    var events = Mediator.eventList;
    var unsubscribeInit;
    var unsubscribeChanged;
    var unsubscribeRisks;

    function init() {
      unsubscribeInit = Mediator.subscribe(events.initStatistic, initStatistic);
      unsubscribeChanged = Mediator.subscribe(events.phaseChanged, onPhaseChanged);
      unsubscribeRisks = Mediator.subscribe(events.risksEstimateChange, risksEstimateChange);
    }

    function dispose() {
      if (unsubscribeInit && unsubscribeChanged && unsubscribeRisks) {
        unsubscribeInit();
        unsubscribeChanged();
        unsubscribeRisks();
      }
    }

    var statistic = {
      reduced: [],
      risk: 0,
      minHours: 0,
      maxHours: 0,
      E50: 0,
      E68: 0,
      E95: 0,
      workhoursPercents: 0
    };
    var estimate = null;
    var saveAfter = false;
    var resultReduced = [];

    function compose(state) {
      var reduced = (angular.isDefined(state.risk))  ? angular.copy(resultReduced) : state.reduced;
      var total = totalCount(reduced, state.risk);
      angular.extend(state, {
        reduced: countBussiness(reduced, total)
      }, total);
      saveAfter = false;
    }

    function countBussiness(reduced, total) {
      var totalRange = (total.maxHours + total.minHours) / 100;
      var totalPert = (total.E68 + total.E95) / 100;
      return reduced.map(function(x) {
        return angular.extend(x, {
          percentsPert: (x.E68 + x.E95) / totalPert,
          percentsRange: (x.maxHours + x.minHours) / totalRange
        });
      });
    }

    function totalCount(reduced, risks) {
      var total = {
        E50: 0,
        E68: 0,
        E95: 0,
        minHours: 0,
        maxHours: 0
      };
      var coef = risksCoef(risks);
      total = reduced.reduce(function(p, c) {
        c.E50 = c.E50 * coef;
        c.E68 = c.E68 * coef;
        c.E95 = c.E95 * coef;
        c.minHours = c.minHours * coef;
        c.maxHours = c.maxHours * coef;
        return {
          E50: p.E50 + c.E50,
          E68: p.E68 + c.E68,
          E95: p.E95 + c.E95,
          minHours: p.minHours + c.minHours,
          maxHours: p.maxHours + c.maxHours
        };
      }, total);
      return total;
    }

    function countPert(min, max) {
      var E50 = (5 * min + max) / 6 ;
      var averDev = (max - min) / 6;
      return {
        E50: E50,
        E68: E50 + averDev,
        E95: E50 + averDev * 2
      };
    }

    function initStatistic(initialState) {
      estimate = initialState;
      if (estimate) {
        saveAfter = true;
        estimate.phases.forEach(composePhaseStatistic);
        composeEstimateStatistic(estimate);
      }
    }

    function onPhaseChanged(phase) {
      if (estimate) {
        var index = estimate.phases.findIndex(function(item) {
          return item._id === phase._id;
        });
        if (index > -1) {
          if (!angular.equals(phase, estimate.phases[index])) {
            angular.copy(phase, estimate.phases[index]);
          }
          composePhaseStatistic(estimate.phases[index]);
          Mediator.publish(events.phaseComposingFinished, estimate.phases[index]);
          composeEstimateStatistic(estimate);
        }
      }
    }

    function risksEstimateChange() {
      statistic.risk = estimate.risk;
      compose(statistic);
      Mediator.publish(events.estimateComposingFinished, statistic, saveAfter);
    }

    function composeEstimateStatistic(estimate) {
      var reduced = [];
      var genCount = 0;
      var customCount = 0;
      var qa = {
        maxHours: 0,
        minHours: 0,
        role: {
          name: 'QA',
          _id: 'qa'
        }
      };
      var pm = {
        maxHours: 0,
        minHours: 0,
        role: {
          name: 'PM',
          _id: 'pm'
        }
      };
      estimate.phases.forEach(function(phase) {
        mergeArray(reduced, phase.reduced);
        qa.maxHours += phase.qaMax;
        qa.minHours += phase.qaMin;
        pm.maxHours += phase.pmMax;
        pm.minHours += phase.pmMin;
        genCount += phase.genCount;
        customCount += phase.customCount;
      });
      reduced.push(qa);
      reduced.push(pm);
      statistic.reduced = reduced;
      reduced.forEach(function(element) {
        angular.extend(element, countPert(element.minHours, element.maxHours));
      });
      resultReduced = angular.copy(reduced);
      statistic.workhoursPercents = (customCount / genCount) * 100;
      statistic.risk = estimate.risk;
      compose(statistic);

      Mediator.publish(events.estimateComposingFinished, statistic, saveAfter);
    }

    function composePhaseStatistic(phase) {
      var type;
      var reduced = [];
      phase.genCount = 0;
      phase.customCount = 0;
      phase.qaMax = 0;
      phase.qaMin = 0;
      phase.pmMax = 0;
      phase.pmMin = 0;
      phase.bugsMax = 0;
      phase.bugsMin = 0;
      phase.qaPertMax = 0;
      phase.qaPertMin = 0;
      phase.pmPertMin = 0;
      phase.pmPertMax = 0;
      phase.risksMax = 0;
      phase.risksMin = 0;

      phase.items.forEach(function(item) {
        type = item.type.toLowerCase();
        switch (type) {
          case 'task':
            if (phase.risksEnabled) {
              item.risks = phase.risks; // временное решение
              item.risksEnabled = phase.risksEnabled;
            }
            phase.genCount += +item.maxHours * item.count;
            if (!item.custom) {
              phase.customCount += +item.maxHours * item.count;
            }
            mergeReduced(reduced, composeTaskStatistic(item));
            summary(phase, item);
            break;
          case 'feature':
            item.reduced = [];
            item.qaMax = 0;
            item.qaMin = 0;
            item.pmMax = 0;
            item.pmMin = 0;
            item.bugsMax = 0;
            item.bugsMin = 0;
            item.count = 0;
            item.qaPertMax = 0;
            item.qaPertMin = 0;
            item.pmPertMin = 0;
            item.pmPertMax = 0;
            item.risksMax = 0;
            item.risksMin = 0;
            item.risks = phase.risks; //временное решение

            item.tasks.forEach(function(task) {
              if (phase.risksEnabled) {
                task.risks = phase.risks; // временное решение
                task.risksEnabled = phase.risksEnabled;
              }
              item.count += (+task.count);
              phase.genCount += +task.maxHours * task.count;
              if (!task.custom) {
                phase.customCount += +task.maxHours * task.count;
              }
              var result = composeTaskStatistic(task);
              mergeReduced(item.reduced, result);
              mergeReduced(reduced, result);
              summary(item, result);
              summary(phase, result);
            });
            compose(item);
            break;
        }

      });

      phase.reduced = reduced;
      compose(phase);

      return phase;
    }

    function composePhaseStatisticDictionary(phase) {
      var reduced = [];
      phase.qaMax = 0;
      phase.qaMin = 0;
      phase.pmMax = 0;
      phase.pmMin = 0;
      phase.items.forEach(function(item) {
        if (item.type && item.type.toLowerCase() === 'feature') {
          item.reduced = [];
          item.qaMax = 0;
          item.qaMin = 0;
          item.pmMax = 0;
          item.pmMin = 0;
          item.link.workhours.forEach(function(task) {
            composeTaskStatisticDictionary(task, item.count);
            mergeReducedDictionary(item.reduced, task, item.count);
            mergeReducedDictionary(reduced, task, item.count);
            sumQaPm(item, task);
            sumQaPm(phase, task);
          });
          compose(item);
        } else {
          composeTaskStatisticDictionary(item);
          mergeReducedDictionary(reduced, item);
          sumQaPm(phase, item);
        }
      });
      phase.reduced = reduced;
      compose(phase);

      return phase;
    }

    function composeTaskStatisticDictionary(element, count) {
      count = count || 1;
      var reducedMin = +element.link.minHours * +element.count * count;
      var reducedMax = +element.link.maxHours * +element.count * count;
      angular.extend(element, countPert(reducedMin, reducedMax));
      element.qaMax = reducedMax * element.qa / 100;
      element.qaMin = reducedMin * element.qa / 100;
      element.pmMax = reducedMax * element.pm / 100;
      element.pmMin = reducedMin * element.pm / 100;
    }

    function mergeReducedDictionary(arr, workhour, count) {
      count = count || 1;
      var reducedMin = +workhour.link.minHours * +workhour.count * count;
      var reducedMax = +workhour.link.maxHours * +workhour.count * count;
      var index = arr.findIndex(function(y) {
        return !workhour.link.role || !y.role ? !workhour.link.role && !y.role :
            y.role === workhour.link.role || y.role._id === workhour.link.role._id ||
            y.role._id === workhour.link.role || y.role === workhour.link.role._id;
      });
      if (index === -1) {
        index = arr.length;
        arr.push({
          role: workhour.link.role,
          minHours: reducedMin,
          maxHours: reducedMax
        });
      } else {
        arr[index].minHours += reducedMin;
        arr[index].maxHours += reducedMax;
      }
      angular.extend(arr[index], countPert(arr[index].minHours, arr[index].maxHours));
      return arr;
    }

    function summary(result, summand) {
      sumQaPm(result, summand);
      result.bugsMax += summand.bugsMax;
      result.bugsMin += summand.bugsMin;
      result.qaPertMax += summand.qaPertMax;
      result.qaPertMin += summand.qaPertMin;
      result.pmPertMin += summand.pmPertMin;
      result.pmPertMax += summand.pmPertMax;
      result.risksMax += summand.risksMax;
      result.risksMin += summand.risksMin;
    }

    function sumQaPm(res, sum) {
      res.qaMax += sum.qaMax;
      res.qaMin += sum.qaMin;
      res.pmMax += sum.pmMax;
      res.pmMin += sum.pmMin;
    }

    function risksCoef(risks) {
      return risks ? 1 + risks / 100 : 1;
    }

    function composeTaskStatistic(task) {
      var coef = task.risksEnabled ? risksCoef(task.risks) : 1;
      var reducedMin = +task.minHours * +task.count;
      var reducedMax = +task.maxHours * +task.count;
      angular.extend(task, countPert(reducedMin, reducedMax));

      if (task.qaEnabled) {
        task.qaMax = reducedMax * task.qa / 100 * coef;
        task.qaMin = reducedMin * task.qa / 100 * coef;
      } else {
        task.qaMax = 0;
        task.qaMin = 0;
      }

      if (task.pmEnabled) {
        task.pmMax = reducedMax * task.pm / 100 * coef;
        task.pmMin = reducedMin * task.pm / 100 * coef;
      } else {
        task.pmMax = 0;
        task.pmMin = 0;
      }

      if (task.bugsEnabled) {
        task.bugsMax = reducedMax * task.bugs / 100 * coef;
        task.bugsMin = reducedMin * task.bugs / 100 * coef;
      } else {
        task.bugsMax = 0;
        task.bugsMin = 0;
      }

      if (task.risksEnabled) {
        task.risksMax = reducedMax * task.risks / 100;
        task.risksMin = reducedMin * task.risks / 100;
      } else {
        task.risksMax = 0;
        task.risksMin = 0;
      }

      var qaPert = countPert(task.qaMin, task.qaMax);
      var pmPert = countPert(task.pmMin, task.pmMax);
      task.qaPertMax = qaPert.E95;
      task.qaPertMin = qaPert.E68;
      task.pmPertMax = pmPert.E95;
      task.pmPertMin = pmPert.E68;

      return task;
    }

    function mergeReduced(dest, task) {
      var min = (task.type && task.type.toLowerCase() === 'task') ? (+task.minHours * +task.count + task.bugsMin + task.risksMin) : +task.minHours;
      var max = (task.type && task.type.toLowerCase() === 'task') ? (+task.maxHours * +task.count + task.bugsMax + task.risksMax) : +task.maxHours;
      var taskRole = null;

      if (task.role) {
        taskRole = task.role._id || task.role;
      }

      var index = dest.findIndex(function(y) {
        var yRole = null;
        if (y.role) {
          yRole = y.role._id || y.role;
        }
        return !task.role || !y.role ? !task.role && !y.role : yRole === taskRole;
      });

      if (index === -1) {
        index = dest.length;
        dest.push({
          role: task.role,
          minHours: min,
          maxHours: max
        });
      } else {
        dest[index].minHours += min;
        dest[index].maxHours += max;
      }
      angular.extend(dest[index], countPert(dest[index].minHours, dest[index].maxHours));

      return dest;
    }

    function mergeArray(dest, src) {
      src.forEach(function(task) {
        mergeReduced(dest, task);
      });
      return dest;
    }

    function getReduced() {
      return resultReduced;
    }

    return {
      composePhaseStatistic: composePhaseStatisticDictionary,
      init: init,
      dispose: dispose,
      getReduced: getReduced,
      compose: compose
    };

  }
})();

(function() {
  'use strict';
  angular.module('estimateMeUi').service('Redirector', Redirector);

  /** @ngInject */
  function Redirector() {
    var returnToState = '';
    var returnToStateParams = '';
    this.setState = function(state, params) {
      returnToState = state;
      returnToStateParams = params;
    };
    this.getState = function() {
      return returnToState;
    };
    this.getParams = function() {
      return returnToStateParams;
    };
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi').factory('Preloader', Preloader);
  function Preloader() {
    var openListeners = [];
    var closeListeners = [];
    return {
      openPreloader: function() {
        openListeners.forEach(function(listener) {
          listener();
        });
      },
      closePreloader: function() {
        closeListeners.forEach(function(listener) {
          listener();
        });
      },
      addOpenListener: function(listener) {
        if (!angular.isFunction(listener)) {
          throw new Error('Listener must be a function');
        }
        openListeners.push(listener);
        return function() {
          openListeners.splice(openListeners.indexOf(listener),1);
        };
      }
    };
  }
})();

(function() {
  'use strict';
  angular.module('estimateMeUi').factory('PhaseState', phaseState);

  /** @ngInject */
  function phaseState($log, EstimatesApi, NotificationManager) {
    var phaseState = [];

    function setPhaseState(newPhaseState) {
      phaseState = (angular.isObject(newPhaseState)) ? angular.copy(newPhaseState, phaseState) : {};
    }

    function getPhaseState() {
      return phaseState;
    }

    function compareRoles(originalRole, copyRole) {
      if (!originalRole && !copyRole) {
        return true;
      }
      if (!originalRole || !copyRole) {
        return false;
      }
      var copyId = copyRole._id || copyRole;
      var originalId = originalRole._id || originalRole;
      return copyId === originalId;
    }

    function compareByField(elem, elemPhaseState, field) {
      if (field === 'role') {
        return compareRoles(elem[field], elemPhaseState[field]);
      }
      return elem[field] == elemPhaseState[field];
    }

    function compareTaskInCurrentPhase(curTask, field, idFeature) {
      var index = -1;
      var ind = -1;
      var task = {};
      if (!idFeature) {
        index = phaseState.items.findIndex(function(item) {
          return curTask._id === item._id;
        });
        if (index !== -1) {
          task = phaseState.items[index];
          if (field === 'name' && curTask[field] === '') {
            curTask[field] = task[field];
            return;
          }
        }
      } else {
        ind = phaseState.items.findIndex(function(item) {
          return idFeature === item._id;
        });
        if (ind !== -1) {
          index = phaseState.items[ind].tasks.findIndex(function(item) {
            return curTask._id === item._id;
          });
          if (index !== -1) {
            task = phaseState.items[ind].tasks[index];
          }
        }
      }
      var hasChanges = false;
      var saveTask = {};
      if (!angular.isArray(field)) {
        field = [field];
      }
      for(var i = 0; i < field.length; i++) {
        hasChanges = !compareByField(curTask, task, field[i]) || hasChanges;
          saveTask[field[i]] = curTask[field[i]];
      }
      
      if (hasChanges) {
        saveTask._id = curTask._id;
        EstimatesApi.updateTask(saveTask)
        .then(function() {
          if (index !== -1) {
            if (ind === -1) {
              copyFields(phaseState.items[index], curTask, field);
            } else {
              copyFields(phaseState.items[ind].tasks[index], curTask, field);
            }
          }
        }, function() {
          NotificationManager.notifyMe('error');
        });
      }
    }

    function copyFields(savedTask, curTask, fields) {
      for(var i = 0; i < fields.length; i++) {
        savedTask[fields[i]] = curTask[fields[i]];
      }
    }

    function compareFeatureInCurrentPhase(curFeature, field) {
      var index = phaseState.items.findIndex(function(item) {
        return curFeature._id === item._id;
      });
      if (!compareByField(curFeature, phaseState.items[index], field)) {
        var saveFeature = {};
        saveFeature._id = curFeature._id;
        saveFeature[field] = curFeature[field];
        saveFeature.phase = curFeature.phase;
        EstimatesApi.updateFeature(saveFeature)
        .then(function(result) {
          $log.log('updated feature:', result);
          phaseState.items[index][field] = curFeature[field];
          if ((field !== 'name' || field !== 'description') && curFeature.tasks.length > 0) {
            phaseState.items[index].tasks.forEach(function(element) {
              element[field] = saveFeature[field];
            });
          }
        }, function() {
          NotificationManager.notifyMe('error');
        });
      }
    }

    function compareQaPmBugsInCurrentPhase(curPhase, field) {
      if (!compareByField(curPhase, phaseState, field)) {
        var savePhase = {};
        var value = curPhase[field];
        savePhase._id = curPhase._id;
        savePhase[field] = value;
        savePhase.estimate = curPhase.estimate;
        EstimatesApi.updatePhase(savePhase).
        then(function(result) {
          $log.log('updated curPhase:', result);
          phaseState[field] = value;
          phaseState.items.forEach(function(element) {
            element[field] = value;
            if (element.type === 'feature') {
              element.tasks.forEach(function(task) {
                task[field] = value;
              });
            }
          });
        }, function(error) {
          $log.error(error);
        });
      }
    }

    function updatePhaseState(action, elem, parent) {
      var index;
      var ind;
      switch (action) {
        case 'add':
          if (parent) {
            index = phaseState.items.findIndex(function(item) {
              return item._id === parent;
            });
            if (!phaseState.items[index].tasks) {
              phaseState.items[index].tasks = [];
            }
            phaseState.items[index].tasks.push(angular.copy(elem));
          } else {
            [].push.apply(phaseState.items, angular.copy(elem));
          }
          break;
        case 'addList':
          [].push.apply(phaseState.items, angular.copy(elem));
          break;
        case 'delete':
          if (parent) {
            index = phaseState.items.findIndex(function(item) {
              return item._id === parent;
            });
            ind = phaseState.items[index].tasks.findIndex(function(item) {
              return item._id === elem._id;
            });
            phaseState.items[index].tasks.splice(ind, 1);
          } else {
            index = phaseState.items.findIndex(function(item) {
              return item._id === elem._id;
            });
            phaseState.items.splice(index, 1);
          }
          break;
        case 'copy':
          if (parent) {
            index = phaseState.items.findIndex(function(item) {
              return item._id === parent && item.type === 'feature';
            });
            ind = phaseState.items[index].tasks.findIndex(function(item) {
              return item._id === elem.id;
            });
            phaseState.items[index].tasks.splice(ind, 0, angular.copy(elem.copy));
          } else {
            index = phaseState.items.findIndex(function(item) {
              return item._id === elem.id;
            });
            phaseState.items.splice(index + 1, 0, angular.copy(elem.copy));
          }
          break;
        default:
          break;
      }
    }

    return {
      setPhaseState: setPhaseState,
      getPhaseState: getPhaseState,
      compareTaskInCurrentPhase: compareTaskInCurrentPhase,
      compareFeatureInCurrentPhase: compareFeatureInCurrentPhase,
      compareQaPmBugsInCurrentPhase: compareQaPmBugsInCurrentPhase,
      updatePhaseState: updatePhaseState
    };
  }
})();

(function() {
  'use strict';
  angular.module('estimateMeUi').factory('NotificationManager', NotificationManager);

  /** @ngInject */
  function NotificationManager($log, $timeout) {
    var optionsList = {};
    optionsList.save = {
      body: 'Изменения сохранены',
      dir: 'auto',
      icon: '/assets/images/success.png',
      tag: 'save'
    };
    optionsList.error = {
      body: 'Изменения не сохранены',
      dir: 'auto',
      icon: '/assets/images/error.png',
      tag: 'error'
    };
    optionsList.notFind = {
      body: '',
      dir: 'auto',
      icon: '/assets/images/error.png',
      tag: 'error'
    };
    optionsList.phaseCopied = {
      body: 'Фаза скопирована',
      dir: 'auto',
      icon: '/assets/images/success.png',
      tag: 'phaseCopied'
    };

    function notifyMe(tag, message) {
      if (tag && optionsList.hasOwnProperty(tag)) {
        var options = Object.assign({}, optionsList[tag]);
        if (message) {
          options.body += (options.body === '' ? '' : '. ') + message;
        }
      } else {
        throw new Error('Unknown tag ' + tag);
      }
      if (!('Notification' in window)) {
        $log.log('This browser does not support desktop notification');
      } else if (Notification.permission === 'granted') {
        newNotify();
      } else if (Notification.permission !== 'denied') {
        Notification.requestPermission(function(permission) {
          if (permission === 'granted') {
            newNotify();
          }
        });
      }
      function newNotify() {
        var notification = new Notification('Внимание', options);
        notification.onshow = function() {
          $timeout(function() {
            notification.close();
          }, 3000);
        };
      }
    }

    return {
      notifyMe: notifyMe
    };
  }
})();

(function() {
  'use strict';
  angular.module('estimateMeUi').service('Mediator', Mediator);

  /** @ngInject */
  function Mediator($timeout, $log) {
    var channels = {};
    var _await = {};
    this.publish = function(channel) {
      var data = [].slice.call(arguments, 1);
      if (!channels[channel]) {
        _await[channel] = data;
        return;
      }
      var subscribers = channels[channel].slice();
      subscribers.forEach(function(subscriber) {
        $timeout(function(){
          subscriber.apply(null, data);
        });
      });
    };
    this.subscribe = function(channel, cb) {
      if (!angular.isFunction(cb)) {
        $log.error(new Error('Mediator subscriber callback is not a function'));
        return;
      }
      if (!channels[channel]) {
        if (_await[channel]) {
          cb.apply(null, _await[channel]);
          _await[channel] = null;
        }
        channels[channel] = [];
      }
      channels[channel].push(cb);
      return function() {
        var i = channels[channel].indexOf(cb);
        channels[channel].splice(i, 1);
      };
    };
    this.eventList = {
      initStatistic: 'initStatistic',
      phaseChanged: 'phaseChanged',
      risksEstimateChange: 'risksEstimateChange',
      estimateComposingFinished: 'estimateComposingFinished',
      phaseComposingFinished: 'phaseComposingFinished'
    };
  }
})();

(function() {
  'use strict';
  /**
   * @ngdoc service
   * @name GraphicsApi
   * @memberOf estimateMeUi
   * @description
   *  Сервис для отправки REST на получение графиков со статистикой по оценкам.
   */
 angular.module('estimateMeUi')
  .service('GraphicsApi', GraphicsApi);

  /**@ngInject*/
  function GraphicsApi($http, $log, API_URL, $q) {
    var vm = this;

    angular.extend(vm, {
      getCommonEstimatesForPeriod: getCommonEstimatesForPeriod,
      getCommonWHPForPeriod: getCommonWHPForPeriod,
      getCommonExpertsData: getCommonExpertsData
    });

    function getCommonEstimatesForPeriod(start, end) {
      var q  = $q.defer();
      $http({
        method: 'POST',
        url: API_URL + 'graphics/report/estimates',
        data: { start: start, end: end}
      }).
      then(function(response) {
        q.resolve(response.data);
      }, function(error) {
        $log.error(error);
        q.reject();
      });
      return q.promise;
    }

    function getCommonWHPForPeriod(start, end) {
      var q  = $q.defer();
      $http({
        method: 'POST',
        url: API_URL + 'graphics/report/estimates/whpercents',
        data: { start: start, end: end}
      }).
      then(function(response) {
        q.resolve(response.data);
      }, function(error) {
        $log.error(error);
        q.reject();
      });
      return q.promise;
    }

    function getCommonExpertsData(start, end) {
      var q  = $q.defer();
      $http({
        method: 'POST',
        url: API_URL + 'graphics/report/estimates/experts',
        data: { start: start, end: end }
      }).
      then(function(response) {
        q.resolve(response.data);
      }, function(error) {
        $log.error(error);
        q.reject();
      });
      return q.promise;
    }
  }

})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .service('FileUploadService', FileUploadService);

  /** @ngInject */
  function FileUploadService($window) {
    var vm = this;

    vm.support = support;
    vm.isFile = isFile;
    vm.isImage = isImage;

    function support() {
      return !!($window.FileReader && $window.CanvasRenderingContext2D);
    }

    function isFile(item) {
      return angular.isObject(item) && item instanceof $window.File;
    }

    function isImage(element) {
      var type = element.type.split('/')[1];
      var format = ['jpg','png','jpeg','bmp','gif'];
      return format.some(function(item) {
          return item === type;
        });
    }
  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi')
    .service('ExportExcelService', ExportExcelService);

  /** @ngInject */
  function ExportExcelService($mdDialog, $http, $log, API_URL) {
    var vm = this;

    vm.openExportExcelWindow = openExportExcelWindow;
    vm.exportExcel = exportExcel;
    vm.getDataExport = getDataExport;

    //-- open modal window for Export
    function openExportExcelWindow(e, estimate, format) {
      $mdDialog.show({
        targetEvent: e,
        controller: 'EstimateExportExcelController',
        controllerAs: 'vm',
        templateUrl: '/app/components/views/excelExportDialog.html',
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          est: estimate,
          indexFormat: format
        }
      });
    }

    
    function getDataExport(id) {
      return $http({
        method: 'GET',
        url: API_URL + 'estimates/' + id + '/export'
      })
        .then(function(response) {
          return response.data;
        }, function(err) {
          $log.error(err);
        }
      );
    }

    //-- request for export Excel
    function exportExcel(id, data) {
      return $http({
        method: 'POST',
        url: API_URL + 'estimates/' + id + '/export',
        data: data,
        responseType: 'arraybuffer'
      });
    }
  }
})();
(function() {
  'use strict';
  /**
   * @ngdoc service
   * @name EstimatesApi
   * @memberOf estimateMeUi
   * @description
   *  Сервис для отправки REST на обработку оценок.
   */
  angular.module('estimateMeUi')
    .service('EstimatesApi', EstimatesApi);

  /** @ngInject */
  function EstimatesApi($log, $http, $q, API_URL, Access/*, $window*/) {
    var that = this;

    //var TAGS_STORAGE = 'tagsStorage';
    //var ROLES_STORAGE = 'rolesStorage';
    //var GROUPS_STORAGE = 'groupsStorage';
    //var WORKHOURS_STORAGE = 'workhoursStorage';

    angular.extend(that, {
      removeAccaunt: removeAccaunt,
      getTasksByEstimate: getTasksByEstimate,
      getPhaseTemplates: getPhaseTemplates,
      getEstimatesList: getEstimatesList,
      getEstimate: getEstimate,
      createEstimate: createEstimate,
      copyEstimate: copyEstimate,
      deleteEstimate: deleteEstimate,
      updateEstimate: updateEstimate,
      updateEstimateReorderPhases: updateEstimateReorderPhases,
      addPhases: addPhases,
      addFeatures: addFeatures,
      addTasks: addTasks,
      copyFeature: copyFeature,
      copyTask: copyTask,
      copyTaskInFeature: copyTaskInFeature,
      deletePhase: deletePhase,
      deleteFeature: deleteFeature,
      deleteTask: deleteTask,
      deleteTag: deleteTag,
      getPhase: getPhase,
      getFeature: getFeature,
      getTask: getTask,
      updatePhase: updatePhase,
      updatePhaseOrder: updatePhaseOrder,
      updateTagsOrder: updateTagsOrder,
      updateTag: updateTag,
      updateCountGroup: updateCountGroup,
      updateItemTag: updateItemTag,
      updateFeature: updateFeature,
      updateTask: updateTask,
      updatePhases: updatePhases,
      updateRoles: updateRoles,
      updateGroups: updateGroups,
      getFeatureTemplates: getFeatureTemplates,
      getDictionaryRoles: getDictionaryRoles,
      getDictionaryCurrencies: getDictionaryCurrencies,
      addDictionaryRoles: addDictionaryRoles,
      addDictionaryCurrencies: addDictionaryCurrencies,
      saveDictionaryCurrencies: saveDictionaryCurrencies,
      deleteDictionaryCurrencies: deleteDictionaryCurrencies,
      deleteDictionaryWorkhour: deleteDictionaryWorkhour,
      deleteDictionaryGroup: deleteDictionaryGroup,
      deleteDictionaryRole: deleteDictionaryRole,
      deleteGroupFromTag: deleteGroupFromTag,
      deleteWorkhourFromTag: deleteWorkhourFromTag,
      deleteWorkhourFromGroup: deleteWorkhourFromGroup,
      addWorkhoursToGroup: addWorkhoursToGroup,
      getDictionaryWorkhours: getDictionaryWorkhours,
      associateWorkhours: associateWorkhours,
      associateGroups: associateGroups,
      getWorkhoursAssociatedWithTag: getWorkhoursAssociatedWithTag,
      getGroupsAssociatedWithTag: getGroupsAssociatedWithTag,
      getDictionaryWorkhourById: getDictionaryWorkhourById,
      updateDictionaryWorkhourById: updateDictionaryWorkhourById,
      updateDictionaryWorkhours: updateDictionaryWorkhours,
      addDictionaryWorkhours: addDictionaryWorkhours,
      getDictionaryGroups: getDictionaryGroups,
      addDictionaryGroups: addDictionaryGroups,
      getDictionaryGroupById: getDictionaryGroupById,
      addDictionaryGroupsInTag: addDictionaryGroupsInTag,
      getDictionaryTags: getDictionaryTags,
      addDictionaryTags: addDictionaryTags,
      getDictionaryTagById: getDictionaryTagById,
      addGroupsAndWorkhoursToTag: addGroupsAndWorkhoursToTag,
      getFeatureTemplate: getFeatureTemplate,
      getPhaseTemplate: getPhaseTemplate,
      getTaskTemplates: getTaskTemplates,
      getTaskTemplate: getTaskTemplate,
      updateStatistic: updateStatistic,
      getStatistic: getStatistic,
      getUsersStatuses: getUsersStatuses,
      saveStatusEstimate: saveStatusEstimate,
      getStatusWorkflow: getStatusWorkflow,
      searchEstimate: searchEstimate,
      pastePhaseIntoEstimate: pastePhaseIntoEstimate,
      isRootUser: isRootUser
    });

    /*function getStorageData(storageName) {
      return $window.sessionStorage.getItem(storageName);
    }

    function setStorageData(storageName, data) {
      $window.sessionStorage.setItem(storageName, angular.toJson(data));
    }

    function storageUpdate(storageName, functionName) {
      $window.sessionStorage.removeItem(storageName),
      that[functionName]();
    }*/

    function removeAccaunt() {
      return $http({
        method: 'DELETE',
        url: API_URL + 'users/removeAccaunt'
      });
    }

    function getTasksByEstimate(id) {
      var q = $q.defer();
      $http({
        method: 'GET',
        url: API_URL + 'estimates/' + id + '/tasks'
      }).then(function(res) {
        q.resolve(res.data);
      }, q.reject);
      return q.promise;
    }

    function updateEstimate(est, authors/*, participants*/) {
      var q = $q.defer();
      var access = Access.checkActionPermission(
        {
          action: 'update',
          entity: 'estimate',
          owners: authors/*,
          participants: participants*/
        }
      );
      if (access) {
        var params = Object.keys(est);
        var estimateData = {};
        params.forEach(function(param) {
          if (param !== 'phases') {
            estimateData[param] = est[param];
          }
        });

        $http({
          method: 'PUT',
          url: API_URL + 'estimates/' + est._id,
          data: estimateData
        }).
        then(function(res) {
          q.resolve(res);
        }, function(err) {
          q.reject(err);
        });
      } else {
        q.reject();
      }
      return q.promise;
    }

    function updateEstimateReorderPhases(idEstimate, listPhase) {
      return $http({
        method: 'PUT',
        url: API_URL + 'estimates/' + idEstimate + '/reorder/phases',
        data: listPhase
      });
    }

    function updatePhase(phase) {
      return $http({
        method: 'PUT',
        url: API_URL + 'phases/' + phase._id,
        data: phase
      });
    }

    function updatePhaseOrder(idPhase, objOrder) {
      return $http({
        method: 'PUT',
        url: API_URL + 'phases/' + idPhase + '/reorder',
        data: objOrder
      });
    }

    /*
      Tags - begin
    */
    function getDictionaryTags() {
      var q = $q.defer();
      var access = Access.checkActionPermission(
        {
          action: 'list',
          entity: 'tag'
        }
      );
      if (access) {
        /*var data = getStorageData(TAGS_STORAGE);
        if (data) {
          q.resolve(angular.fromJson(data));
        } else {*/
          $http({
            method: 'GET',
            url: API_URL + 'dictionaries/tags'
          })
          .then(function (res) {
            //setStorageData(TAGS_STORAGE, res.data);
            q.resolve(res.data);
          }, function (err) {
              $log.error('getting tags error:', err);
              q.reject(err);
          });
        //}
      } else {
        q.reject();
      }
      return q.promise;
    }

    function updateTagsOrder(idPhase, objOrder) {
      return $http({
        method: 'PUT',
        url: API_URL + 'dictionaries/tags/' + idPhase + '/reorder',
        data: objOrder
      })
      .then(function (response) {
        //storageUpdate(TAGS_STORAGE, 'getDictionaryTags');
        return response;
      }, function (err) {
        $log.error(err);
      });
    }

    function updateTag(tag) {
      return $http({
        method: 'PUT',
        url: API_URL + 'dictionaries/tags/' + tag._id,
        data: tag
      })
      .then(function (response) {
        //storageUpdate(TAGS_STORAGE, 'getDictionaryTags');
        return response;
      }, function (err) {
        $log.error(err);
      });
    }

    function updateItemTag(tagId, item) {
      return $http({
        method: 'PUT',
        url: API_URL + 'dictionaries/tags/' + tagId + '/count',
        data: item
      })
      .then(function (response) {
        //storageUpdate(TAGS_STORAGE, 'getDictionaryTags');
        return response;
      }, function (err) {
        $log.error(err);
      });
    }

    function deleteTag(phase) {
      var id = phase._id || phase;
      return $http({
        method: 'DELETE',
        url: API_URL + 'dictionaries/tags/' + id
      })
      .then(function (response) {
        //storageUpdate(TAGS_STORAGE, 'getDictionaryTags');
        return response.data;
      }, function (err) {
        $log.error(err);
      });
    }

    function deleteGroupFromTag(tag, group) {
      var id = tag._id || tag;
      var groupId = group._id || group;
      return $http({
        method: 'DELETE',
        url: API_URL + 'dictionaries/tags/' + id + '/groups/' + groupId
      })
      .then(function (response) {
        //storageUpdate(TAGS_STORAGE, 'getDictionaryTags');
        return response.data;
      }, function (err) {
          $log.error(err);
      });
    }

    function deleteWorkhourFromTag(tag, workhour) {
      var id = tag._id || tag;
      var workhourId = workhour._id || workhour;
      return $http({
        method: 'DELETE',
        url: API_URL + 'dictionaries/tags/' + id + '/workhours/' + workhourId
      })
      .then(function (response) {
        //storageUpdate(TAGS_STORAGE, 'getDictionaryTags');
        return response.data;
      }, function (err) {
        $log.error(err);
      });
    }

    function addDictionaryTags(tag) {
      return $http({
        method: 'POST',
        url: API_URL + 'dictionaries/tags',
        data: tag
      })
      .then(function (response) {
        //storageUpdate(TAGS_STORAGE, 'getDictionaryTags');
        return response.data;
      },  function (error) {
            $log.error(error);
      });
    }

    function getDictionaryTagById(id) {
      return $http({
        method: 'GET',
        url: API_URL + 'dictionaries/tags/' + id
      })
      .then(function (response) {
          return response.data;
      },  function (error) {
            $log.error(error);
      });
    }

    function addGroupsAndWorkhoursToTag(tag, groupsAndWorkhours) {
      var id = tag._id || tag;
      return $http({
        method: 'POST',
        url: API_URL + 'dictionaries/tags/' + id,
        data: groupsAndWorkhours
      })
      .then(function (response) {
        //storageUpdate(TAGS_STORAGE, 'getDictionaryTags');
        return response.data;
      },  function (error) {
           $log.log(error);
      });
    }

    function getWorkhoursAssociatedWithTag(phase) {
      var id = phase._id || phase;
      return $http({
        method: 'GET',
        url: API_URL + 'dictionaries/tags/' + id + '/associated/workhours'
      })
      .then(function (response) {
        return response.data;
      },  function (error) {
            $log.error(error);
      });
    }

    function getGroupsAssociatedWithTag(phase) {
      var id = phase._id || phase;
      return $http({
        method: 'GET',
        url: API_URL + 'dictionaries/tags/' + id + '/associated/groups'
      })
      .then(function (response) {
        return response.data;
      },  function (error) {
            $log.error(error);
      });
    }
    /*
      Tags - end
    */

    function updateCountGroup(groupId, item) {
      return $http({
        method: 'PUT',
        url: API_URL + 'dictionaries/groups/' + groupId + '/count',
        data: item
      });
    }

    function updateFeature(feature) {
      return $http({
        method: 'PUT',
        url: API_URL + 'features/' + feature._id,
        data: feature
      });
    }

    function updateTask(task) {
      var q = $q.defer();
      $http({
        method: 'PUT',
        url: API_URL + 'tasks/' + task._id,
        data: task
      }).then(function(response) {
        q.resolve(response.data);
      }, q.reject);
      return q.promise;
    }

    function deletePhase(estimate, phase) {
      var id = phase._id || phase;
      var estimateId = estimate._id;
      return $http({
        method: 'DELETE',
        url: API_URL + 'estimates/' + estimateId + '/phases/' + id
      });
    }

    function deleteFeature(feature) {
      var id = feature._id || feature;
      return $http({
        method: 'DELETE',
        url: API_URL + 'features/' + id
      }).then(function(response) {
        return response.data;
      }, function(err) {
        $log.error(err);
      });
    }

    function deleteTask(task) {
      var id = task._id || task;
      return $http({
        method: 'DELETE',
        url: API_URL + 'tasks/' + id
      }).then(function(response) {
        return response.data;
      }, function(err) {
        $log.error(err);
      });
    }

    /* Method for estimates */
    function deleteEstimate(id) {
      return $http({
        method: 'DELETE',
        url: API_URL + 'estimates/' + id
      });
    }

    function createEstimate(locale) {
      var q = $q.defer();
      $http({
        method: 'POST',
        url: API_URL + 'estimates/',
        data: {locale: locale || 'ru'}
      })
        .then(function(response) {
          q.resolve(response.data);
        }, q.reject);
      return q.promise;
    }

    function copyEstimate(id) {
      var q = $q.defer();
      $http({
        method: 'POST',
        url: API_URL + 'estimates/' + id + '/copy'
      })
      .then(function(response) {
        q.resolve(response.data);
      }, q.reject);
      return q.promise;
    }

    function getEstimatesList(param) {
      return $http({
        method: 'GET',
        url: API_URL + 'estimates',
        params: param
      })
        .then(function(response) {
          return response.data;
        }, function(err) {
          $log.error(err);

        }
      );
    }

    function getEstimate(id) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        url: API_URL + 'estimates/' + id
      })
      .then(function(res) {
        deferred.resolve(res.data);
      }, function(err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function getPhase(phase) {
      var _id = phase._id || phase;
      var deferred = $q.defer();
      $http({
        method: 'GET',
        url: API_URL + 'phases/' + _id
      })
      .then(function(res) {
        deferred.resolve(res.data);
      }, function(err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function getFeature(feature) {
      var _id = feature._id || feature;
      return $http({
        method: 'GET',
        url: API_URL + 'features/' + _id
      });
    }

    function getTask(task) {
      return $http({
        method: 'GET',
        url: API_URL + 'tasks/' + task._id
      });
    }

    /*
      Roles - begin
    */
    function getDictionaryRoles() {
      /*var data = getStorageData(ROLES_STORAGE);
      if (data) {
        var q = $q.defer();
        q.resolve(angular.fromJson(data));
        return q.promise;
      } else {*/
        return $http({
          method: 'GET',
          url: API_URL + 'dictionaries/roles'
        })
        .then(function (response) {
          //setStorageData(ROLES_STORAGE, response.data);
          return response.data;
          }, 
          function (error) {
            $log.error(error);
          }
        );
      //}
    }

    function addDictionaryRoles(role) {
      return $http({
        method: 'POST',
        url: API_URL + 'dictionaries/roles',
        data: role
      }).
      then(function(response) {
        //storageUpdate(ROLES_STORAGE, 'getDictionaryRoles');
        return response.data;
      }, function(error) {
          $log.error(error);
      });
    }

    function updateRoles(roles) {
      return $http({
        method: 'PUT',
        url: API_URL + 'dictionaries/roles',
        data: roles
      }).
        then(function (response) {
          //storageUpdate(ROLES_STORAGE, 'getDictionaryRoles');
          return response.data;
        }, function (error) {
            $log.error(error);
        });
    }

    function deleteDictionaryRole(role) {
      var id = role._id || role;
      var q = $q.defer();
      $http(
        {
          method: 'DELETE',
          url: API_URL + 'dictionaries/roles/' + id
        }
      )
      .then(function (response) {
        //storageUpdate(ROLES_STORAGE, 'getDictionaryRoles');
        q.resolve(response);
      }, function (error) {
          q.reject(error);
      });

      return q.promise;
    }
    /*
      Roles - end
    */

    /*
      Currency - begin
    */
    function getDictionaryCurrencies() {  //не используется на данный момент
      return $http({
        method: 'GET',
        url: API_URL + 'dictionaries/currencies'
      })
      .then(function(response) {
        return response.data;
      },  function(error) {
          $log.error(error);
      });
    }

    function addDictionaryCurrencies(currencies) {
      return $http({
        method: 'POST',
        url: API_URL + 'dictionaries/currencies',
        data: currencies
      })
      .then(function(response) {
        //storageUpdate(ROLES_STORAGE, 'getDictionaryRoles');
        return response.data;
      }, function(error) {
        $log.error(error);
      });
    }

    function saveDictionaryCurrencies(currency) {
      return $http({
        method: 'PUT',
        url: API_URL + 'dictionaries/currencies',
        data: currency
      })
      .then(function(response) {
        //storageUpdate(ROLES_STORAGE, 'getDictionaryRoles');
        return response.data;
      }, function(error) {
        $log.error(error);
      });
    }

    function deleteDictionaryCurrencies(currency) {
      var id = currency._id || currency;
      return $http({
        method: 'DELETE',
        url: API_URL + 'dictionaries/currencies/' + id
      })
      .then(function (response) {
        //storageUpdate(ROLES_STORAGE, 'getDictionaryRoles');
        return response.data;
      }, function (err) {
        $log.error(err);
      });
    }
     /*
      Currency - end
    */

    function updateGroups(groups) {
      return $http({
        method: 'PUT',
        url: API_URL + 'dictionaries/groups/',
        data: groups
      }).
      then(function(response) {
        return response.data;
      }, function(error) {
        $log.error(error);
      });
    }

    function deleteDictionaryWorkhour(workhour) {
      var id = workhour._id || workhour;
      return $http({
        method: 'DELETE',
        url: API_URL + 'dictionaries/workhours/' + id
      }).then(function(response) {
        return response.data;
      }, function(err) {
        $log.error(err);
      });
    }

    function deleteDictionaryGroup(group) {
      var id = group._id || group;
      return $http({
        method: 'DELETE',
        url: API_URL + 'dictionaries/groups/' + id
      }).then(function(response) {
        return response.data;
      }, function(err) {
        $log.error(err);
      });
    }

    function deleteWorkhourFromGroup(group, workhour) {
      var id = group._id || group;
      var workhourId = workhour._id || workhour;
      return $http({
        method: 'DELETE',
        url: API_URL + 'dictionaries/groups/' + id + '/workhours/' + workhourId
      }).then(function(response) {
        return response.data;
      }, function(err) {
        $log.error(err);
      });
    }

    function addWorkhoursToGroup(group, workhours) {
      var id = group._id || group;
      return $http({
        method: 'POST',
        url: API_URL + 'dictionaries/groups/' + id,
        data: workhours
      }).
      then(function(response) {
        return response.data;
      }, function(error) {
        $log.error(error);
      });
    }

    function getDictionaryWorkhours() {
      /*var data = getStorageData(WORKHOURS_STORAGE);
      if (data) {
        var q = $q.defer();
        q.resolve(angular.fromJson(data));
        return q.promise;
      } else {*/
        return $http({
          method: 'GET',
          url: API_URL + 'dictionaries/workhours'
        }).then(
          function (response) {
            //setStorageData(WORKHOURS_STORAGE, response.data);
            return response.data;
          },
          function (error) {
            $log.error(error);
          }
        );
      //}
    }

    function associateWorkhours(workhour, phaseList) {
      var id = workhour._id || workhour;
      return $http({
        method: 'PUT',
        url: API_URL + 'dictionaries/workhours/' + id + '/associate',
        data: phaseList
      }).then(
        function(response) {
          return response.data;
        },
        function(error) {
          $log.error(error);
        }
      );
    }

    function associateGroups(group, phaseList) {
      var id = group._id || group;
      return $http({
        method: 'PUT',
        url: API_URL + 'dictionaries/groups/' + id + '/associate',
        data: phaseList
      }).then(
        function(response) {
          return response.data;
        },
        function(error) {
          $log.error(error);
        }
      );
    }

    function getDictionaryWorkhourById(id) {
      return $http({
        method: 'GET',
        url: API_URL + 'dictionaries/workhours/' + id
      }).then(
        function(response) {
          return response.data;
        },
        function(error) {
          $log.error(error);
        }
      );
    }

    function updateDictionaryWorkhourById(workhour) {
      return $http({
        method: 'PUT',
        url: API_URL + 'dictionaries/workhours/' + workhour._id,
        data: workhour
      }).then(
        function(response) {
          return response.data;
        },
        function(error) {
          $log.error(error);
        }
      );
    }

    function updateDictionaryWorkhours(workhours) {
      return $http({
        method: 'PUT',
        url: API_URL + 'dictionaries/workhours',
        data: workhours
      }).then(
        function(response) {
          return response.data;
        },
        function(error) {
          $log.error(error);
        }
      );
    }

    function addDictionaryWorkhours(workhour) {
      return $http({
        method: 'POST',
        url: API_URL + 'dictionaries/workhours',
        data: workhour
      }).
      then(function(response) {
        return response.data;
      }, function(error) {
        $log.error(error);
      });
    }

    function getDictionaryGroups() {
      /*var data = getStorageData(GROUPS_STORAGE);
      if (data) {
        var q = $q.defer();
        q.resolve(angular.fromJson(data));
        return q.promise;
      } else {*/
        return $http({
          method: 'GET',
          url: API_URL + 'dictionaries/groups'
        }).then(
          function (response) {
            //setStorageData(GROUPS_STORAGE, response.data);
            return response.data;
          },
          function (error) {
            $log.error(error);
          }
        );
      //}
    }

    function addDictionaryGroups(group) {
      return $http({
        method: 'POST',
        url: API_URL + 'dictionaries/groups',
        data: group
      }).
      then(function(response) {
        return response.data;
      }, function(error) {
        $log.error(error);
      });
    }

    function getDictionaryGroupById(id) {
      return $http({
        method: 'GET',
        url: API_URL + 'dictionaries/groups/' + id
      }).then(
        function(response) {
          return response.data;
        },
        function(error) {
          $log.error(error);
        }
      );
    }

    function addDictionaryGroupsInTag(tagId, group) {
      return $http({
        method: 'POST',
        url: API_URL + 'dictionaries/groups/add/' + tagId,
        data: group
      }).
      then(function(response) {
        return response.data;
      }, function(error) {
        $log.error(error);
      });
    }

    function addTasks(phaseId, tasks) {
      return $http({
        method: 'POST',
        url: API_URL + 'phases/' + phaseId + '/tasks/',
        data: tasks
      }).then(
        function(response) {
          return response.data;
        },
        function(error) {
          $log.error(error);
        }
      );
    }

    function copyTask(phaseId, task) {
      return $http({
        method: 'POST',
        url: API_URL + 'phases/' + phaseId + '/task/',
        data: task
      }).then(
        function(response) {
          return response.data;
        },
        function(error) {
          $log.error(error);
        }
      );
    }

    function copyFeature(phaseId, feature) {
      return $http({
        method: 'POST',
        url: API_URL + 'phases/' + phaseId + '/feature/',
        data: feature
      }).then(
        function(response) {
          return response.data;
        },
        function(error) {
          $log.error(error);
        }
      );
    }

    function copyTaskInFeature(featureId, task) {
      return $http({
        method: 'POST',
        url: API_URL + 'features/' + featureId + '/task/',
        data: task
      }).then(
        function(response) {
          return response.data;
        },
        function(error) {
          $log.error(error);
        }
      );
    }

    function addFeatures(phaseId, features) {
      return $http({
        method: 'POST',
        url: API_URL + 'phases/' + phaseId + '/features/',
        data: features
      }).then(
        function(response) {
          return response.data;
        },
        function(error) {
          $log.error(error);
        }
      );
    }

    function addPhases(id, phases) {
      return $http({
        method: 'POST',
        url: API_URL + 'estimates/' + id + '/phases/',
        data: phases
      }).then(
        function(response) {
          return response.data;
        },
        function(error) {
          $log.error(error);
        }
      );
    }

    function getPhaseTemplates() {
      return $http({
        method: 'GET',
        url:  API_URL + 'tags/'
      });
    }

    function getPhaseTemplate(id) {
      return $http({
        method: 'GET',
        url:  API_URL + 'tags/' + id
      });
    }

    function getFeatureTemplates() {
      return $http({
        method: 'GET',
        url:  API_URL + 'groups/'
      });
    }

    function getFeatureTemplate(id) {
      return $http({
        method: 'GET',
        url:  API_URL + 'groups/' + id
      });
    }

    function getTaskTemplates() {
      return $http({
        method: 'GET',
        url:  API_URL + 'workhours/'
      });
    }

    function getTaskTemplate(id) {
      return $http({
        method: 'GET',
        url:  API_URL + 'workhours/' + id
      });
    }

    function updatePhases(phases) {
      return $http({
        method: 'PUT',
        url:  API_URL + 'phases/',
        data: phases
      });
    }

    function updateStatistic(stats, id) {
      var q = $q.defer();
      $http({
        method: 'PUT',
        url:  API_URL + 'estimates/' + id + '/statistics',
        data: stats
      }).then(q.resolve, q.reject);
      return q.promise;
    }

    function getStatistic(id) {
      var q = $q.defer();
      $http({
        method: 'GET',
        url:  API_URL + 'statistics/' + id
      }).then(q.resolve, q.reject);
      return q.promise;
    }

    function getUsersStatuses() {
      var q = $q.defer();
      $http({
        method: 'GET',
        url: API_URL + 'users/'
      }).then(function(res) {
        q.resolve(res.data);
      }, q.reject);
      return q.promise;
    }

    function saveStatusEstimate(idEst, idStatus) {
      var q = $q.defer();
      $http({
        method: 'PUT',
        url:  API_URL + 'estimates/' + idEst + '/status/',
        data: {statusId: idStatus}
      }).then(q.resolve, q.reject);
      return q.promise;
    }

    function getStatusWorkflow(estimateId, statusId) {
      var q = $q.defer();
      $http({
        method: 'GET',
        url: API_URL + 'estimates/' + estimateId + '/workflow/' + statusId
      }).then(function(res) {
        q.resolve(res.data);
      }, q.reject);
      return q.promise;
    }

    function searchEstimate(filter) {
      return $http({
        method: 'POST',
        url: API_URL + 'estimates/search/',
        data: filter
      }).then(
        function(response) {
          return response.data;
        },
        function(error) {
          $log.error(error);
        }
      );
    }

    function pastePhaseIntoEstimate(estimateId, phaseId) {
      return $http({
        method: 'POST',
        url: API_URL + 'estimates/' + estimateId + '/paste/' + phaseId,
        data: {
          estimateId: estimateId,
          phaseId: phaseId
        }
      }).then(
        function(response) {
          return response.data;
        },
        function(error) {
          $log.error(error);
        }
      );
    }

    function isRootUser() {
      return $http({
        method: 'GET',
        url: API_URL + 'users/isSuperUserForEstimate'
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
          $log.error(error);
      });
    }

  }
})();

(function() {
  'use strict';

  angular.module('estimateMeUi').factory('BreadCrumbs', Breadcrumbs);
  function Breadcrumbs($timeout) {
    var listeners = [];
    var crumbs = [];

    function executeListeners() {
      listeners.forEach(function(listener) {
        listener(crumbs);
      });
    }
    return {
      addCrumbs: function(newCrumbs) {
        if (angular.isObject(newCrumbs)) {
          var isArray = newCrumbs instanceof Array;
          $timeout(function() {
            if (isArray) {
              [].push.apply(crumbs, newCrumbs);
            } else {
              crumbs.push(newCrumbs);
            }
            executeListeners();
          });
          return function(newName) {
            if (angular.isString(newName)) {
              if (!isArray) {
                newCrumbs.name = newName;
              }
            } else {
              if (isArray) {
                newCrumbs.forEach(function(crumb) {
                  crumbs.splice(crumbs.indexOf(crumb),1);
                });
              } else {
                crumbs.splice(crumbs.indexOf(newCrumbs),1);
              }
            }
            executeListeners();
          };
        }
      },
      addListener: function(listener) {
        if (!angular.isFunction(listener)) {
          throw new Error('Listener must be a function');
        }
        listeners.push(listener);
        listener(crumbs);
        return function() {
          listeners.splice(listeners.indexOf(listener),1);
        };
      }
    };
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name Auth
   * @memberOf estimateMeUi
   * @description
   *  Сервис для управления авторизацией пользователя.
   */
  angular
    .module('estimateMeUi')
    .service('Auth', Auth);

  /** @ngInject */
  function Auth($localStorage, $http, $q, API_URL, $state, Access, $window) {
    this.isAuth = function() {
      return !!$localStorage.userToken;
    };

    /**
     * @ngdoc method
     * @name authenticate
     * @memberOf estimateMeUi.Auth
     * @description
     *  Метод авторизации на удаленном API.
     *
     * @param {string} email Email пользователя
     * @param {string} password Пароль пользователя
     * @returns {Promise} Результат-обещание запроса к API сервера с попыткой авторизоваться.
     */
    this.authenticate = Authenticate;

    this.fbAuth = fbAuth;
    this.onFBResponseChange = fbResponseChangeHandle;

    this.refreshAuth = RefreshAuth;

    /**
     * @ngdoc method
     * @name logout
     * @memberOf estimateMeUi.Auth
     * @description
     *  Метод для разлогирования пользователя. В случае успешного завершения метода удаляются:
     *  <ul><li>Объект токена из $localStorage</li>
     *  <li>Заголовок Authorization из $http.defaults.headers.common</li><ul>
     *
     * @returns {Promise} Результат-обещание запроса к API сервера с попыткой разлогиниться.
     */
    this.logout = Logout;

    function Authenticate(login, password) {
      return authRequest({
        method: 'POST',
        url: API_URL + 'auth/login',
        data: {
          login: login,
          password: password
        }
      });
    }

    function fbResponseChangeHandle(response) {
      if (response.status === 'connected') {
       var accessToken = response.authResponse.accessToken;

        return authRequest({
          method: 'POST',
          url: API_URL + 'auth/facebook',
          data: {
            accessToken: accessToken
          }
        });
      } else {
        return $q.reject();
      }
    }

    function fbAuth() {
      var deferred = $q.defer();

      $window.FB.login(function (response) {
        fbResponseChangeHandle(response).then(function (response) {
          deferred.resolve(response);
        }, deferred.reject)
      }, {
        scope: 'public_profile, email',
        return_scopes: true
      });
      return deferred.promise;
    }

    function authRequest(request) {
      return $http(request)
        .then(handleAuthResponse)
        .then(function (response) {
            return response;
        });
    }

    function handleAuthResponse(response) {
      if (!response) {
        return $q.reject();
      }

      $localStorage.userToken = response.data;
      $http.defaults.headers.common.Authorization = 'Bearer ' + $localStorage.userToken.token;
      Access.setUserRole(response.data);
      return $q.resolve(response);
    }

    function Logout() {
      var deferred = $q.defer();
      $http({
        method: 'DELETE',
        url: API_URL + 'auth/logout'
      }).then(function(response) {

        delete $localStorage.userToken;
        delete $http.defaults.headers.common.Authorization;
        $state.go('login');
        deferred.resolve(response);
      }, function(reject) {
        deferred.reject(reject);
      });
      return deferred.promise;
    }

    function RefreshAuth() {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        url: API_URL + 'auth/refresh'
      }).then(function(response) {

        $localStorage.userToken = response.data;
        $http.defaults.headers.common.Authorization = 'Bearer ' + $localStorage.userToken.token;

        deferred.resolve(response);
      }, function(reject) {
        deferred.reject(reject);
      });
      return deferred.promise;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('estimateMeUi')
    .factory('AuthInterceptor', AuthInterceptor);

  function AuthInterceptor($localStorage, $q, moment, $log, API_URL, $injector) {

    var countToEstimate = 10;
    var itemsToEstimate = 'minutes';

    return {
      'responseError': function(response) {
        var deferred = $q.defer();
        var $state = $injector.get('$state');
        if (response.status === 401) {
          delete $injector.get('$http').defaults.headers.common.Authorization;
          delete $localStorage.userToken;
          $log.log('[AuthInterceptor] : Token failed.');

          $state.go('login');
          deferred.reject(response);
        }
        if (response.status === 404) {
          deferred.reject(response);
        }
        if (response.status === 500) {
          deferred.reject(response);
        }
        return deferred.promise;
      },
      request: function(config) {
        var deferred = $q.defer();

        if (!!$localStorage.userToken &&
          moment($localStorage.userToken.expire,'x') <= moment().add(countToEstimate, itemsToEstimate) &&
          config.url.indexOf(API_URL) >= 0 &&
          config.url !== API_URL + 'auth/refresh'
        ) {
          $log.log('[AuthInterceptor] : User token expires in ' + countToEstimate + ' ' + itemsToEstimate +
              '. Must be updated.');

          $injector.get('Auth').refreshAuth().then(
            function() {
              deferred.resolve(config);
            },
            function() {
              $log.log('[AuthInterceptor] : Token failed to update.');

              delete $injector.get('$http').defaults.headers.common.Authorization;
              delete $localStorage.userToken;

              $injector.get('$state').go('login');
              deferred.reject(config);
            }
          );
        } else {
          if ($localStorage.userToken) {
            $injector.get('$http').defaults.headers.common.Authorization = 'Bearer ' + $localStorage.userToken.token;
          }
          deferred.resolve(config);
        }

        return deferred.promise;
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('estimateMeUi')
    .service('Access', Access);

  /** @ngInject */
  function Access($q, $http, $log, API_URL, $localStorage) {
    this.GetAccessList = getAccessList;
    this.createNewRole = createNewRole;
    this.getRoleList = getRoleList;
    this.setUserRole = setUserRole;
    this.getUserRole = getUserRole;
    this.checkStatePermission = checkStatePermission;
    this.checkActionPermission = checkActionPermission;
    this.changeUserRole = changeUserRole;
    var role = {
      name: 'defaulUserRole',
      permissions: {
        estimate: {
          all: [
            'list',
            'view',
            //'update',
            //'delete',
            'create',
            'export'
          ],
          approvers: [
            'view',
            'update',
            'create',
            'export'
          ],
          ownEstimate: [
            'view',
            'update',
            'create',
            'delete',
            'export'
          ]

        },
        currency: {
          all: [
            'update',
            'create',
            'delete'
          ]
        },
        group: {
          all: [
            'list',
            'view',
            'update',
            'delete',
            'create'
          ]
        },
        role: {
          all: [
            'list',
            'view',
            'update',
            //'delete',
            'create'
          ]
        },
        tag: {
          all: [
            'list',
            'view',
            'update',
            'delete',
            'create'
          ]
        },
        workhour: {
          all: [
            'list',
            'view',
            'update',
            'delete',
            'create'
          ]
        }
      }
    };

    var id;
    if ($localStorage.userToken) {
      id = $localStorage.userToken.user;
      role = $localStorage.userToken.role || role;
    }

    function setUserRole(user) {
      role = user.role || role;
      id = user.user;
    }

    function getUserRole() {
      return role;
    }

    function checkStatePermission(toState) {
      var accessGranted = true;
      if (toState.name === 'index.tags') {
        accessGranted = checkActionPermission({
          entity: 'tag',
          action: 'list'
        });
      } else if (toState.name === 'index.tags.edit') {
        accessGranted = checkActionPermission({
          entity: 'tag',
          action: 'view'
        });
      } else if (toState.name === 'index.groups') {
        accessGranted = checkActionPermission({
          entity: 'group',
          action: 'list'
        });
      } else if (toState.name === 'index.workhours') {
        accessGranted = checkActionPermission({
          entity: 'workhour',
          action: 'list'
        });
      } else if (toState.name === 'index.roles') {
        accessGranted = checkActionPermission({
          entity: 'role',
          action: 'list'
        });
      } else if (toState.name === 'index.admin') {
        accessGranted = checkActionPermission({
           entity: 'user',
           action: 'list'
         });
      }
      return accessGranted;
    }

    function checkActionPermission(action) {
      var accessGranted = false;
      if (action.entity && role.permissions && role.permissions.all) {
        if (role.permissions.all.all) {
          accessGranted = inArray(role.permissions.all.all, action.action);
          if (accessGranted) {
            return true;
          }
        }
        if (role.permissions.all.ownEstimate && action.owners) {
          accessGranted = checkPermission(action.owners, action.action, role.permissions.all.ownEstimate);
          if (accessGranted) {
            return true;
          }
        }
      }
      if (action.entity && role.permissions && role.permissions[action.entity]) {
        if (role.permissions[action.entity].all) {
          accessGranted = inArray(role.permissions[action.entity].all, action.action);
          if (accessGranted) {
            return true;
          }
        }
        if (role.permissions[action.entity].ownEstimate) {
          if (action.owners && action.owners.length) {
            accessGranted = checkPermission(action.owners, action.action, role.permissions[action.entity].ownEstimate);
          } else {
            accessGranted = inArray(role.permissions[action.entity].ownEstimate, action.action);
          }
          if (accessGranted) {
            return true;
          }
        }
        if (role.permissions[action.entity].participant) {
          if (action.participants) {
            accessGranted = checkPermission(action.participants, action.action, role.permissions[action.entity].participant);
          } else {
            accessGranted = inArray(role.permissions[action.entity].participant, action.action);
          }
          if (accessGranted) {
            return true;
          }
        }
        if (role.permissions[action.entity].approvers) {
          if (action.approvers) {
            accessGranted = checkPermission(action.approvers, action.action, role.permissions[action.entity].approvers);
          } else {
            accessGranted = inArray(role.permissions[action.entity].approvers, action.action);
          }
          if (accessGranted) {
            return true;
          }
        }
        if (role.permissions[action.entity].managers) {
          if (action.managers) {
            accessGranted = checkPermission(action.managers, action.action, role.permissions[action.entity].managers);
          } else {
            accessGranted = inArray(role.permissions[action.entity].managers, action.action);
          }
          if (accessGranted) {
            return true;
          }
        }
      }
      return accessGranted;
    }

    function checkPermission(owners, action, entityPermissions) {
      if (isOwn(owners)) {
        return inArray(entityPermissions, action);
      }
      return false;
    }

    function isOwn(owners) {
      var i = owners.findIndex(function(owner) {
        return owner._id === id;
      });
      if (i === -1) {
        return false;
      }
      return true;
    }

    function inArray(array, item) {
      var i = array.indexOf(item);
      return i !== -1;
    }

    function getAccessList() {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        url: API_URL + 'auth/access/list'
      }).then(function(response) {
        if (!response) {
          return deferred.reject();
        }
        deferred.resolve(response);
      }, function(reject) {
        deferred.reject(reject.data);
      });
      return deferred.promise;
    }

    function createNewRole(name, permissions) {
      var deferred = $q.defer();
      $http({
        method: 'POST',
        url: API_URL + 'roles',
        data: {
          name: name,
          permissions: permissions
        }
      }).then(function(response) {
        if (!response) {
          return deferred.reject();
        }
        deferred.resolve(response);
      }, function(reject) {
        deferred.reject(reject.data);
      });
      return deferred.promise;
    }

    function getRoleList() {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        url: API_URL + 'roles'
      }).then(function(response) {
        if (!response) {
          return deferred.reject();
        }
        deferred.resolve(response.data);
      }, function(reject) {
        deferred.reject(reject.data);
      });
      return deferred.promise;
    }

    function changeUserRole(id, roleID) {
      var deferred = $q.defer();
      $http({
        method: 'PUT',
        url: API_URL + 'users/' + id + '/role/' + roleID
      }).then(function(response) {
        if (!response) {
          return deferred.reject();
        }
        deferred.resolve(response.data);
      }, deferred.reject);
      return deferred.promise;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('estimateMeUi')
    .filter('truncate', truncate);

  /** @ngInject */
  function truncate() {
    return function(value, max, tail) {
      if (!value) {
        return '';
      }
      max = parseInt(max, 10);
      if (!max) {
        return value;
      }
      if (value.length <= max) {
        return value;
      }
      value = value.substr(0, max);
      return value + tail;
    };
  }
})();

(function() {
'use strict';
angular.module('estimateMeUi')
  .directive('ngThumb', ngThumb);

  /**@ngInject*/
  function ngThumb() {

    return {
      restrict: 'A',
      scope: {
          ngThumb: '='
        },
      template: '<canvas/>',
      link: function(scope, element) {

        var params = scope.ngThumb;

        var canvas = element.find('canvas');
        var reader = new FileReader();

        reader.onload = onLoadFile;
        reader.readAsDataURL(params.file);

        function onLoadFile(event) {
          var img = new Image();
          img.onload = onLoadImage;
          img.src = event.target.result;
        }

        function onLoadImage() {
          var width = params.width || this.width / this.height * params.height;
          var height = params.height || this.height / this.width * params.width;
          canvas.attr({width: width, height: height});
          canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
        }
      }
    };
  }
})();

(function() {
  'use strict';
  angular.module('estimateMeUi').run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $state, Auth, $http, $localStorage, moment, Access, Redirector, $window, FB_ID) {
    $window.fbAsyncInit = function() {
      $window.FB.init({
        appId      : FB_ID,
        cookie     : true,
        xfbml      : true,
        version    : 'v5.0'
      });

      /*$window.FB.Event.subscribe('auth.authResponseChange', function (response) {
        console.log('auth.authResponseChange');
        Auth.onFBResponseChange(response);
      });*/
    }

    var stateChangeStartDestroy = $rootScope.$on('$stateChangeStart', function(e, toState, toParams) {
      if (!Auth.isAuth() && (!toState.hasOwnProperty('data') || !toState.data.hasOwnProperty('auth') ||
          toState.data.auth === true)) {
        e.preventDefault();
        Redirector.setState(toState.name, toParams);
        $state.go('login');
      } else if (Auth.isAuth() && !Access.checkStatePermission(toState)) {
        e.preventDefault();
        $state.go('index.estimates');
      }
    });
    if (!$localStorage.userToken || moment($localStorage.userToken.expire, 'x') <= moment()) {
      delete $localStorage.userToken;
    } else {
      $http.defaults.headers.common.Authorization = 'Bearer ' + $localStorage.userToken.token;
    }
    $rootScope.$on('$destroy', stateChangeStartDestroy);
    $rootScope.header = '';
  }
})();

(function() {
  'use strict';
  angular.module('estimateMeUi')
    .config(routerConfig);
  /**ngInject*/
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false
    }).hashPrefix('!');
    $urlRouterProvider
      .when('', '/')
      .when('/', '/estimates')
      .otherwise('/estimates');

    $stateProvider
      .state('index', {
        url: '/',
        resolve: {
          usersStatuses: function(EstimatesApi, $q){
            var q = $q.defer();
            EstimatesApi.getUsersStatuses()
              .then(function(res) {
                q.resolve(res);
              })
              .catch(function(err) {
                q.reject(err);
              });
            return q.promise;
          }
        },
        controller: 'navBarController',
        controllerAs: 'vm',
        templateUrl: '/app/pages/index/navBar.html'
      })
      .state('index.estimates', {
        url: 'estimates',
        resolve: {
          header: function() {
            return {
              name: 'Оценки',
              link: 'index.estimates'
            };
          }
        },
        views: {
          'content': {
            controllerAs: 'vm',
            controller: 'EstimatesListController',
            templateUrl: '/app/pages/index/estimatesView.html'
          }
        }
      })
      .state('index.estimates.edit', {
        url: '/:estimate',
        resolve: {
          header: function() {
            return {
              name: 'Оценки',
              link: 'index.estimates'
            };
          },
          roles: function(EstimatesApi) {
            return EstimatesApi.getDictionaryRoles();
          },
          project: function(Access, $stateParams, EstimatesApi, $state, $q) {
            var q = $q.defer();
            EstimatesApi.getEstimate($stateParams.estimate)
              .then(function(response) {
                var accessGranted = Access.checkActionPermission(
                  {
                    entity: 'estimate',
                    action: 'view',
                    owners: response.authors
                  }
                );
                if (!accessGranted) {
                  return $state.go('index.estimates');
                }
                q.resolve(response);
              })
              .catch(function(err) {
                if (err.status === 500) {
                  return $state.go('index.estimates', {estimate: $stateParams.estimate});
                }
                q.reject({});
              });

            return q.promise;
          },
          currentTab: function() {
            var tab = {
              type: ''
            };
            return {
              setTab: function(newTab) {
                angular.extend(tab, {
                  type: newTab.type,
                  data: newTab.data || null
                });
              },
              getTab: function() {
                return tab;
              }
            };
          }
        },
        views: {
          'content@index': {
            controllerAs: 'vm',
            controller: 'EstimateEditController',
            templateUrl: '/app/pages/index/headerView.html'
          },
          'phase@index.estimates.edit': {
            controllerAs: 'vm',
            controller: 'EstimateAboutController',
            templateUrl: '/app/pages/index/estimateAbout.html'
          }
        }
      })
      .state('index.estimates.edit.edit', {
        url: '/edit',
        params: {
          newEstimate: false
        },
        views: {
          'phase': {
            controllerAs: 'vm',
            controller: 'EstimateAboutEditController',
            templateUrl: '/app/pages/index/estimateEditView.html'
          }
        }
      })
      .state('index.estimates.edit.phases', {
        url: '/phases/:phase',
        resolve: {
          header: function() {
            return {
              name: 'Фазы'
            };
          }
        },
        views: {
          'phase': {
            controllerAs: 'vm',
            controller: 'EstimateEditPhaseController',
            templateUrl: '/app/pages/index/phaseEditView.html'
          }
        }
      })
      .state('index.tags', {
        url: 'tags',
        resolve: {
          tags: function(EstimatesApi, $q) {
            var q = $q.defer();
            EstimatesApi.getDictionaryTags()
              .then(function(response) {
                q.resolve(response.content);
              })
              .catch(function(err) {
                q.reject(err);
              });
            return q.promise;
          },
          header: function() {
            return [
              {
                name: 'Оценки',
                link: 'index.estimates'
              },
              {
                name: 'Справочник фаз',
                link: 'index.tags'
              }
            ];
          }
        },
        views: {
          'content': {
            controllerAs: 'vm',
            controller: 'PhaseTemplatesController',
            templateUrl: '/app/pages/index/phaseTemplatesView.html'
          }
        }
      })
      .state('index.tags.edit', {
        url: '/:phaseId',
        views: {
          'phase': {
            controllerAs: 'vm',
            controller: 'PhaseTemplateEditController',
            templateUrl: '/app/pages/index/phaseTemplateEditView.html'
          }
        }
      })
      .state('index.groups', {
        url: 'groups',
        params: {
          link: 'index.groups.phase'
        },
        resolve: {
          tags: function(EstimatesApi, $q) {
            var q = $q.defer();
            EstimatesApi.getDictionaryTags()
              .then(function(response) {
                q.resolve(response.content);
              })
              .catch(function(err) {
                q.reject(err);
              });
            return q.promise;
          },
          header: function() {
            return [
              {
                name: 'Оценки',
                link: 'index.estimates'
              },
              {
                name: 'Справочник фич',
                link: 'index.groups'
              }
            ];
          }
        },
        views: {
          'content@index': {
            controllerAs: 'vm',
            controller: 'TemplateHeaderController',
            templateUrl: '/app/pages/index/templateHeader.html'
          }
        }
      })
      .state('index.groups.phase', {
        url: '/:phaseId',
        views: {
          'template@index.groups': {
            controllerAs: 'vm',
            controller: 'FeatureTemplateEditController',
            templateUrl: '/app/pages/index/featureTemplateEditView.html'
          }
        }
      })
      .state('index.workhours', {
        url: 'workhours',
        params: {
          link: 'index.workhours.phase'
        },
        resolve: {
          tags: function(EstimatesApi, $q) {
            var q = $q.defer();
            EstimatesApi.getDictionaryTags()
              .then(function(response) {
                q.resolve(response.content);
              })
              .catch(function(err) {
                q.reject(err);
              });
            return q.promise;
          },
          header: function() {
            return [
              {
                name: 'Оценки',
                link: 'index.estimates'
              },
              {
                name: 'Справочник нормочасов',
                link: 'index.workhours'
              }
            ];
          }
        },
        views: {
          'content@index': {
            controllerAs: 'vm',
            controller: 'TemplateHeaderController',
            templateUrl: '/app/pages/index/templateHeader.html'
          }
        }
      })
      .state('index.workhours.phase', {
        url: '/:phaseId',
        views: {
          'template@index.workhours': {
            controllerAs: 'vm',
            controller: 'TaskTemplateEditController',
            templateUrl: '/app/pages/index/taskTemplateEditView.html'
          }
        }
      })
      .state('index.costs', {
        url: 'costs',
        resolve: {
          header: function() {
            return 'Стоимость';
          }
        },
        views: {
          'content': {
            controllerAs: 'vm',
            controller: 'FeatureTemplatesController',
            template: ''
          }
        }
      })
      .state('index.roles', {
        url: 'roles',
        resolve: {
          header: function() {
            return [
              {
                name: 'Оценки',
                link: 'index.estimates'
              },
              {
                name: 'Справочник ролей',
                link: 'index.roles'
              }
            ];
          }
        },
        views: {
          'content': {
            controllerAs: 'vm',
            controller: 'RoleTemplateEditController',
            templateUrl: '/app/pages/index/roleTemplateEditView.html'
          }
        }
      })
      .state('index.currencies', {
        url: 'currencies',
        resolve: {
          header: function() {
            return 'Валюты';
          }
        },
        views: {
          'content': {
            controllerAs: 'vm',
            controller: 'FeatureTemplatesController',
            template: ''
          }
        }
      })      
      .state('index.chart', {
        url: 'chart',
        views: {
          'content': {
            controllerAs: 'vm',
            controller: 'ChartController',
            templateUrl: '/app/pages/index/chartView.html'
          }
        }
      }) 
      .state('login', {
        url: '/login',
        controller: 'LoginFormController',
        controllerAs: 'vm',
        templateUrl: '/app/pages/login/login.html',
        data: {
          auth: false
        }
      })
      .state('logout', {
        url: '/logout',
        controller: 'LogoutStateController',
        controllerAs: 'vm',
        template: ''
      })
      .state('remove_accaunt', {
        url: '/quit',
        controller: 'RemoveAccauntStateController',
        controllerAs: 'vm',
        template: '',
        resolve: {
          PreviousState: ["$state", function ($state) {
            var currentStateData = {
                Name: $state.current.name,
                Params: angular.copy($state.params),
                URL: $state.href($state.current.name, $state.params)
            };
            return currentStateData;
          }]
        }
      })
      /*.state('index.admin', {
        url: 'admin',
        resolve: {
          header: function() {
            return {
              name: 'Управление ролями'
            };
          },
          onEnter: function(Preloader) {
            Preloader.openPreloader();
          }
        },
        views: {
          'content': {
            controllerAs: 'vm',
            controller: 'EditUserRolesController',
            templateUrl: '/app/pages/index/editUserRolesView.html'
          }
        }
      })*/;

  }

})();

/* global moment:false */
/* global estimateConfig:false */

(function() {
  'use strict';

  angular
    .module('estimateMeUi')
    .constant('moment', moment)
    .constant('API_URL', estimateConfig.api + 'api/')
    .constant('FB_ID', estimateConfig.fbId);
})();

(function() {
  'use strict';

  angular
    .module('estimateMeUi')
    .config(config);

  /** @ngInject */
  function config($logProvider, $localStorageProvider, $httpProvider, RestangularProvider, API_URL) {
    $logProvider.debugEnabled(true);

    $localStorageProvider.setKeyPrefix('esm-');

    RestangularProvider.setBaseUrl(API_URL);

    $httpProvider.interceptors.push('AuthInterceptor');
  }

})();

(function() {
  'use strict';

  angular
    .module('estimateMeUi')
    .config(palleteConfig);

  /** @ngInject */
  function palleteConfig($mdThemingProvider) {
    var customPrimary = {
      '50': '#E3F2FD',
      '100': '#BBDEFB',
      '200': '#90CAF9',
      '300': '#64B5F6',
      '400': '#42A5F5',
      '500': '#1b3c90',
      '600': '#1E88E5',
      '700': '#1b3c90',
      '800': '#1565C0',
      '900': '#0D47A1',
      'A100': '#82B1FF',
      'A200': '#448AFF',
      'A400': '#2979FF',
      'A700': '#2962FF',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': '50 100 200 A100 A200'
    };

    var customAccent = {
      '50': '#f4fcfb',
      '100': '#19213f',
      '200': '#8ddfd9',
      '300': '#55cfc6',
      '400': '#3dc8be',
      '500': '#ffffff',
      '600': '#2c9c94',
      '700': '#25847e',
      '800': '#1f6c67',
      '900': '#185550',
      'A100': '#f4fcfb',
      'A200': '#19213f',
      'A400': '#3dc8be',
      'A700': '#25847e',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': '50 100 200 300 400 500 A100 A200 A400'
    };

    var customWarn = {
      '50': '#fefffb',
      '100': '#e4f9b4',
      '200': '#d1f580',
      '300': '#b8f03e',
      '400': '#aeee21',
      '500': '#d32c00',
      '600': '#8bc40f',
      '700': '#8bc40f',
      '800': '#628b0b',
      '900': '#4e6e08',
      'A100': '#fefffb',
      'A200': '#e4f9b4',
      'A400': '#aeee21',
      'A700': '#77a70d',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': '50 100 200 300 400 500 600 700 A100 A200 A400 A700'
    };

    var customBackground = {
      '50': '#fafafa',
      '100': '#f5f5f5',
      '200': '#dedede',
      '300': '#e0e0e0',
      '400': '#bdbdbd',
      '500': '#19213f',
      '600': '#f2f2f2',
      '700': '#757575',
      '800': '#d9d9d9',
      '900': '#cccccc',
      'A100': '#eef3f6',
      'A200': '#eef3f6',
      'A400': '#eef3f6',
      'A700': '#2b2b2b'
    };

    $mdThemingProvider
      .definePalette('customPrimary', customPrimary);

    $mdThemingProvider
      .definePalette('customAccent', customAccent);

    $mdThemingProvider
      .definePalette('customWarn', customWarn);

    $mdThemingProvider
      .definePalette('customBackground', customBackground);

    $mdThemingProvider.theme('default')
      .primaryPalette('customPrimary')
      .accentPalette('customAccent')
      .warnPalette('customWarn')
      .backgroundPalette('customBackground');
  }

})();


angular.module("estimateMeUi").run(["$templateCache", function($templateCache) {$templateCache.put("/app/components/views/associateWorkhour.html","<md-dialog class=\"associateModal\"><md-icon ng-click=\"vm.closeModal()\" class=\"pointer close-btn\">close</md-icon><div class=\"text-header\">Ассоциация с фазами</div><ul class=\"phase-list\"><li ng-repeat=\"phase in vm.listPhases\" class=\"list-icon\"><md-checkbox ng-model=\"phase.checked\" class=\"md-primary\"><span>{{phase.name}}</span></md-checkbox></li></ul><md-button ng-click=\"vm.saveAddingTasks()\" ng-disabled=\"!vm.hasCheckedPhase()\" class=\"md-primary\">Сохранить</md-button></md-dialog>");
$templateCache.put("/app/components/views/estimateNewCurrency.html","<md-dialog flex=\"60\" layout=\"column\" class=\"addingModal\"><div class=\"md-headline text-header\">Новая валюта</div><md-divider></md-divider><div><form name=\"estimateNewCurrency\"><div layout=\"row\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\"><input ng-model=\"vm.bufferCurrency\" name=\"bufferCurrency\" ng-keypress=\"vm.addBufferCurrency($event)\" placeholder=\"Введите название валюты и нажмите клавишу &lt;Ввод&gt;\"></md-input-container><md-icon ng-click=\"vm.addBufferCurrency($event)\" style=\"margin:0;\" class=\"material-icons text-header pointer\">add_circle<md-tooltip md-direction=\"top\">Добавить</md-tooltip></md-icon></div><ul><li ng-repeat=\"newCurrency in vm.bufferCurrencies\" class=\"list-icon\"><md-icon ng-click=\"vm.deleteBufferCurrency($index)\" class=\"material-icons text-header pointer\">cancel<md-tooltip md-direction=\"top\">Удалить валюту</md-tooltip></md-icon><span>{{newCurrency}}</span></li></ul></form></div><md-divider></md-divider><md-button ng-click=\"vm.saveAddingCurrencies()\" ng-disabled=\"vm.bufferCurrencies.length === 0\" class=\"md-primary\">Сохранить</md-button></md-dialog>");
$templateCache.put("/app/components/views/estimateNewFeature.html","<md-dialog flex=\"none\" layout=\"column\" class=\"addingModal\"><md-content class=\"tabs padding\"><md-tabs md-selected=\"vm.currentPhase.selected\"><md-tab ng-repeat=\"phase in vm.phases\" md-on-select=\"vm.onPhaseSelected(phase)\"><md-tab-label><label class=\"pointer\">{{phase.name}}</label></md-tab-label></md-tab></md-tabs></md-content><md-divider></md-divider><div class=\"dialog-header\"><label>Выберите фичу</label></div><div layout=\"column\" ng-if=\"vm.isShowTemplate\" flex=\"\" class=\"inner-block\"><div layout=\"column\" flex=\"none\" class=\"fixed-table-header\"><div layout=\"row\" layout-align=\"end end\" class=\"table-header\"><div class=\"hours-column text-center\">Часы</div></div><div layout=\"row\" layout-align=\"start end\" class=\"table-header\"><div layout-align=\"end start\" flex=\"none\" class=\"name-column\"><label>Название, описаниe</label></div><div layout-align=\"end start\" flex=\"none\" class=\"roles-column\"><label>Роль</label></div><div layout=\"row\" flex=\"none\" class=\"hours-column text-center\"><label flex=\"grow\" class=\"text-center\">от</label> <label flex=\"nogrow\" class=\"text-center\">-</label> <label flex=\"grow\" class=\"text-center\">до</label></div></div></div><md-divider></md-divider><div layout=\"column\" flex=\"\" class=\"fixed-height\"><div class=\"table-body\"><div ng-repeat=\"patternFeature in vm.listPatterns | filter: vm.phaseFilter\" layout=\"column\"><div layout=\"row\" layout-align=\"start end\" class=\"table-row min-height\"><div layout=\"row\" layout-align=\"start start\" flex=\"none\" class=\"checkbox-column\"><md-checkbox ng-model=\"patternFeature.checked\" class=\"md-primary\"><div flex=\"none\" class=\"name-column\"><div ng-class=\"{\'padding\': patternFeature.workhours.length === 0}\" class=\"name\"><md-icon ng-show=\"patternFeature.workhours.length &gt; 0\" ng-click=\"vm.changeListState($event, patternFeature)\" class=\"pointer wrap-ico\"><span ng-if=\"!patternFeature.opened\">chevron_right</span><span ng-if=\"patternFeature.opened\">expand_more</span></md-icon>{{ patternFeature.name }}</div></div></md-checkbox></div><div flex=\"none\" class=\"roles-column\"><div>{{ patternFeature.composedRole }}</div></div><div layout=\"row\" layout-align=\"center end\" flex=\"none\" class=\"hours-column\"><div flex=\"50\" class=\"text-center\">{{ patternFeature.minHours }}</div><div flex=\"50\" class=\"text-center\">{{ patternFeature.maxHours }}</div></div></div><md-divider></md-divider><div ng-repeat=\"patternTask in patternFeature.workhours\" layout=\"column\" ng-show=\"patternFeature.opened\" class=\"table-row sublist-item\"><div layout=\"row\" class=\"item\"><div layout=\"column\" layout-align=\"end start\" flex=\"none\" class=\"name-column\"><div class=\"name\">{{ patternTask.link.name }}</div><div class=\"description\">{{ patternTask.link.description }}</div></div><div layout=\"row\" layout-align=\"start end\" flex=\"none\" class=\"roles-column\"><div>{{ patternTask.link.role.name }}</div></div><div layout=\"row\" layout-align=\"center end\" flex=\"none\" class=\"hours-column\"><div flex=\"50\" class=\"text-center\">{{ patternTask.link.minHours }}</div><div flex=\"50\" class=\"text-center\">{{ patternTask.link.maxHours }}</div></div></div><md-divider></md-divider></div></div></div></div></div><div layout=\"row\" layout-align=\"center center\" style=\"overflow: auto\" class=\"buttons-block\"><md-button ng-click=\"vm.saveAddingFeatures()\" ng-disabled=\"!vm.bufferFeature &amp;&amp; !vm.hasCheckedTemplate()\" id=\"save-adding-features-button\" class=\"md-primary\">Сохранить</md-button><md-button ng-click=\"vm.closeModal()\" id=\"close-button\" class=\"md-primary\">Закрыть</md-button></div></md-dialog>");
$templateCache.put("/app/components/views/estimateNewPhase.html","<md-dialog class=\"phaseModal\"><md-icon ng-click=\"vm.closeModal()\" class=\"pointer close-btn\">close</md-icon><div class=\"text-header\">Добавить новую фазу из справочника</div><ul class=\"phase-list\"><li ng-repeat=\"phase in vm.listPatterns\" class=\"list-icon\"><md-checkbox ng-model=\"phase.checked\" class=\"md-primary\"><span>{{phase.name}}</span></md-checkbox></li></ul><div ng-if=\"!vm.listPatterns.length\" class=\"empty-phase-list\">В справочнике нет ни одной фазы</div><div class=\"customField\"><label>Добавить новую кастомную фазу</label></div><div layout=\"row\" class=\"customInput\"><md-input-container layout=\"row\"><input ng-model=\"vm.bufferPhase\" placeholder=\"Введите название фазы\" ng-keypress=\"vm.addPhaseOnEnter($event)\" autofocus-input=\"\" id=\"save-adding-phases-button\" class=\"gray bold\"></md-input-container></div><md-button ng-click=\"vm.saveAddingPhases()\" ng-disabled=\"(!vm.bufferPhase &amp;&amp; !vm.hasCheckedTemplate()) || vm.formCheckedListPatterns()\" class=\"md-primary\">Сохранить {{vm.checkPhasesLength()}}</md-button></md-dialog>");
$templateCache.put("/app/components/views/estimateNewRole.html","<md-dialog flex=\"60\" layout=\"column\" class=\"addingModal\"><div class=\"md-headline text-header\">Новая роль</div><md-divider></md-divider><div><form name=\"estimateNewRole\"><div layout=\"row\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\"><input ng-model=\"vm.bufferRole\" name=\"bufferRole\" ng-keypress=\"vm.addBufferRole($event)\" placeholder=\"Введите название роли и нажмите клавишу &lt;Ввод&gt;\" id=\"role-name-input\"></md-input-container><md-icon ng-click=\"vm.addBufferRole($event)\" style=\"margin:0;\" class=\"material-icons text-header pointer\">add_circle<md-tooltip md-direction=\"top\">Добавить</md-tooltip></md-icon></div><ul><li ng-repeat=\"newRole in vm.bufferRoles\" class=\"list-icon\"><md-icon ng-click=\"vm.deleteBufferRole($index)\" class=\"material-icons text-header pointer\">cancel<md-tooltip md-direction=\"top\">Удалить роль</md-tooltip></md-icon><span>{{newRole}}</span></li></ul></form></div><md-divider></md-divider><md-button ng-click=\"vm.saveAddingRoles()\" ng-disabled=\"vm.bufferRoles.length === 0\" id=\"save-adding-roles-button\" class=\"md-primary\">Сохранить</md-button></md-dialog>");
$templateCache.put("/app/components/views/estimateNewTask.html","<md-dialog flex=\"none\" layout=\"column\" class=\"addingModal\"><md-content class=\"tabs padding\"><md-tabs md-selected=\"vm.currentPhase.selected\"><md-tab ng-repeat=\"phase in vm.phases\" md-on-select=\"vm.onPhaseSelected(phase)\"><md-tab-label><label class=\"pointer\">{{phase.name}}</label></md-tab-label></md-tab></md-tabs></md-content><md-divider></md-divider><div class=\"dialog-header\"><label>Выбрать задачу</label></div><div layout=\"column\" ng-if=\"vm.isShowTemplate\" flex=\"\" class=\"inner-block\"><div layout=\"column\" flex=\"none\" class=\"fixed-table-header\"><div layout=\"row\" layout-align=\"end end\" class=\"table-header\"><div class=\"hours-column text-center\">Часы</div></div><div layout=\"row\" layout-align=\"start end\" class=\"table-header\"><div layout-align=\"end start\" flex=\"none\" class=\"name-column\"><label>Название, описаниe</label></div><div layout-align=\"end start\" flex=\"none\" class=\"roles-column\"><label>Роль</label></div><div layout=\"row\" flex=\"none\" class=\"hours-column text-center\"><label flex=\"grow\" class=\"text-center\">от</label> <label flex=\"nogrow\" class=\"text-center\">-</label> <label flex=\"grow\" class=\"text-center\">до</label></div></div></div><md-divider></md-divider><div layout=\"column\" flex=\"\" class=\"fixed-height\"><div class=\"table-body\"><div ng-repeat=\"patternTask in vm.listPatterns | filter: vm.phaseFilter\" layout=\"row\" class=\"table-row\"><div layout=\"row\" layout-align=\"start start\" flex=\"none\" class=\"checkbox-column\"><md-checkbox ng-model=\"patternTask.checked\" aria-label=\"выбрать нормочас\" flex=\"none\" class=\"md-primary md-align-top-left\"><div layout=\"column\" class=\"name-column\"><div class=\"name\">{{ patternTask.name }}</div><div class=\"description\">{{ patternTask.description }}</div></div></md-checkbox></div><div layout=\"row\" layout-align=\"start end\" flex=\"none\" class=\"roles-column\"><div>{{ patternTask.role.name }}</div></div><div layout=\"row\" layout-align=\"center end\" flex=\"none\" class=\"hours-column\"><div flex=\"50\" class=\"text-center\">{{ patternTask.minHours }}</div><div flex=\"50\" class=\"text-center\">{{ patternTask.maxHours }}</div></div></div></div></div></div><div layout=\"row\" layout-align=\"center center\" style=\"overflow: auto\" class=\"buttons-block\"><md-button ng-click=\"vm.saveAddingTasks()\" ng-disabled=\"!vm.bufferTask &amp;&amp; !vm.hasCheckedTemplate()\" id=\"save-adding-tasks-button\" class=\"md-primary\">Сохранить</md-button><md-button ng-click=\"vm.closeModal()\" class=\"md-primary\">Закрыть</md-button></div></md-dialog>");
$templateCache.put("/app/components/views/estimateReorderPhase.html","<md-dialog class=\"phaseModal reorderPhases\"><md-icon ng-click=\"vm.closeModal()\" class=\"pointer close-btn\">close</md-icon><div class=\"text-header\">Изменить порядок фаз</div><div ui-tree=\"\"><ul ui-tree-nodes=\"\" ng-model=\"vm.phases\"><li ng-repeat=\"phase in vm.phases\" ui-tree-node=\"\" class=\"drag-wrapper phase\"><span class=\"phase-name\">{{phase.name}}</span><div ui-tree-handle=\"\" class=\"dragger\"><md-icon md-svg-src=\"/assets/images/drag_indicator.svg\"></md-icon></div></li></ul></div><md-button ng-click=\"vm.saveReorderPhases()\" id=\"save-reorder-phase-button\" class=\"md-primary md-raised phase-center\">Сохранить</md-button></md-dialog>");
$templateCache.put("/app/components/views/excelExportDialog.html","<md-dialog flex=\"50\"><div layout=\"column\" class=\"white\"><md-content class=\"content-dialog\"><div layout=\"row\" layout-align=\"space-between center\"><h2 class=\"md-headline text-header\">Экспортировать в Excel</h2><md-button ng-click=\"vm.close()\" class=\"md-icon-button close-button\"><md-icon class=\"text-header\">close</md-icon></md-button></div><div layout=\"column\" ng-if=\"vm.roleErrorMessage\" class=\"error\"><p>Не все роли заполнены!</p></div><div ng-if=\"!vm.roleErrorMessage\"><div layout=\"column\" ng-if=\"vm.messageError.length &gt; 0\" class=\"error\"><p>Роли не заполнены</p><div ng-repeat=\"value in vm.messageError track by $index\">{{value}}</div></div><div layout=\"row\" class=\"radio-button\"><div flex=\"50\"><p>Формат</p><md-radio-group ng-model=\"vm.data.format\"><div ng-repeat=\"item in vm.format\"><md-radio-button value=\"{{item.namekey}}\" class=\"md-primary\">{{item.name}}<md-tooltip ng-if=\"item.tooltip\" class=\"ml-tooltip\">{{item.tooltip}}</md-tooltip></md-radio-button></div></md-radio-group></div><div flex=\"50\" ng-if=\"vm.isManager\"><p>Валюта</p><md-radio-group ng-model=\"vm.data.currency\"><div ng-repeat=\"currency in vm.currencies\"><md-radio-button value=\"{{currency._id}}\" class=\"md-primary\">{{currency.name}}</md-radio-button></div></md-radio-group></div></div><div layout=\"column\" ng-if=\"vm.isManager\" class=\"role\"><div flex=\"\" layout=\"row\" class=\"role-header\"><p flex=\"25\">Роли</p><p flex=\"15\" style=\"text-align: right\">Ставка</p><p flex=\"10\" ng-if=\"vm.data.roles.length &gt; 1\"></p><p flex=\"25\" ng-if=\"vm.data.roles.length &gt; 1\">Роли</p><p flex=\"15\" style=\"text-align: right\" ng-if=\"vm.data.roles.length &gt; 1\">Ставка</p></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"vm.data.roles.length &gt; 0\"><div flex=\"50\" layout=\"row\" layout-align=\"center end\" ng-repeat=\"role in vm.data.roles\" class=\"row\"><div flex=\"50\">{{role.name}}</div><div flex=\"30\" layout=\"row\" layout-align=\"end end\"><md-input-container md-no-float=\"\" class=\"md-block noarrow\"><input ng-model=\"role.dict[vm.data.currency].value\" type=\"number\" placeholder=\"0\" min=\"0\"></md-input-container></div><div flex=\"20\"></div></div></div></div><div class=\"total-cost\"><div ng-show=\"vm.sum !== \'\'\" layout=\"row\" ng-if=\"vm.isManager\">Общая стоимость проекта<div class=\"colorgreen\">{{ vm.sum }}</div>{{vm.curren}}</div></div><div layout=\"row\" layout-align=\"center center\"><md-button style=\"font-size: 12px; text-transform: none; padding: 0 28px\" ng-click=\"vm.export($event)\" class=\"export-button md-raised md-primary\">Скачать</md-button></div></div></md-content></div></md-dialog>");
$templateCache.put("/app/components/views/getFile.html","<md-dialog flex=\"30\" style=\"text-align: center;\"><div layout=\"column\" class=\"white\"><md-content class=\"content-dialog\"><h2 class=\"md-headline text-header\">Файл сгенерирован</h2><a href=\"{{vm.link.link}}\" download=\"{{vm.link.filename}}\" target=\"_blank\" class=\"text-header\">Скачать</a><div layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"vm.close()\" class=\"text-header\">Закрыть</md-button></div></md-content></div></md-dialog>");
$templateCache.put("/app/components/views/newCategoryForm.html","<md-toolbar flex=\"\"><div class=\"md-toolbar-tools\"><h2>Create new category</h2></div></md-toolbar><md-content layout-padding=\"\"><form novalidate=\"\" ng-submit=\"vm.createNewCategory()\" name=\"newCategoryForm\"><md-input-container><label>Category Name</label> <input ng-model=\"vm.name\" name=\"categoryName\" required=\"\"><div ng-messages=\"newCategoryForm.categoryName.$error\"><div ng-message=\"required\" ng-show=\"newCategoryForm.categoryName.$error.required\">Field cannot be empty</div></div></md-input-container><md-input-container><md-button type=\"submit\" ng-click=\"vm.createNewCategory\" ng-disabled=\"newCategoryForm.categoryName.$error.required\" class=\"md-raised md-primary\">Create</md-button></md-input-container></form></md-content>");
$templateCache.put("/app/pages/index/chartView.html","<md-content class=\"tabs\"><md-tabs class=\"md-primary padding-content\"><md-tab ng-repeat=\"chart in vm.getCharts()\" md-on-select=\"vm.onChartSelected(chart)\"><md-tab-label><label class=\"pointer\">{{chart.name}}</label></md-tab-label></md-tab></md-tabs></md-content><div flex=\"\" class=\"estimate-projects wrap-copyright\"><md-content layout=\"column\" ng-cloak=\"\" class=\"padding-content content-copyright\"><div layout=\"row\" layout-align=\"flex-start\" style=\"margin-bottom: 5px; height: 30px;\" class=\"calendar-area\"><span flex=\"15\" style=\"margin-left:15px\">Начало диапазона</span><md-datepicker flex=\"20\" ng-model=\"vm.startDate\" ng-change=\"vm.onChartSelected(vm.currentChart)\"></md-datepicker><span flex=\"15\">Конец диапазона</span><md-datepicker flex=\"20\" column=\"2\" ng-model=\"vm.endDate\" ng-change=\"vm.onChartSelected(vm.currentChart)\"></md-datepicker></div><div id=\"container\"></div></md-content></div><copyright ng-show=\"true\"></copyright>");
$templateCache.put("/app/pages/index/editUserRolesView.html","<div flex=\"\" class=\"estimate-projects wrap-copyright\"><md-content layout=\"column\" ng-cloak=\"\" class=\"padding-content content-copyright\"><md-whiteframe layout=\"column\" ng-show=\"!vm.preloader\" class=\"md-whiteframe-3dp estimate-table\"><div layout=\"row\" layout-align=\"start end\" class=\"table-head\"><div flex=\"60\" ng-click=\"vm.changeSorting(\'fullName\')\" class=\"table-head__cell sorting\"><md-icon md-svg-src=\"/assets/images/arrow.svg\" ng-class=\"{\'active\': vm.columnActiveSorting === \'fullName\', \'arrow-down\': !vm.sorting[vm.columnActiveSorting]}\" class=\"table__arrow-icon\"></md-icon><label>Пользователь</label></div><div flex=\"40\" ng-click=\"vm.changeSorting(\'role.name\')\" class=\"table-head__cell sorting\"><md-icon md-svg-src=\"/assets/images/arrow.svg\" ng-class=\"{\'active\': vm.columnActiveSorting === \'role.name\', \'arrow-down\': !vm.sorting[vm.columnActiveSorting]}\" class=\"table__arrow-icon\"></md-icon><label>Роль</label></div></div><md-divider></md-divider><div class=\"table-body\"><div ng-repeat=\"user in vm.users | orderBy:vm.columnActiveSorting:vm.sorting[vm.columnActiveSorting] track by user._id\" layout=\"row\" layout-align=\"start end\" class=\"task-item\"><div flex=\"60\" class=\"padding-15\"><span>{{::user.fullName}}</span></div><div flex=\"40\" ng-if=\"!$last\" class=\"padding-10 user-role\"><md-select ng-model=\"user.role\" placeholder=\"Выберите роль\" ng-model-options=\"{trackBy: \'$value._id\'}\" ng-change=\"vm.changeUserRole(user)\"><md-option ng-value=\"::role\" ng-repeat=\"role in vm.userRoles\">{{::role.name}}</md-option></md-select></div><div flex=\"40\" ng-if=\"$last\" class=\"padding-10 user-role\"><md-select ng-model=\"user.role\" placeholder=\"Выберите роль\" ng-model-options=\"{trackBy: \'$value._id\'}\" ng-change=\"vm.changeUserRole(user)\"><md-option ng-value=\"::role\" ng-repeat=\"role in vm.userRoles\" on-finish-render=\"vm.closePreloader()\">{{::role.name}}</md-option></md-select></div></div></div></md-whiteframe><div layout=\"row\" layout-align=\"center center\" ng-show=\"vm.preloader\" flex=\"\" class=\"preloader\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></md-content><copyright></copyright></div>");
$templateCache.put("/app/pages/index/estimateAbout.html","<div flex=\"\" class=\"wrap-copyright\"><md-content layout=\"row\" layout-align=\"center start\" ng-show=\"!vm.preloader\" ng-cloak=\"\" class=\"padding-content content-copyright\"><div layout=\"column\" flex=\"\" class=\"about about-view md-whiteframe-3dp\"><div layout=\"row\" layout-align=\"space-between start\"><div layout-align=\"space-between start\"><label class=\"title\">{{::vm.project.customer}}</label></div></div><div layout=\"row\"><label class=\"subtitle\">{{::vm.project.name}}</label></div><div layout=\"column\"><md-input-container ng-show=\"vm.hasRightToEdit()\" class=\"status-container\"><label class=\"section-caption\">Статус</label><md-select ng-model=\"vm.project.status\" md-on-close=\"vm.saveStatus()\" class=\"status-select\"><md-option ng-value=\"status\" ng-repeat=\"status in vm.statuses\">{{ status.name }}</md-option></md-select></md-input-container><div ng-show=\"!vm.hasRightToEdit()\"><div class=\"section-caption\">Статус</div><div class=\"field\">{{vm.project.status.name}}</div></div></div><div layout=\"column\" ng-if=\"::vm.project.description\" class=\"description\"><label class=\"section-caption\">Описание</label><p class=\"section-text\">{{::vm.project.description}}</p></div></div></md-content><copyright ng-show=\"!vm.preloader\"></copyright><div layout=\"row\" layout-align=\"center center\" ng-show=\"vm.preloader\" class=\"preloader\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div>");
$templateCache.put("/app/pages/index/estimateEditView.html","<div flex=\"\" class=\"wrap-copyright\"><md-content layout=\"row\" layout-align=\"center start\" ng-show=\"!vm.preloader\" ng-cloak=\"\" class=\"padding-content content-copyright\"><div layout=\"column\" flex=\"\" class=\"about md-whiteframe-3dp\"><div layout=\"row\" layout-align=\"space-between start\"><md-input-container flex=\"100\" class=\"md-block name-input\"><label style=\"color:rgba(0,0,0,0.54); padding-left:4px;\" class=\"md-block-2 caption\">Клиент</label> <textarea name=\"customer\" required=\"\" ng-minlength=\"3\" ng-maxlength=\"255\" ng-model=\"vm.project.customer\" ng-blur=\"vm.save(\'customer\')\" autofocus-input=\"{{vm.newEstimate}}\"></textarea></md-input-container></div><div layout=\"row\" layout-align=\"space-between start\"><md-input-container md-no-float=\"\" flex=\"100\" class=\"md-block name-input\"><label style=\"color:rgba(0,0,0,0.54); padding-left:4px;\" class=\"md-block-2 caption\">Название проекта</label> <textarea ng-model=\"vm.project.name\" ng-minlength=\"3\" required=\"required\" ng-maxlength=\"255\" aria-label=\"Название проекта\" ng-blur=\"vm.save(\'name\')\" class=\"required\"></textarea></md-input-container></div><div layout=\"column\" ng-if=\"vm.project.files.documents.length &gt; 0 || vm.project.files.images.length &gt; 0\"><label class=\"md-headline\">Файлы</label><div layout=\"column\" ng-if=\"vm.project.files.documents.length &gt; 0\"><label class=\"md-subhead\">Документы</label><ul><li layout=\"row\" ng-repeat=\"doc in vm.project.files.documents\" class=\"list-icon\"><md-icon md-svg-src=\"/assets/images/file-excel.svg\" class=\"material-icons text-header\"></md-icon><a href=\"{{doc.url}}\" class=\"text-header\">{{doc.name}}</a></li></ul></div><div layout=\"column\" ng-if=\"vm.project.files.images.length &gt; 0\"><hlabel class=\"md-subhead\">Изображения</hlabel><div layout=\"row\" layout-wrap=\"\"><md-whiteframe flex=\"15\" ng-repeat=\"image in vm.project.files.images\" class=\"md-whiteframe-1dp image-frame\"></md-whiteframe></div></div></div><div style=\"overflow:hidden;\" ng-if=\"false\"><md-button class=\"md-primary\"><md-icon class=\"material-icons text-header pointer load-btn\">add_circle</md-icon>Загрузить файлы</md-button><span class=\"md-caption\">(.jpg, .png, .tiff, .psd, .doc и т. д.)</span> <input type=\"file\" nv-file-select=\"\" uploader=\"uploader\" class=\"input-file\"></div><div ng-if=\"uploader.queue.length &gt; 0 &amp;&amp; false\"><div layout=\"row\" layout-align=\"start end\"><div flex=\"40\"><label>Название</label></div><div flex=\"10\"><label>Размер</label></div><div flex=\"10\"><label>Ход</label></div><div flex=\"10\"><label>Статус</label></div><div flex=\"30\"><label>Действия</label></div></div><div ng-repeat=\"item in uploader.queue\"><div layout=\"row\" layout-align=\"start end\"><div flex=\"40\"><label>{{ item.file.name }}</label><div ng-switch=\"uploader.isThumb(item._file)\"><div ng-switch-when=\"true\"><div ng-thumb=\"{ file: item._file, height: 100 }\"></div></div><div ng-switch-when=\"false\"><img ng-src=\"/assets/images/textfile.png\" height=\"100\"></div></div></div><div flex=\"10\"><label>{{ item.file.size/1024/1024|number:2 }}</label></div><div flex=\"10\"><md-progress-linear md-mode=\"determinate\" ng-value=\"{{item.progress}}\"></md-progress-linear></div><div flex=\"10\"><span ng-show=\"item.isSuccess\"><md-icon class=\"material-icons\">done</md-icon></span><span ng-show=\"item.isCancel\"><md-icon class=\"material-icons\">clear</md-icon></span><span ng-show=\"item.isError\"><md-icon class=\"material-icons\">error</md-icon></span></div><div flex=\"30\"><button type=\"button\" ng-click=\"item.upload()\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\"><span>Загрузить</span></button> <button type=\"button\" ng-click=\"item.cancel()\" ng-disabled=\"!item.isUploading\"><span>Отменить</span></button> <button type=\"button\" ng-click=\"item.remove()\"><span class=\"glyphicon glyphicon-trash\">Удалить</span></button></div></div></div><div><div>Ход:<md-progress-linear md-mode=\"determinate\" ng-value=\"{{uploader.progress}}\"></md-progress-linear></div><button type=\"button\" ng-click=\"uploader.uploadAll()\" ng-disabled=\"!uploader.getNotUploadedItems().length\"><span>Загрузить все</span></button> <button type=\"button\" ng-click=\"uploader.cancelAll()\" ng-disabled=\"!uploader.isUploading\"><span>Отменить все</span></button> <button type=\"button\" ng-click=\"uploader.clearQueue()\" ng-disabled=\"!uploader.queue.length\"><span>Удалить все</span></button></div></div><div><md-input-container class=\"md-block\"><label style=\"color:rgba(0,0,0,0.54); padding-left:4px;\" class=\"md-block-2\">Описание</label> <textarea name=\"description\" ng-model=\"vm.project.description\" ng-blur=\"vm.save(\'description\')\"></textarea></md-input-container></div></div></md-content><copyright ng-show=\"!vm.preloader\"></copyright><div layout=\"row\" layout-align=\"center center\" ng-show=\"vm.preloader\" class=\"preloader\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div>");
$templateCache.put("/app/pages/index/estimatesView.html","<div flex=\"\" class=\"estimate-projects wrap-copyright\"><md-content layout=\"column\" ng-cloak=\"\" class=\"padding-content content-copyright\"><div layout=\"row\" layout-align=\"center center\" class=\"table-container search\"><md-whiteframe ng-init=\"hasFocus=false\" layout=\"row\" layout-align=\"start center\" class=\"table\"><md-button aria-label=\"search\" flex=\"none\" class=\"md-icon-button search-icon\"><md-icon ng-class=\"{\'search-active\': hasFocus}\" md-svg-src=\"/assets/images/search.svg\"></md-icon></md-button><md-input-container md-no-float=\"\" flex=\"\" class=\"search-input\"><input name=\"filter\" ng-model=\"vm.searchText\" type=\"text\" placeholder=\"Введите текст\" ng-focus=\"hasFocus=true\" ng-blur=\"hasFocus=false\" search-estimate=\"vm.searchCallback.run()\"></md-input-container><span class=\"search-by-and\">Поиск по &laquo;И&raquo;</span><md-switch md-no-ink=\"\" aria-label=\"Поиск строки с пробелами\" ng-model=\"vm.searchStingWithSpaces\" flex=\"none\" ng-change=\"vm.setSpaces()\" class=\"search-switch md-primary\"></md-switch></md-whiteframe></div><div class=\"filter-block\"><div class=\"filter-title\">Выберите фильтр:</div><div ng-repeat=\"filter in vm.filterList\" ng-click=\"vm.setFilter(filter)\" ng-class=\"{\'filter-tab-active\': !!filter.isActive}\" class=\"filter-tab\">{{::filter.name}}</div></div><md-whiteframe layout-align=\"center center\" ng-if=\"vm.isNotFound\" class=\"empty-list\">Подходящих по критерию оценок не найдено</md-whiteframe><md-whiteframe layout=\"column\" ng-if=\"!vm.isNotFound &amp;&amp; vm.displayEstimateList\" ng-show=\"!vm.preloader\" class=\"estimate-table\"><div layout=\"row\" layout-align=\"start center\" class=\"table-head\"><div flex=\"\" layout=\"row\" layout-align=\"start end\"><div flex=\"70\" ng-click=\"vm.changeSorting(\'name\')\" class=\"table-head__cell blue\"><md-icon md-svg-src=\"/assets/images/arrow.svg\" ng-class=\"{\'sort-active\': vm.columnActiveSorting === \'name\', \'arrow-down\': vm.sorting.name.icon === \'expand_less\'}\" class=\"table__arrow-icon\"></md-icon>Название</div><div flex=\"30\" ng-click=\"vm.changeSorting(\'created\')\" class=\"table-head__cell text-center\"><md-icon md-svg-src=\"/assets/images/arrow.svg\" ng-class=\"{\'sort-active\': vm.columnActiveSorting === \'created\', \'arrow-down\': vm.sorting.created.icon === \'expand_less\'}\" class=\"table__arrow-icon\"></md-icon>Дата создания</div></div><div flex=\"none\" layout=\"row\" class=\"hours-perc\"><div flex=\"100\" class=\"table-head__cell table-head__hours-perc\">Количество часов</div></div><div flex=\"none\" layout=\"row\" class=\"status\"><div flex=\"100\" ng-click=\"vm.changeSorting(\'status\')\" class=\"table-head__cell\"><md-icon md-svg-src=\"/assets/images/arrow.svg\" ng-class=\"{\'sort-active\': vm.columnActiveSorting === \'status\', \'arrow-down\': vm.sorting.status.icon === \'expand_less\'}\" class=\"table__arrow-icon\"></md-icon>Статус оценки</div></div><div flex=\"none\" layout=\"row\" layout-align=\"space-between center\" class=\"actions\"><div flex=\"100\" class=\"default\"></div></div></div><md-divider></md-divider><div infinite-scroll=\"vm.nextPage()\" infinite-scroll-disabled=\"vm.busy\" infinite-scroll-distance=\"0.1\" infinite-scroll-container=\"\'#main-content\'\" class=\"table-body\"><div ng-repeat=\"est in vm.arrEstimates | orderBy:vm.predicate:vm.reverse track by est._id\" layout=\"column\"><a layout=\"row\" ui-sref=\"index.estimates.edit(::{estimate:\'{{::est._id }}\'})\" layout-align=\"start center\" on-finish-render=\"vm.finishRender()\" class=\"task-item\"><div flex=\"\" layout=\"row\"><div flex=\"70\" class=\"padding-15\"><strong class=\"task-item-name\">{{::est.customer}}</strong><div class=\"department-item-name\">{{::est.name}}</div></div><div flex=\"30\" class=\"padding-15\"><div class=\"department-item-name text-center\">{{::est.created | date : \'dd-MM-yyyy\'}}</div><div class=\"department-item-name text-center\">{{::est.created | date : \'HH:mm\'}}</div></div></div><div flex=\"none\" layout=\"row\" layout-align=\"start center\" class=\"hours-perc\"><div flex=\"100\" class=\"padding-10 text-center\"><div>{{vm.range[est._id]}}<md-tooltip md-direction=\"top\" md-autohide=\"false\">Range</md-tooltip></div><div>{{vm.pert[est._id]}}<md-tooltip md-direction=\"bottom\" md-autohide=\"false\">Pert</md-tooltip></div></div></div><div flex=\"none\" layout=\"row\" layout-align=\"start center\" class=\"status\"><div flex=\"100\" class=\"padding-15\"><span>{{::est.status.name}}</span></div></div><div flex=\"none\" layout=\"row\" layout-align=\"space-between center\" class=\"actions\"><div flex=\"50\"><md-button aria-label=\"Скопировать оценку\" ng-click=\"vm.copyEstimate($event, est)\" ng-disabled=\"::vm.disableCopying(est)\" id=\"copy-estimate-button\" class=\"md-icon-button icon-button tab-icon\"><md-icon md-svg-src=\"/assets/images/content_copy.svg\" class=\"allow-color\"></md-icon><md-tooltip md-direction=\"top\">Копировать оценку</md-tooltip></md-button></div><div flex=\"50\"><md-button aria-label=\"Удалить оценку\" ng-click=\"vm.deleteEstimate($event, est)\" ng-disabled=\"::vm.disableDeletion(est)\" id=\"disable-deletion-button\" class=\"md-icon-button icon-button tab-icon\"><md-icon class=\"material-icons table__remove-icon\">close</md-icon><md-tooltip md-direction=\"top\">Удалить оценку</md-tooltip></md-button></div></div></a><md-divider></md-divider></div></div><div ng-show=\"vm.busy &amp;&amp; !vm.endPage\" layout=\"row\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div></md-whiteframe><div layout=\"row\" layout-align=\"center center\" ng-show=\"vm.preloader\" flex=\"\" class=\"preloader\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></md-content><copyright></copyright></div><div ng-if=\"::vm.canCreate\" class=\"adding-area\"><md-button aria-label=\"menu\" ng-click=\"vm.newEstimate($event, \'ru\')\" ng-disabled=\"vm.loading\" id=\"open-menu-button\" class=\"general-btn add-estimate-btn\"><md-icon class=\"material-icons md-light\">add</md-icon>Добавить оценку<md-tooltip>Создать оценку</md-tooltip></md-button></div>");
$templateCache.put("/app/pages/index/featureTemplateEditView.html","<div class=\"wrap-copyright feature-template-edit-view\"><div layout=\"column\" class=\"padding-content workhours-page content-copyright\"><div layout=\"row\" layout-align=\"center center\" class=\"search\"><md-whiteframe ng-init=\"hasFocus=false\" layout=\"row\" layout-align=\"center center\" class=\"md-whiteframe-3dp table\"><md-button aria-label=\"search\" class=\"md-icon-button fixed search-icon\"><md-icon ng-class=\"{\'search-active\': hasFocus}\" md-svg-src=\"/assets/images/search.svg\"></md-icon></md-button><md-input-container md-no-float=\"\" class=\"search-input\"><input name=\"filter\" ng-model=\"vm.searchText\" type=\"text\" placeholder=\"Введите текст\" ng-focus=\"hasFocus=true\" ng-blur=\"hasFocus=false\"></md-input-container></md-whiteframe></div><md-whiteframe layout=\"column\" ng-show=\"vm.showTable &amp;&amp; !vm.preloader\" class=\"md-whiteframe-2dp estimate-table\"><radio-button></radio-button><head-table ref=\"\'groups\'\" class=\"flat\"></head-table><md-divider></md-divider><div class=\"table-body\"><div layout=\"column\" class=\"table-list\"><div><div layout=\"column\" layout-align=\"start start\" class=\"task-wrapper workhours-wrapper\"><div ng-repeat=\"(featureIndex, item) in vm.features | filter: {name: vm.searchText}\" layout=\"column\" layout-align=\"center\"><div on-finish-render=\"vm.finishRender()\" class=\"task-wrapper-item task-item\"><groups-table flex=\"grow\" layout=\"row\" layout-align=\"start center\" item=\"item\" save-feature=\"vm.saveFeature\" collapsed=\"collapsed\" toggle=\"collapsed = !collapsed\" delete-feature=\"vm.deleteFeature\" add-new-task=\"vm.addNewTask\" index=\"featureIndex\" phase-list=\"vm.phases\" is-editable=\"vm.canEdit\" is-count-editable=\"false\" show-phases=\"true\" can-be-deleted=\"vm.canDelete\" locale=\"vm.locale\" class=\"wrap-item\"></groups-table><div layout=\"column\" ng-show=\"!collapsed\" class=\"wrap-content\"><div ng-repeat=\"(taskIndex, task) in item.workhours\" class=\"sublist\"><md-divider></md-divider><div class=\"task-item\"><workhours-table flex=\"grow\" layout=\"row\" layout-align=\"start end\" item=\"task.link\" count=\"task.count\" save-count=\"vm.saveCountWorkhour\" delete-workhour=\"vm.deleteTask\" parent=\"item\" workhour-index=\"taskIndex\" role-list=\"vm.roleList\" undo=\"vm.undoTaskToTemplate\" table-row=\"vm.tableRow\" phase-list=\"vm.phases\" is-editable=\"false\" is-part-of-group=\"!vm.canEdit\" locale=\"vm.locale\" class=\"wrap-item\"></workhours-table></div></div></div></div><md-divider></md-divider></div><new-task flex=\"grow\" layout=\"row\" layout-align=\"start center\" item=\"vm.newFeature\" add-filled-item=\"vm.addNewFeature\" show-error=\"vm.showError\" add-callback=\"vm.addCallbackOnNewTaskCreation(callback)\" table-row=\"vm.tableRow\" ng-if=\"vm.canCreate\" phase-list=\"vm.phases\" is-editable=\"false\" index=\"featureIndex\" locale=\"vm.locale\" class=\"wrap-item add\"></new-task></div></div></div></div></md-whiteframe><md-whiteframe layout=\"column\" ng-if=\"vm.message\" class=\"md-whiteframe-2dp estimate-table message\"><div>Для работы со справочником создайте<a ui-sref=\"index.tags\" class=\"colorgreen\">фазы</a></div></md-whiteframe><div layout=\"row\" layout-align=\"center center\" ng-show=\"vm.preloader\" flex=\"\" class=\"preloader\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div><copyright></copyright></div>");
$templateCache.put("/app/pages/index/headerView.html","<div class=\"padding-content estimate-header\"><div id=\"phases-tab-toolbar\" layout=\"row\" layout-align=\"space-between center\" ng-class=\"{\'edit-active\': vm.readyToEdit}\"><md-tabs md-no-pagination=\"\" style=\"width: 114px\" md-selected=\"vm.selectedIndexAbout\"><md-tab md-on-select=\"vm.onPhaseSelected(\'index.estimates.edit\', {estimate: vm.estimateID})\" md-active=\"vm.isAboutTabActive()\"><md-tab-label>О проекте</md-tab-label></md-tab></md-tabs><md-tabs flex=\"\" md-selected=\"vm.selectedIndex\" ng-if=\"vm.project.phases.length\"><md-tab ng-repeat=\"phase in vm.project.phases | orderBy : \'index\'\" md-on-select=\"vm.onPhaseSelected(\'index.estimates.edit.phases\', {phase: phase._id})\" md-active=\"vm.isTabActive(phase._id)\" ng-disabled=\"!vm.isCustomerProvided()\"><md-tab-label><label contenteditable=\"{{vm.readyToEdit}}\" ng-click=\"vm.labelClick($event)\" tab-editable=\"phase.name\" ready-to-edit=\"vm.readyToEdit\" ng-keydown=\"vm.labelKeyDown($event)\" class=\"pointer editable phase-name\"></label><md-icon ng-if=\"!vm.readyToEdit &amp;&amp; phase.isReady\" class=\"material-icons tab-icon-check\">check_circle<md-tooltip md-direction=\"top\">Создание фазы завершено</md-tooltip></md-icon><md-button ng-click=\"vm.deletePhase($event, phase)\" ng-disabled=\"!vm.isCustomerProvided()\" id=\"delete-phase-button\" class=\"tab-icon-cancel\"><md-tooltip md-direction=\"top\">Удалить фазу</md-tooltip><md-icon aria-label=\"Delete Phase\" class=\"material-icons\">cancel</md-icon></md-button></md-tab-label></md-tab></md-tabs><div layout=\"row\" style=\"{{vm.project.phases.length ? \'border-bottom: 1px solid #adbac7\' : \'\'}}\" ng-show=\"vm.project.canEdit\"><md-button id=\"add-phase-button\" ng-if=\"!vm.readyToEdit\" ng-click=\"vm.newPhase($event)\" ng-disabled=\"!vm.isCustomerProvided() || !vm.hasRightToEdit || vm.project.phases.length &gt;= 20\" class=\"md-icon-button md-primary\"><md-tooltip md-direction=\"top\">Добавить фазу</md-tooltip><md-icon aria-label=\"Add Phase\" class=\"material-icons md-18\">add</md-icon></md-button><md-button ng-click=\"vm.saveEditPhase()\" ng-disabled=\"!vm.isCustomerProvided() || !vm.hasRightToEdit\" id=\"save-phase-button\" class=\"md-icon-button done md-primary\"><md-tooltip md-direction=\"top\">Сохранить</md-tooltip><md-icon aria-label=\"Save Phase\" class=\"material-icons md-18\">done</md-icon></md-button><md-button ng-click=\"vm.copyPhase()\" ng-disabled=\"!vm.canCopyPhase()\" ng-hide=\"vm.getCopiedPhase()\" id=\"edit-copy-phase\" class=\"md-icon-button md-primary\"><md-tooltip md-direction=\"top\">Скопировать фазу</md-tooltip><md-icon aria-label=\"Copy Phase\" class=\"material-icons md-18\">content_copy</md-icon></md-button><md-button ng-click=\"vm.pastePhase()\" ng-hide=\"!vm.canPastePhase()\" ng-disabled=\"!vm.hasRightToEdit\" id=\"edit-paste-phase\" class=\"md-icon-button md-primary modeEdit\"><md-tooltip md-direction=\"top\">Вставить фазу</md-tooltip><md-icon aria-label=\"Paste Phase\" class=\"material-icons md-18\">content_paste</md-icon></md-button><md-button ng-click=\"vm.openEditPhase()\" ng-disabled=\"!vm.isCustomerProvided() || !vm.hasRightToEdit\" ng-hide=\"!vm.project.phases || vm.project.phases.length === 0\" id=\"edit-phase-button\" class=\"md-icon-button md-primary\"><md-tooltip md-direction=\"top\">Изменить</md-tooltip><md-icon aria-label=\"Edit Phase\" md-svg-src=\"/assets/images/edit.svg\" class=\"material-icons md-18\"></md-icon></md-button><md-button id=\"reorder-phase-button\" ng-show=\"vm.project.phases.length &gt; 1\" ng-click=\"vm.reorderPhase($event)\" ng-disabled=\"!vm.isCustomerProvided() || !vm.hasRightToEdit\" class=\"md-icon-button md-primary modeEdit\"><md-tooltip md-direction=\"top\">Изменить порядок</md-tooltip><md-icon aria-label=\"Reorder Phase\" class=\"material-icons md-18\">reorder</md-icon></md-button></div></div><div ng-if=\"vm.actions.edit.show &amp;&amp; vm.statistic\" layout=\"row\"><md-card flex=\"\"><md-card-content><ul><li ng-repeat=\"group in vm.statistic.reduced\"><h3>{{group.role.name || \'Нет роли\'}}</h3><span>{{group.minHours | number:1}} - {{group.maxHours | number:1}} ч. ({{group.percentsRange | number:1}}%)</span></li></ul><span flex=\"grow\"></span><md-divider></md-divider><div class=\"card-content-footer\"><span>Диапазон: {{vm.statistic.minHours | number:1}} - {{vm.statistic.maxHours | number:1}} ч.</span><md-button ng-click=\"vm.excelExport($event, vm.project, 0)\" ng-disabled=\"!vm.project.canExport\"><md-icon md-svg-src=\"/assets/images/excel.svg\"></md-icon><span>Скачать</span></md-button></div></md-card-content></md-card><md-card flex=\"\"><md-card-content><ul><li ng-repeat=\"group in vm.statistic.reduced\" layout=\"row\" layout-align=\"space-between\"><h3>{{group.role.name || \'Нет роли\'}}</h3><span>{{group.E68 | number:1}} - {{group.E95 | number:1}} ч. ({{group.percentsPert | number:1}}%)</span></li></ul><span flex=\"grow\"></span><md-divider></md-divider><div class=\"card-content-footer\"><span>PERT: {{vm.statistic.E68 | number:1}} - {{vm.statistic.E95 | number:1}} ч.</span><md-button ng-click=\"vm.excelExport($event, vm.project, 1)\" ng-disabled=\"!vm.project.canExport\"><md-icon md-svg-src=\"/assets/images/excel.svg\"></md-icon><span>Скачать</span></md-button></div></md-card-content></md-card><md-card flex=\"25\"><md-card-header><md-card-header-text><span class=\"md-title\">{{vm.project.authors[0].fullName}}</span></md-card-header-text></md-card-header><md-card-content><p style=\"margin-top: 12px\">Создатель оценки</p><span flex=\"grow\"></span><md-divider></md-divider><div class=\"card-content-footer\"><div flex=\"25\" class=\"risk-title\">Риски:</div><md-input-container md-no-float=\"\" flex=\"30\" class=\"noarrow risk-input-container\"><input name=\"risk\" ng-model=\"vm.project.risk\" type=\"number\" min=\"-100\" max=\"200\" ng-change=\"vm.updateStatisticWithRisk()\" ng-disabled=\"!vm.hasRightToEdit\" aria-label=\"Риски\" ng-blur=\"vm.saveRisks()\"><span>%</span></md-input-container><span flex=\"grow\"></span></div></md-card-content></md-card></div><div layout=\"row\" style=\"margin: 0 0 0 8px\"><span ng-hide=\"vm.hasRightToEdit\" class=\"warning\">Оценка доступна только для просмотра.</span><span flex=\"row\"></span><md-button ng-click=\"vm.editAbout($event)\" ng-show=\"vm.actions.edit.show\" ng-disabled=\"!vm.isCustomerProvided() || !vm.hasRightToEdit\" aria-label=\"Редактировать\" class=\"edit-button\"><span ng-if=\"vm.edit\">Редактировать</span><span ng-if=\"vm.project.phases.length &gt; 0 &amp;&amp; !vm.edit\">Сохранить</span><span ng-if=\"vm.project.phases.length === 0 &amp;&amp; !vm.edit\">Сохранить и добавить фазу</span></md-button></div></div><div ui-view=\"phase\" layout=\"column\" flex=\"\" class=\"content-wrapper\"></div>");
$templateCache.put("/app/pages/index/navBar.html","<md-sidenav md-component-id=\"left\" ng-init=\"vm.initSideNav(\'left\')\" class=\"md-sidenav-left md-whiteframe-4dp\"><md-content width=\"4\"><div class=\"menu-head\"><h2>Estimate<span class=\"text-grey\">Platform</span></h2><div class=\"copyright\">by SimbirSoft</div></div><div ng-repeat=\"item in ::vm.menu\" class=\"menu-item\"><a ui-sref=\"{{::item.href}}\" ui-sref-active=\"active\" ng-click=\"vm.sideNav.close()\" ng-cloak=\"\" ng-if=\"::!item.link &amp;&amp; !item.menu &amp;&amp; !item.accessDenied\">{{::item.title}}</a><a ng-if=\"::item.link\" href=\"{{::item.link}}\" target=\"_blank\">{{::item.title}}</a><ul ng-if=\"::item.menu\"><span class=\"text-grey\"># {{::item.title}}</span><li ng-repeat=\"link in ::item.menu\" class=\"menu-item\"><a ui-sref=\"{{::link.href}}\" ui-sref-active=\"active\" ng-click=\"vm.sideNav.close()\" ng-cloak=\"\" ng-if=\"::!link.menu &amp;&amp; !link.accessDenied\">{{::link.title}}</a></li></ul></div><div class=\"menu-item\"><a ng-cloak=\"\" ui-sref=\"remove_accaunt\" style=\"cursor: pointer; color:#7f00008a;\">Удалить аккаунт</a></div></md-content></md-sidenav><md-toolbar flex=\"none\" class=\"navbar\"><div class=\"md-toolbar-tools padding-content navbar-content\"><md-button ng-click=\"vm.sideNav.toggle()\" id=\"toggle-side-nav-button\" aria-label=\"Переключить меню\" class=\"md-icon-button\"><md-icon md-svg-src=\"/assets/images/menu.svg\" class=\"navbar-icon\"></md-icon></md-button><h2 ng-cloak=\"\" class=\"navbar__title\"><span ng-repeat=\"crumb in vm.breadCrumbs\"><label ng-if=\"!crumb.link || $last\">{{crumb.name | truncate : ($last ? crumb.limitIfLast : crumb.limit) : \'...\'}}</label><a ui-sref=\"{{crumb.link}}\" ui-sref-opts=\"{{crumb.opts}}\" ng-if=\"crumb.link &amp;&amp; !$last\">{{crumb.name | truncate : crumb.limit : \'...\'}}</a><md-icon ng-if=\"!$last\" class=\"navbar-icon\">chevron_left</md-icon></span></h2><span flex=\"\"></span><md-button md-no-ink=\"\" aria-label=\"Logout\" ui-sref=\"logout\" id=\"logout-button\" class=\"exit-button no-padding\">Выход<md-icon md-svg-src=\"/assets/images/exit.svg\" class=\"navbar-icon\"></md-icon></md-button></div></md-toolbar><div ui-view=\"content\" flex=\"\" layout=\"column\"></div>");
$templateCache.put("/app/pages/index/phaseEditView.html","<div id=\"margin-bottom\" flex=\"\" ng-if=\"!vm.preloader\" ng-cloak=\"\" class=\"padding-content phase-wrapper\"><md-whiteframe layout=\"column\" ng-show=\"vm.phase.items.length &gt; 0 || vm.hasRightToEdit()\" class=\"md-whiteframe-2dp estimate-table\"><head-table ref=\"\'tasks\'\" item=\"vm.phase\" is-editable=\"vm.hasRightToEdit()\" collapse-all=\"vm.collapseAll\" expand-all=\"vm.expandAll\"></head-table><div ng-class=\"::{\'bottom-padding\': !vm.hasRightToEdit()}\" infinite-scroll=\"vm.nextPage()\" infinite-scroll-disabled=\"vm.busy\" infinite-scroll-distance=\"1\" infinite-scroll-container=\"\'#main-content\'\" class=\"table-body\"><div layout=\"column\" class=\"table-list\"><div ng-if=\"vm.phase.items.length &gt; 0\" ui-tree=\"phaseTree\"><div layout=\"column\" ui-tree-nodes=\"\" ng-model=\"vm.items\" layout-align=\"start start\" class=\"task-wrapper\"><div ng-repeat=\"(itemIndex, item) in vm.items track by item._id\" ui-tree-node=\"\" navigatable=\"\" data-type=\"{{::item.type.toLowerCase()}}\" ng-class=\"{\'task-custom\': item.custom &amp;&amp; item.type.toLowerCase() === \'task\', \'feature\': item.type.toLowerCase() === \'feature\'}\" on-finish-render=\"vm.finishRenderPartPhase()\" class=\"task-wrapper-item task-item\"><div ng-if=\"::item.type.toLowerCase() === \'feature\'\" ng-class=\"::{\'left-padding\': !vm.hasRightToEdit()}\" class=\"drag-wrapper\"><div ui-tree-handle=\"\" ng-if=\"::vm.hasRightToEdit()\" class=\"dragger\"><md-icon md-svg-src=\"/assets/images/drag_indicator.svg\"></md-icon></div><features-table phase-item=\"::vm.phase._id\" layout=\"column\" item=\"item\" collapsed=\"collapsed\" toggle=\"toggle(this)\" delete-feature=\"vm.deleteFeature\" copy=\"vm.copyFeature\" role-list=\"::vm.roleList\" tasks-dictionaty=\"::vm.tasksDictionaty\" is-editable=\"::vm.hasRightToEdit()\" feature-statistic=\"vm.phaseWithStatistics.items[itemIndex]\" get-template-task=\"vm.getTemplateTask\" class=\"wrap-item\"></features-table></div><md-divider ng-if=\"::item.type.toLowerCase() === \'feature\'\" style=\"border-top-color: #eef3f6\"></md-divider><div layout=\"column\" ui-tree-nodes=\"\" ng-model=\"item.tasks\" ng-show=\"!collapsed\" class=\"task-wrapper wrap-content\"><div ng-repeat=\"task in item.tasks track by task._id\" ui-tree-node=\"\" data-type=\"{{::task.type.toLowerCase()}}\" class=\"sublist fix-height\"><div ng-class=\"{\'task-custom\': task.custom, \'left-padding\': !vm.hasRightToEdit()}\" class=\"task-item drag-wrapper\"><div ui-tree-handle=\"\" ng-if=\"::vm.hasRightToEdit()\" class=\"dragger\"><md-icon md-svg-src=\"/assets/images/drag_indicator.svg\"></md-icon></div><tasks-table layout=\"row\" layout-align=\"start end\" item=\"task\" delete-task=\"vm.deleteTask\" parent=\"item\" role-list=\"::vm.roleList\" undo=\"vm.undoTaskToTemplate\" copy=\"vm.copyTaskInFeature\" is-editable=\"::vm.hasRightToEdit()\" workhour=\"::vm.workhours[task._id]\" class=\"wrap-item position-center\"></tasks-table></div><md-divider style=\"border-top-color: #eef3f6\"></md-divider></div></div><div ng-if=\"::item.type.toLowerCase() === \'task\'\" ng-class=\"::{\'left-padding\': !vm.hasRightToEdit()}\" class=\"task drag-wrapper\"><div ui-tree-handle=\"\" ng-if=\"::vm.hasRightToEdit()\" class=\"dragger\"><md-icon md-svg-src=\"/assets/images/drag_indicator.svg\"></md-icon></div><tasks-table flex=\"grow\" layout=\"row\" layout-align=\"start end\" item=\"item\" delete-task=\"vm.deleteTask\" parent=\"::vm.phase\" role-list=\"::vm.roleList\" undo=\"vm.undoTaskToTemplate\" copy=\"vm.copyTask\" is-editable=\"::vm.hasRightToEdit()\" workhour=\"::vm.workhours[item._id]\" class=\"wrap-item\"></tasks-table></div><md-divider ng-if=\"::item.type.toLowerCase() === \'task\'\" style=\"border-top-color: #eef3f6\"></md-divider></div></div></div></div></div><div id=\"typeahead-form\" ng-if=\"::vm.hasRightToEdit()\"><typeahead-task-phase new-custom-item=\"vm.newCustomItem\" new-existing-item=\"vm.newExistingItem\" groups-dictionary=\"vm.groupsDictionary\" tasks-dictionaty=\"vm.tasksDictionaty\" is-feature=\"vm.isFeature\" on-add-feature=\"vm.addNewFeature\" on-add-task=\"vm.addNewTask\"></typeahead-task-phase><div flex=\"\" layout=\"row\" layout-align=\"start\" class=\"dictionary-button-wrap\"><md-button ng-click=\"vm[vm.isFeature ? \'addNewFeature\' : \'addNewTask\']($event)\" class=\"md-primary dictionary-button\">или выберите из справочника</md-button></div></div></md-whiteframe><md-whiteframe layout=\"column\" ng-if=\"vm.phase.items.length === 0 &amp;&amp; !vm.hasRightToEdit()\" class=\"md-whiteframe-2dp estimate-table message\"><div>Фаза не содержит часов оценки</div></md-whiteframe><div id=\"phaseFooter\" calc-width-footer=\"\" class=\"phase-total\"><div class=\"padding-content\"><div ng-if=\"vm.hasRightToEdit()\" class=\"phase-status-button\"><md-button ng-click=\"vm.changePhaseStatus()\"><span ng-if=\"vm.phase.isReady\">Убрать отметку о готовности</span><span ng-if=\"!vm.phase.isReady\">Отметить как готовую</span><md-tooltip>Сменить статус фазы</md-tooltip></md-button></div><div layout=\"row\"><div flex=\"100\"><div layout=\"row\" layout-align=\"space-between center\" class=\"phase-total-head\"><div flex=\"60\"><div class=\"phase-total-text\">Роли,ч.</div></div><div flex=\"33\" layout=\"row\" layout-align=\"center none\"><div flex=\"25\"><div class=\"phase-total-text\">Часы фазы</div></div><div flex=\"25\"><div class=\"phase-total-text\">QA,ч.</div></div><div flex=\"25\"><div class=\"phase-total-text\">PM/AM,ч.</div></div><div flex=\"25\"><div class=\"phase-total-text\">BUGS,ч.</div></div></div></div><div layout=\"row\" layout-align=\"space-between center\" class=\"phase-total-body\"><div flex=\"60\" layout=\"row\" layout-wrap=\"\"><label flex=\"50\" ng-repeat=\"group in vm.phaseWithStatistics.reduced\">{{group.role.name || \'Нет роли\'}}: {{group.minHours| number:1}} – {{group.maxHours| number:1}} ({{group.percentsRange | number:1}}%)</label></div><div flex=\"33\" layout=\"row\" layout-align=\"center none\" class=\"phase-total-stat\"><div flex=\"25\" layout=\"row\" class=\"phase-total-time text-center\">{{vm.phaseWithStatistics.minHours | number : 1}}—{{vm.phaseWithStatistics.maxHours | number : 1}}</div><div flex=\"25\">{{vm.phaseWithStatistics.qaMin| number:1}} — {{vm.phaseWithStatistics.qaMax| number:1}}</div><div flex=\"25\">{{vm.phaseWithStatistics.pmMin| number:1}} — {{vm.phaseWithStatistics.pmMax| number:1}}</div><div flex=\"25\">{{vm.phaseWithStatistics.bugsMin| number:1}} — {{vm.phaseWithStatistics.bugsMax| number:1}}</div></div></div></div></div><div ng-show=\"vm.busy &amp;&amp; !vm.endPage\" class=\"load-part-phase\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"25\"></md-progress-circular></div></div><md-divider></md-divider><copyright></copyright></div></div><div layout=\"row\" layout-align=\"center center\" ng-show=\"vm.preloader\" class=\"preloader\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("/app/pages/index/phaseTemplateEditView.html","<div id=\"margin-bottom\" class=\"phase-template-edit-view padding-content workhours-page\"><div layout=\"row\" layout-align=\"center center\" ng-if=\"!vm.message\" class=\"search\"><md-whiteframe ng-init=\"hasFocus=false\" class=\"md-whiteframe-3dp table\"><md-button aria-label=\"search\" class=\"md-icon-button fixed search-icon\"><md-icon ng-class=\"{\'search-active\': hasFocus}\" md-svg-src=\"/assets/images/search.svg\"></md-icon></md-button><md-input-container md-no-float=\"\" class=\"search-input\"><input name=\"filter\" ng-model=\"vm.searchText\" type=\"text\" placeholder=\"Введите текст\" ng-focus=\"hasFocus=true\" ng-blur=\"hasFocus=false\"></md-input-container></md-whiteframe></div><md-whiteframe layout=\"column\" ng-show=\"!vm.message &amp;&amp; vm.showTable &amp;&amp; !vm.preloader\" class=\"md-whiteframe-2dp estimate-table\"><head-table ref=\"\'phases\'\" class=\"flat\"></head-table><md-divider></md-divider><div class=\"table-body\"><div layout=\"column\" class=\"table-list\"><div ng-if=\"vm.phase.items.length &gt; 0\" ui-tree=\"phaseTree\"><div layout=\"column\" ui-tree-nodes=\"\" ng-model=\"vm.phase.items\" layout-align=\"start start\" class=\"task-wrapper workhours-wrapper phase\"><div ng-repeat=\"(featureIndex, item) in vm.phase.items | filter:{link:{name: vm.searchText}}\" ui-tree-node=\"\" data-type=\"{{item.type.toLowerCase()}}\" ng-class=\"{\'last-item\': $last}\" on-finish-render=\"vm.finishRender()\" class=\"task-wrapper-item task-item\"><div ng-if=\"item.type.toLowerCase() === \'feature\'\" class=\"drag-wrapper\"><div ui-tree-handle=\"\" ng-if=\"vm.canEdit\" class=\"dragger\"><md-icon md-svg-src=\"/assets/images/drag_indicator.svg\"></md-icon></div><groups-table flex=\"grow\" layout=\"row\" layout-align=\"start end\" item=\"item.link\" count=\"item.count\" save-count=\"vm.saveChange\" collapsed=\"collapsed\" toggle=\"toggle(this)\" delete-feature=\"vm.deleteFeature\" add-new-task=\"vm.addNewTask\" index=\"featureIndex\" phase-list=\"vm.phases\" is-editable=\"false\" is-count-editable=\"false\" can-be-deleted=\"vm.canEdit\" locale=\"vm.locale\" class=\"wrap-item\"></groups-table></div><div layout=\"column\" ng-model=\"item.link.workhours\" ng-show=\"!collapsed\" class=\"task-wrapper wrap-content\"><div ng-repeat=\"(taskIndex, task) in item.link.workhours\" class=\"sublist\"><div ng-class=\"{\'task-custom\': task.custom}\" class=\"task-item drag-wrapper\"><workhours-table flex=\"grow\" layout=\"row\" layout-align=\"start end\" item=\"task.link\" count=\"task.count\" delete-workhour=\"vm.deleteTask\" parent=\"item\" workhour-index=\"taskIndex\" role-list=\"vm.roleList\" table-row=\"vm.tableRow\" is-editable=\"false\" is-part-of-group=\"true\" locale=\"vm.locale\" class=\"wrap-item\"></workhours-table></div></div></div><div ng-if=\"item.type.toLowerCase() !== \'feature\'\" class=\"drag-wrapper\"><div ui-tree-handle=\"\" ng-if=\"vm.canEdit\" class=\"dragger\"><md-icon md-svg-src=\"/assets/images/drag_indicator.svg\"></md-icon></div><workhours-table flex=\"grow\" layout=\"row\" layout-align=\"start end\" item=\"item.link\" count=\"item.count\" save-count=\"vm.saveChange\" delete-workhour=\"vm.deleteTask\" parent=\"vm.phase\" workhour-index=\"featureIndex\" role-list=\"vm.roleList\" table-row=\"vm.tableRow\" is-editable=\"false\" is-part-of-group=\"!vm.canEdit\" locale=\"vm.locale\" class=\"wrap-item\"></workhours-table></div></div></div></div></div></div></md-whiteframe><md-whiteframe layout=\"column\" ng-if=\"vm.message\" class=\"md-whiteframe-2dp estimate-table message\"><div>Для работы с шаблоном фазы создайте ассоциированные&nbsp;<a ui-sref=\"index.workhours.phase({phaseId: vm.phase._id})\" class=\"colorgreen\">нормочасы</a> и&nbsp;<a ui-sref=\"index.groups.phase({phaseId: vm.phase._id})\" class=\"colorgreen\">фичи</a></div></md-whiteframe></div><div layout=\"row\" layout-align=\"center center\" ng-show=\"vm.preloader\" flex=\"\" class=\"preloader\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div id=\"phaseFooter\" calc-width-footer=\"\" class=\"phase-total\"><div class=\"padding-content\"><div layout=\"row\" class=\"phase-total-head\"><div flex=\"15\"><div class=\"phase-total-title\">{{vm.phase.name}}</div></div><div flex=\"50\"><div class=\"phase-total-text\">Роли,ч.</div></div><div flex=\"15\" class=\"text-center\"><div class=\"phase-total-text\">Часы фазы</div></div><div flex=\"15\" layout=\"row\"><div flex=\"45\" class=\"text-right\"><div class=\"phase-total-text\">QA,ч.</div></div><div flex=\"10\"></div><div flex=\"45\"><div class=\"phase-total-text\">PM/AM,ч.</div></div></div></div><div layout=\"row\" class=\"phase-total-body\"><div flex-offset=\"15\" flex=\"50\" layout=\"row\" layout-wrap=\"\"><label flex=\"50\" ng-repeat=\"group in vm.phase.reduced\">{{group.role.name || \'Нет роли\'}}: {{group.minHours| number:1}} – {{group.maxHours| number:1}} ({{group.percentsRange | number:1}}%)</label></div><div flex=\"15\" layout=\"row\" class=\"phase-total-time text-center\"><div flex=\"45\">{{vm.phase.minHours| number:1}}</div><div flex=\"10\">—</div><div flex=\"45\">{{vm.phase.maxHours| number:1}}</div></div><div flex=\"15\" layout=\"row\" class=\"phase-total-stat\"><div flex=\"45\" class=\"text-right\">{{vm.phase.qaMin| number:1}} - {{vm.phase.qaMax| number:1}}</div><div flex=\"10\" class=\"text-center\">—</div><div flex=\"45\" class=\"text-left\">{{vm.phase.pmMin| number:1}} - {{vm.phase.pmMax| number:1}}</div></div></div><div ng-if=\"vm.canEdit\" class=\"adding-area phase-total-btn\"><md-fab-speed-dial md-open=\"vm.isOpen\"><md-fab-trigger><md-button aria-label=\"menu\" class=\"md-fab md-accent fixed-color\"><md-icon class=\"material-icons md-light\">add<md-tooltip>Добавить</md-tooltip></md-icon></md-button></md-fab-trigger><div ng-if=\"vm.isOpen\" class=\"md-whiteframe-6dp adding-area-block adding-workhours\"><div ng-click=\"vm.addNewFeature(event)\" class=\"adding-area-item\">Добавить фичи</div><div ng-click=\"vm.addNewTask(event)\" class=\"adding-area-item\">Добавить нормочасы</div></div></md-fab-speed-dial></div></div><md-divider></md-divider><copyright></copyright></div>");
$templateCache.put("/app/pages/index/phaseTemplatesView.html","<div ng-cloak=\"\" ng-if=\"!vm.phaseOpened\" class=\"phase-templates-view padding-content workhours-page wrap-copyright\"><div class=\"content-copyright\"><div layout=\"row\" layout-align=\"center center\" class=\"search\"><md-whiteframe ng-init=\"hasFocus=false\" layout=\"row\" layout-align=\"center center\" class=\"md-whiteframe-3dp table\"><md-button aria-label=\"search\" class=\"md-icon-button fixed search-icon\"><md-icon ng-class=\"{\'search-active\': hasFocus}\" md-svg-src=\"/assets/images/search.svg\"></md-icon></md-button><md-input-container md-no-float=\"\" class=\"search-input\"><input name=\"filter\" ng-model=\"vm.searchText\" type=\"text\" placeholder=\"Введите текст\" ng-focus=\"hasFocus=true\" ng-blur=\"hasFocus=false\"></md-input-container></md-whiteframe></div><md-whiteframe layout=\"column\" ng-if=\"vm.displayPhaseList || vm.canCreate\" class=\"md-whiteframe-3dp estimate-table phase-table\"><head-table ref=\"\'tags\'\" change-sorting=\"vm.changeSorting\" comparator=\"vm.comparator\" reverse=\"vm.reverse\" class=\"flatHeight\"></head-table><md-divider ng-show=\"!$last\"></md-divider><div ng-repeat=\"phase in vm.phases | filter: {name: vm.searchText} | orderBy:vm.comparator:vm.reverse\" layout=\"column\"><div layout=\"row\" ng-if=\"vm.displayPhaseList\" class=\"table-row\"><div layout=\"row\" layout-align=\"start center\" flex=\"grow\" class=\"name-column\"><div ng-click=\"vm.selectPhaseIndex(phase._id)\" ng-if=\"!phase.editMode\" class=\"link\">{{ vm.getLocalePhaseName(phase) }}</div><md-input-container ng-if=\"phase.editMode\" ng-show=\"vm.locale==\'ru\'\" class=\"textarea-container\"><input rows=\"1\" ng-model=\"phase.name\" ng-blur=\"vm.savePhaseName(phase)\" ng-keypress=\"vm.savePhaseNameOnEnter($event, phase)\" ng-show=\"vm.locale == \'ru\'\" class=\"wrap-title label\"></md-input-container><md-input-container ng-if=\"phase.editMode\" ng-show=\"vm.locale==\'en\'\" class=\"textarea-container\"><input rows=\"1\" ng-model=\"phase.nameEn\" ng-blur=\"vm.savePhaseName(phase)\" ng-keypress=\"vm.savePhaseNameOnEnter($event, phase)\" class=\"wrap-title label\"><md-tooltip md-direction=\"top\">{{phase.name}}</md-tooltip></md-input-container></div><div layout=\"row\" layout-align=\"center center\" flex=\"none\" class=\"workhours-column\"><div><label class=\"bold\">{{vm.countWorkhours[phase._id]}}<md-tooltip md-direction=\"top\">Ассоциированные</md-tooltip></label></div></div><div layout=\"row\" layout-align=\"center center\" flex=\"none\" class=\"features-column\"><div><label class=\"bold\">{{vm.countFeatures[phase._id]}}<md-tooltip md-direction=\"top\">Ассоциированные</md-tooltip></label></div></div><div layout=\"row\" layout-align=\"start center\" flex=\"20\" class=\"roles-column\"><div><span class=\"bold\">{{vm.roles[phase._id]}}</span></div></div><div layout=\"column\" layout-align=\"end center\" flex=\"none\" class=\"hours-column\"><div><span class=\"bold\">{{phase.minHours | number:1}} - {{phase.maxHours | number:1}}<md-tooltip md-direction=\"bottom\">Pert</md-tooltip></span></div><div><span class=\"bold\">{{phase.E68 | number:1}} - {{phase.E95 | number:1}}</span><md-tooltip md-direction=\"bottom\">Диапазон</md-tooltip></div></div><div layout=\"row\" layout-align=\"end center\" flex=\"none\" class=\"icons-column\"><md-button aria-label=\"Редактировать имя\" ng-if=\"!phase.editMode &amp;&amp; vm.canEdit\" ng-click=\"vm.savePhaseName(phase)\" id=\"edit-name-button\" class=\"md-icon-button icon-button tab-icon\"><md-icon class=\"material-icons\">edit</md-icon><md-tooltip md-direction=\"bottom\">Редактировать имя</md-tooltip></md-button><md-button aria-label=\"Завершить редактирование\" ng-if=\"phase.editMode\" ng-click=\"vm.savePhaseName(phase)\" id=\"save-name-button\" class=\"md-icon-button icon-button tab-icon\"><md-icon class=\"material-icons\">done</md-icon><md-tooltip md-direction=\"bottom\">Завершить редактирование</md-tooltip></md-button><md-button ng-click=\"vm.deletePhase($event, phase)\" tabindex=\"-1\" ng-disabled=\"!vm.canDelete\" id=\"delete-phase-button\" class=\"md-icon-button icon-button tab-icon\"><md-icon>close</md-icon><md-tooltip md-direction=\"top\">Удалить фазу</md-tooltip></md-button></div></div><md-divider></md-divider></div><div layout=\"row\" ng-if=\"vm.canCreate\" class=\"table-row\"><div layout=\"row\" layout-align=\"start end\" flex=\"grow\" class=\"name-column\"><md-input-container md-no-float=\"\"><input rows=\"1\" ng-model=\"vm.newPhaseName\" placeholder=\"Введите название\" ng-keypress=\"vm.addNewPhaseOnEnter($event)\" ng-disabled=\"vm.locale != \'ru\'\" id=\"enter-phase-name-textarea\" class=\"bold wrap-title\"></md-input-container></div><div layout=\"row\" layout-align=\"end center\" flex=\"none\" class=\"icons-column\"><md-icon aria-label=\"Добавить фазу\" ng-click=\"vm.addNewPhase($event)\" ng-class=\"{\'disabled\': !vm.newPhaseName}\" class=\"tab-icon material-icons pointer\">done</md-icon></div></div></md-whiteframe></div><copyright></copyright></div><md-content ng-if=\"vm.phaseOpened\" class=\"tabs\"><md-tabs md-selected=\"vm.selectedIndex\" class=\"md-primary padding-content\"><md-tab ng-repeat=\"phase in vm.phases track by phase._id\" md-on-select=\"vm.onPhaseSelected(phase)\"><md-tab-label><label class=\"pointer\">{{phase.name}}</label></md-tab-label></md-tab></md-tabs></md-content><div ui-view=\"phase\" flex=\"\" layout=\"column\" class=\"content-wrapper\"></div>");
$templateCache.put("/app/pages/index/roleTemplateEditView.html","<div class=\"role-template-edit wrap-copyright\"><div layout=\"column\" class=\"padding-content workhours-page content-copyright\"><div layout=\"row\" layout-align=\"center center\" class=\"search\"><md-whiteframe ng-init=\"hasFocus=false\" layout=\"row\" layout-align=\"start center\" class=\"md-whiteframe-3dp table\"><md-button aria-label=\"search\" class=\"md-icon-button fixed search-icon\"><md-icon ng-class=\"{\'search-active\': hasFocus}\" md-svg-src=\"/assets/images/search.svg\"></md-icon></md-button><md-input-container md-no-float=\"\" flex=\"grow\" class=\"search-input\"><input name=\"filter\" ng-model=\"vm.searchText\" type=\"text\" placeholder=\"Введите текст\" ng-focus=\"hasFocus=true\" ng-blur=\"hasFocus=false\"></md-input-container></md-whiteframe></div><md-whiteframe layout=\"column\" ng-show=\"!vm.preloader\" class=\"md-whiteframe-3dp estimate-table\"><div layout=\"row\" layout-align=\"space-between end\" ng-class=\"{\'edit-active\': vm.readyToEdit}\" class=\"table-head roles flat\"><div flex=\"\" ng-click=\"vm.changeSorting(\'name\')\" class=\"name\"><label>Роль</label><md-icon md-svg-src=\"/assets/images/arrow.svg\" ng-class=\"{\'sort-active\': vm.columnActiveSorting === \'name\', \'arrow-down\': !vm.reverse}\" class=\"table__arrow-icon\"></md-icon></div><div flex=\"none\" layout=\"row\" layout-align=\"center end\" ng-repeat=\"(index, currency) in vm.currencies\" class=\"costs edit\"><label>{{ vm.locale == \'ru\' ? currency.name : currency.nameEn }}</label><md-input-container md-no-float=\"\" ng-click=\"$event.stopPropagation()\" ng-show=\"vm.locale == \'ru\'\" class=\"md-block\"><input ng-model=\"currency.name\" type=\"text\" placeholder=\"Название\" ng-disabled=\"!vm.access.currency.update\"></md-input-container><md-icon ng-if=\"vm.access.currency.delete\" ng-click=\"vm.deleteCurrency($event, index)\" aria-label=\"О проекте\" class=\"tab-icon material-icons tab-icon-cancel pointer\">cancel<md-tooltip md-direction=\"top\">Удалить валюту</md-tooltip></md-icon></div><div flex=\"10\" layout=\"row\" layout-align=\"space-around center\"><md-icon ng-click=\"vm.addNewCurrency($event)\" ng-if=\"!vm.readyToEdit &amp;&amp; vm.access.currency.create\">add_circle<md-tooltip md-direction=\"top\">Добавить валюту</md-tooltip></md-icon><div ng-if=\"vm.access.currency.delete || vm.access.currency.update\"><md-icon aria-label=\"Edit\" ng-click=\"vm.openEditCurrencies()\" class=\"modeEdit\">mode_edit<md-tooltip md-direction=\"top\">Редактировать валюты</md-tooltip></md-icon><md-icon aria-label=\"Edit\" ng-click=\"vm.saveCurrencies()\" class=\"done\">done<md-tooltip md-direction=\"top\">Сохранить валюты</md-tooltip></md-icon></div></div></div><md-divider></md-divider><div class=\"table-body\"><div layout=\"column\" class=\"table-list\"><div><div layout=\"column\" layout-align=\"start start\" class=\"task-wrapper roles-wrapper\"><div ng-repeat=\"(roleIndex, item) in vm.roles | filter: {name: vm.searchText} | orderBy:vm.predicate:vm.reverse track by $index\"><div layout=\"column\" class=\"task-wrapper-item task-item\"><body-table ref=\"true\" item=\"item\" index=\"roleIndex\" currencies=\"vm.currencies\" delete=\"vm.deleteRole\" can-be-deleted=\"vm.access.role.delete\" editable=\"vm.access.role.update\" save-role=\"vm.saveRole\" locale=\"vm.locale\"></body-table></div><md-divider></md-divider></div><div class=\"task-wrapper-item task-item last-item\"><body-table ref=\"false\" item=\"vm.newrole\" currencies=\"vm.currencies\" add=\"vm.addNewRole\" ng-if=\"vm.access.role.create\" editable=\"vm.access.role.create &amp;&amp; vm.locale == \'ru\'\" locale=\"vm.locale\"></body-table></div></div></div></div></div></md-whiteframe><div layout=\"row\" layout-align=\"center center\" ng-show=\"vm.preloader\" flex=\"\" class=\"preloader\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div><copyright></copyright></div>");
$templateCache.put("/app/pages/index/taskTemplateEditView.html","<div class=\"wrap-copyright task-template-edit-view\"><div layout=\"column\" class=\"padding-content workhours-page content-copyright\"><div layout=\"row\" layout-align=\"center center\" class=\"search\"><md-whiteframe layout=\"row\" layout-align=\"start center\" ng-init=\"hasFocus=false\" class=\"md-whiteframe-3dp table\"><md-button aria-label=\"search\" class=\"md-icon-button fixed search-icon\"><md-icon ng-class=\"{\'search-active\': hasFocus}\" md-svg-src=\"/assets/images/search.svg\"></md-icon></md-button><md-input-container md-no-float=\"\" class=\"search-input\"><input name=\"filter\" ng-model=\"vm.searchText\" type=\"text\" placeholder=\"Введите текст\" ng-focus=\"hasFocus=true\" ng-blur=\"hasFocus=false\"></md-input-container></md-whiteframe></div><md-whiteframe layout=\"column\" ng-show=\"vm.showTable &amp;&amp; !vm.preloader\" class=\"md-whiteframe-2dp estimate-table\"><radio-button style=\"padding-top: 0\"></radio-button><head-table ref=\"\'workhours\'\" choose-all=\"vm.chooseAll\" is-editable=\"vm.canEdit\"></head-table><md-divider></md-divider><div class=\"table-body\"><div layout=\"column\" class=\"table-list\"><div><div layout=\"column\" layout-align=\"start start\" class=\"task-wrapper workhours-wrapper\"><div ng-repeat=\"(index, item) in vm.task.items | filter: {name: vm.searchText}\" layout=\"column\"><div on-finish-render=\"vm.finishRender()\" class=\"task-wrapper-item task-item\"><workhours-table flex=\"grow\" layout=\"row\" layout-align=\"end end\" item=\"item\" workhour-index=\"index\" role-list=\"vm.roleList\" save-workhour=\"vm.saveWorkhour\" delete-workhour=\"vm.deleteWorkhour\" phase-list=\"vm.phases\" table-row=\"vm.tableRow\" is-editable=\"vm.canEdit\" len=\"vm.task.items.length\" change-role-new-task=\"vm.changeRoleNewTask\" is-part-of-group=\"!vm.canDelete\" locale=\"vm.locale\" class=\"wrap-item work\"></workhours-table></div><md-divider></md-divider></div><new-task flex=\"grow\" layout=\"row\" layout-align=\"start end\" item=\"vm.newTask\" add-filled-item=\"vm.addNewTask\" role-list=\"vm.roleList\" add-callback=\"vm.addCallbackOnNewTaskCreation(callback)\" table-row=\"vm.tableRow\" ng-if=\"vm.canCreate\" phase-list=\"vm.phases\" is-editable=\"true\" index=\"index\" locale=\"vm.locale\" class=\"wrap-item task-wrapper-item\"></new-task></div></div></div></div></md-whiteframe><div layout=\"row\" layout-align=\"center center\" ng-show=\"vm.preloader\" flex=\"\" class=\"preloader\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div><copyright></copyright></div>");
$templateCache.put("/app/pages/index/templateHeader.html","<md-content class=\"tabs\"><md-tabs md-selected=\"vm.selected\" class=\"md-primary padding-content\"><md-tab ng-repeat=\"phase in vm.phases\" md-on-select=\"vm.onPhaseSelected(phase._id)\"><md-tab-label><label class=\"pointer\">{{phase.name}}</label></md-tab-label></md-tab></md-tabs></md-content><div ui-view=\"template\" flex=\"\" layout=\"column\" ng-if=\"!vm.message\"></div><div ng-if=\"vm.message\" class=\"padding-content workhours-page\"><md-whiteframe layout=\"column\" ng-if=\"vm.message\" class=\"md-whiteframe-2dp estimate-table message\"><div>Для работы со справочником создайте&nbsp;<a ui-sref=\"index.tags\" class=\"colorgreen\">фазы</a></div></md-whiteframe></div>");
$templateCache.put("/app/pages/login/login.html","<div layout=\"vertical\" layout-fill=\"\" ng-if=\"vm.showLoginButton\" class=\"login-form\"><div flex=\"\" layout=\"column\" role=\"main\"><md-content flex=\"\" layout=\"vertical\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"center center\" layout-fill=\"\" class=\"login-block\"><md-whiteframe layout=\"column\" flex-lg=\"30\" flex=\"21\" flex-md=\"50\" flex-sm=\"80\" class=\"md-whiteframe-z1 table\"><md-toolbar flex=\"\" class=\"login-header\"><div class=\"md-toolbar-tools\"><h2 class=\"login-title\">Estimate Platform</h2></div></md-toolbar><md-content layout-padding=\"\" class=\"white-block login-body\"><form><md-input-container layout-align=\"center center\" class=\"login-btn-block\"><div layout=\"row\" layout-sm=\"column\" layout-margin=\"\" class=\"login-btn-wrap\"><md-button flex=\"50\" flex-sm=\"100\" ng-click=\"vm.logFaceBook($event)\" ng-disabled=\"vm.processing\" class=\"md-raised general-btn login-btn\">Login with FaceBook</md-button></div></md-input-container></form></md-content></md-whiteframe></div></md-content></div></div>");
$templateCache.put("/app/pages/login/loginAgreementModal.html","<md-dialog flex=\"60\" class=\"login-agreement-modal\"><div ng-if=\"!vm.isMobile()\" class=\"md-toolbar-tools\"><h2>Ознакомьтесь с условиями регистрации</h2><span flex=\"\"></span><md-button ng-click=\"vm.cancel()\" class=\"md-icon-button\"><md-icon aria-label=\"Close dialog\" class=\"close-icon\">clear</md-icon></md-button></div><md-dialog-content ng-if=\"!vm.isMobile()\"><md-checkbox ng-model=\"vm.personal\" aria-label=\"personal\"><span>Я согласен с условиями &nbsp;</span><a href=\"https://www.simbirsoft.com/agreement/\" target=\"_blank\">Политики ООО “СимбирCофт” в отношении обработки персональных данных</a></md-checkbox><md-checkbox ng-model=\"vm.public\" aria-label=\"public\"><span>Я согласен с условиями &nbsp;</span><a href=\"./assets/user_agreement.pdf\" target=\"_blank\">Пользовательского соглашения</a></md-checkbox><div class=\"note\">Для доступа к приложению требуется дать разрешение на передачу email</div></md-dialog-content><div layout=\"row\" layout-align=\"flex-center-center\" ng-if=\"!vm.isMobile()\" class=\"md-actions\"><md-button ng-click=\"vm.cancel()\" class=\"cancel-btn\">Отмена</md-button><md-button ng-click=\"vm.ok()\" ng-disabled=\"!(vm.personal &amp;&amp; vm.public)\" class=\"general-btn\">Войти</md-button></div><div ng-if=\"vm.isMobile()\" class=\"md-dialog-content\"><div class=\"warning-decorator\">Для работы в приложении Estimate Platform используйте персональный компьютер.</div></div><div layout=\"row\" layout-align=\"flex-center-center\" ng-if=\"vm.isMobile()\" class=\"md-actions\"><md-button ng-click=\"vm.cancel()\" class=\"general-btn\">Ok</md-button></div></md-dialog>");
$templateCache.put("/app/components/directives/actionBar/actionBar.html","<md-toolbar layout=\"column\" class=\"md-menu-toolbar md-primary grey-toolbar action-bar\"><div layout=\"row\" layout-align=\"end center\" class=\"padding-content\"><md-menu ng-show=\"vm.actions.addMenu\" class=\"add-menu\"><md-button ng-click=\"$mdOpenMenu($event)\" id=\"open-menu-button\" class=\"tab-icon btn-add\"><md-tooltip>Добавить</md-tooltip><md-icon class=\"material-icons\">add</md-icon>Добавить</md-button><md-menu-content class=\"add-menu-content\"><md-menu-item><md-button ng-click=\"vm.addNewFeature($event)\" id=\"add-feature-button\">Фичу</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.addNewTask($event)\" id=\"add-task-button\">Задачу</md-button></md-menu-item></md-menu-content></md-menu><md-menu ng-show=\"vm.actions.addRoleMenu\" class=\"add-menu\"><md-button ng-click=\"$mdOpenMenu($event)\" class=\"tab-icon\"><md-tooltip>Добавить</md-tooltip><md-icon class=\"material-icons\">add</md-icon>Добавить</md-button><md-menu-content class=\"add-menu-content\"><md-menu-item><md-button ng-click=\"vm.addNewRole($event)\" id=\"add-role-button\">Роль</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.addNewCurrency($event)\" id=\"add-currency-button\">Валюту</md-button></md-menu-item></md-menu-content></md-menu><md-button ng-click=\"vm.addNewTask($event)\" ng-show=\"vm.actions.addTask\" id=\"add-workhour-button\" class=\"tab-icon\"><md-tooltip>Добавить нормочас</md-tooltip><md-icon class=\"material-icons\">add</md-icon>Добавить нормочас</md-button><md-button ng-click=\"vm.addNewFeature($event)\" ng-show=\"vm.actions.addFeature\" id=\"add-feature-button\" class=\"tab-icon\"><md-tooltip>Добавить фичу</md-tooltip><md-icon class=\"material-icons\">add</md-icon>Добавить фичу</md-button><md-button ng-click=\"vm.editEstimate($event)\" ng-show=\"vm.actions.edit.show\" id=\"edit-feature-button\" class=\"tab-icon\"><md-icon class=\"material-icons\">edit</md-icon>{{vm.actions.edit.message}}</md-button><md-button ng-click=\"vm.undo()\" ng-show=\"vm.actions.undo\" id=\"undo-button\" class=\"md-icon-button tab-icon btn-undo\"><md-tooltip>Отменить</md-tooltip><md-icon class=\"material-icons\">undo</md-icon></md-button><md-button ng-disabled=\"true\" ng-click=\"\" ng-show=\"vm.actions.redo\" id=\"repeat-button\" class=\"md-icon-button tab-icon btn-redo\"><md-tooltip>Повторить</md-tooltip><md-icon class=\"material-icons\">redo</md-icon></md-button><md-button ng-click=\"vm.save($event)\" ng-show=\"vm.actions.save\" id=\"save-button\" class=\"tab-icon btn-save\"><md-tooltip>Сохранить</md-tooltip><md-icon class=\"material-icons\">save</md-icon>Сохранить</md-button></div></md-toolbar>");
$templateCache.put("/app/components/directives/bodyTable/bodyTable.html","<div layout=\"row\" layout-wrap=\"\" layout-align=\"space-between center\" class=\"wrap-item\"><div flex=\"\" class=\"wrap-name\"><md-input-container md-no-float=\"\" ng-show=\"vm.locale == \'ru\'\" class=\"md-block\"><input ng-model=\"vm.item.name\" type=\"text\" placeholder=\"{{vm.ref ? \'\' : \'Введите роль\'}}\" ng-disabled=\"!vm.editable || vm.isQaPm(vm.item.name)\" ng-focus=\"vm.setValue(vm.item.name)\" ng-blur=\"vm.compareRole(\'name\')\"></md-input-container><md-input-container md-no-float=\"\" ng-show=\"vm.locale==\'en\'\" class=\"md-block\"><input ng-model=\"vm.item.nameEn\" type=\"text\" placeholder=\"{{vm.ref ? \'\' : \'Введите роль\'}}\" ng-disabled=\"!vm.editable\" ng-focus=\"vm.setValue(vm.item.nameEn)\" ng-blur=\"vm.compareRole(\'nameEn\')\"></md-input-container></div><div flex=\"none\" layout=\"row\" layout-align=\"center center\" ng-repeat=\"currency in vm.currencies\" class=\"wrap-costs\"><md-input-container md-no-float=\"\" class=\"md-block\"><input ng-model=\"vm.item.dict[currency._id].value\" type=\"text\" placeholder=\"0\" min=\"0\" number-input=\"\" ng-disabled=\"!currency._id || !vm.editable\" ng-focus=\"vm.setValue(vm.item.dict[currency._id].value)\" ng-blur=\"vm.compareRole(currency._id)\" class=\"text-center\"></md-input-container></div><div flex=\"10\" layout=\"row\" layout-align=\"end center\" class=\"wrap-ctrl-icons\"><div flex=\"50\" class=\"text-right\"><md-icon md-svg-src=\"/assets/images/close.svg\" aria-label=\"Delete\" ng-click=\"vm.delete($event, vm.index)\" ng-if=\"vm.ref &amp;&amp; vm.canBeDeleted &amp;&amp; !vm.isQaPm(vm.item.name)\" class=\"pointer\"><md-tooltip md-direction=\"top\">Удалить задачу</md-tooltip></md-icon><md-icon aria-label=\"Добавление\" ng-click=\"!!vm.item.name &amp;&amp; vm.add()\" ng-class=\"{\'disabled\': !vm.item.name}\" ng-if=\"!vm.ref\" class=\"material-icons pointer\">done</md-icon></div></div></div>");
$templateCache.put("/app/components/directives/copyright/copyright.html","<div class=\"copyrightFooter\">Copyright © SimbirSoft 2016 - {{vm.currentYear}}. Все права защищены</div>");
$templateCache.put("/app/components/directives/featuresTable/featuresTable.html","<div layout=\"row\" layout-align=\"start end\" class=\"row-wrap feature-ctrl-items-center\"><div flex=\"\" layout=\"column\" layout-align=\"start start\" class=\"wrap-main\"><div layout=\"row\" layout-align=\"start center\" class=\"wrap-main-firstrow\"><textarea item-name=\"vm.item.name\" add-title-attr=\"{{vm.item.name}}\" max-title=\"70\" save-change=\"vm.saveChange(\'name\')\" element-bind-text=\"vm.setValueModel(valueField, \'name\')\" ng-class=\"{\'no-border\': vm.descriptionOpen}\" ng-disabled=\"::!vm.isEditable\" aria-label=\"Название фичи\" autosize-textarea=\"\" ng-trim=\"false\" required=\"required\" id=\"feature-name-textarea\" class=\"feature-name bold wrap-title\">{{::vm.item.name}}</textarea><div layout=\"row\" layout-align=\"start start\" class=\"wrap-icons\"><md-icon ng-click=\"vm.toggle()\"><span ng-if=\"vm.collapsed\">expand_less</span><span ng-if=\"!vm.collapsed\">expand_more</span></md-icon><md-icon md-svg-src=\"/assets/images/message-text-outline.svg\" ng-click=\"vm.toggleDescription()\" ng-class=\"{\'green\': vm.item.description}\" ng-if=\"vm.isEditable || vm.item.description\" hide-tooltip=\"\" ng-style=\"vm.item.description.length &gt; 0 ? {\'fill\':\'#1b3c90\'} : {\'fill\':\'#dedede\'}\" class=\"wrap-ico wrap-ico-1\"><md-tooltip md-direction=\"top\">Комментарий</md-tooltip></md-icon><md-icon md-svg-src=\"/assets/images/import_contacts.svg\" ng-if=\"false\" class=\"wrap-ico wrap-ico-2\"></md-icon><md-icon ng-click=\"vm.showTaskInput($event)\" ng-if=\"::vm.isEditable\" hide-tooltip=\"\" style=\"fill: #1b3c90\" class=\"wrap-ico wrap-add-btn\">add<md-tooltip md-direction=\"top\">Добавить задачу</md-tooltip></md-icon></div></div><div layout=\"row\" layout-align=\"start end\" ng-if=\"vm.descriptionOpen\" class=\"wrap-main-secondrow\"><div ng-if=\"::vm.isEditable\" class=\"description\"><textarea element-bind-text=\"vm.setValueModel(valueField, \'description\')\" element-bind-empty=\"true\" aria-label=\"Описание\" maxlength=\"1500\" ng-blur=\"vm.saveChange(\'description\')\" autofocus-input=\"\" autosize-textarea=\"\" ng-trim=\"false\" id=\"description-textarea\" class=\"wrap-desc\">{{::vm.item.description}}</textarea></div><div ng-bind=\"vm.item.description\" ng-if=\"::!vm.isEditable\" class=\"wrap-desc\"></div></div></div><div flex=\"10\" layout=\"row\" layout-align=\"center start\" class=\"wrap-count\"><md-input-container flex=\"50\" tabindex=\"-1\"><span class=\"bold text-center\">{{vm.featureStatistic.count}}</span></md-input-container></div><div flex=\"none\" class=\"wrap-role\"><span class=\"text-center bold\">{{vm.getSumRole()}}</span></div><div flex=\"15\" layout=\"row\" layout-align=\"center start\" class=\"wrap-time\"><md-input-container flex=\"50\" tabindex=\"-1\" layout-align=\"center center\"><span class=\"bold text-center\">{{vm.featureStatistic.minHours | number:1}}</span></md-input-container><md-input-container flex=\"50\" tabindex=\"-1\" layout-align=\"center center\"><span class=\"bold text-center\">{{vm.featureStatistic.maxHours | number:1}}</span></md-input-container></div><div flex=\"5\" layout=\"row\" layout-align=\"center start\" class=\"wrap-qa\"><div flex=\"70\" layout=\"row\" layout-align=\"center end\" class=\"edit\"><div ng-class=\"vm.item.qaEnabled ? \'cell-colored\' : \'cell-colored-gray\'\" ng-click=\"vm.setActive($event, vm.item, \'qaEnabled\', \'qa\')\" ng-if=\"!vm.showInputs.qa\" class=\"toggle\"><div>{{vm.item.qa}}</div></div><md-input-container ng-if=\"vm.showInputs.qa\"><input type=\"text\" element-bind=\"vm.setValueModel(valueField, \'qa\')\" maxlength=\"3\" value=\"{{::vm.item.qa}}\" ng-blur=\"vm.changeTasks(vm.item, \'qa\')\" tabindex=\"-1\" aria-label=\"QA\" ng-disabled=\"::!vm.isEditable\" autofocus-input=\"\" ng-trim=\"false\"></md-input-container></div></div><div flex=\"5\" layout=\"row\" layout-align=\"center start\" class=\"wrap-paam\"><div flex=\"70\" layout=\"row\" layout-align=\"center end\" class=\"edit\"><div ng-class=\"vm.item.pmEnabled ? \'cell-colored\' : \'cell-colored-gray\'\" ng-click=\"vm.setActive($event, vm.item, \'pmEnabled\', \'pm\')\" ng-if=\"!vm.showInputs.pm\" class=\"toggle\"><div>{{vm.item.pm}}</div></div><md-input-container ng-if=\"vm.showInputs.pm\"><input type=\"text\" element-bind=\"vm.setValueModel(valueField, \'pm\')\" maxlength=\"3\" value=\"{{::vm.item.pm}}\" ng-blur=\"vm.changeTasks(vm.item, \'pm\')\" tabindex=\"-1\" aria-label=\"PM\" ng-disabled=\"::!vm.isEditable\" autofocus-input=\"\" ng-trim=\"false\"></md-input-container></div></div><div flex=\"5\" layout=\"row\" layout-align=\"center start\" class=\"wrap-bugs\"><div flex=\"70\" layout=\"row\" layout-align=\"center end\" class=\"edit\"><div ng-class=\"vm.item.bugsEnabled ? \'cell-colored\' : \'cell-colored-gray\'\" ng-click=\"vm.setActive($event, vm.item, \'bugsEnabled\', \'bugs\')\" ng-if=\"!vm.showInputs.bugs\" class=\"toggle\"><div>{{vm.item.bugs}}</div></div><md-input-container ng-if=\"vm.showInputs.bugs\"><input type=\"text\" element-bind=\"vm.setValueModel(valueField, \'bugs\')\" maxlength=\"3\" value=\"{{::vm.item.bug}}\" ng-blur=\"vm.changeTasks(vm.item, \'bugs\')\" tabindex=\"-1\" ng-disabled=\"::!vm.isEditable\" aria-label=\"BUGS\" autofocus-input=\"\" ng-trim=\"false\"></md-input-container></div></div><div flex=\"5\" layout=\"row\" layout-align=\"end end\" class=\"wrap-ctrl-icons feature-ctrl-icons-center\"><div flex=\"none\" layout=\"row\" layout-align=\"center center\" class=\"ctrl-icons\"><md-button ng-click=\"vm.copy($event, vm.item)\" tabindex=\"-1\" ng-disabled=\"::!vm.isEditable\" id=\"copy-feature-button\" class=\"md-icon-button icon-button tab-icon\"><md-icon md-svg-src=\"/assets/images/content_copy.svg\"></md-icon><md-tooltip md-direction=\"top\">Копировать фичу</md-tooltip></md-button></div><div flex=\"none\" layout=\"row\" layout-align=\"center center\" class=\"ctrl-icons\"><md-button ng-click=\"vm.deleteFeature($event, vm.item)\" tabindex=\"-1\" ng-disabled=\"::!vm.isEditable\" id=\"delete-feature-button\" class=\"md-icon-button icon-button tab-icon\"><md-icon md-svg-src=\"/assets/images/close.svg\"></md-icon><md-tooltip md-direction=\"top\">Удалить фичу</md-tooltip></md-button></div></div></div><typeahead-task-inline ng-if=\"vm.inputVisible\" phase-item=\"vm.phaseItem\" new-custom-item=\"vm.newCustomItem\" new-existing-item=\"vm.newExistingItem\" input-visib=\"vm.hideTaskInput\" tasks-dictionaty=\"::vm.tasksDictionaty\"></typeahead-task-inline>");
$templateCache.put("/app/components/directives/groupsTable/groupsTable.html","<div flex=\"\" layout=\"column\" layout-align=\"start start\" class=\"wrap-main groups-table\"><div layout=\"row\" layout-align=\"start center\" flex=\"grow\" class=\"wrap-main-firstrow\"><md-icon ng-click=\"vm.toggle()\" class=\"pointer wrap-ico\"><span ng-if=\"vm.collapsed\">chevron_right</span><span ng-if=\"!vm.collapsed\">expand_more</span></md-icon><md-input-container flex=\"grow\"><input ng-model=\"vm.item.name\" ng-disabled=\"!vm.isEditable\" add-title-attr=\"{{vm.item.name}}\" max-title=\"45\" aria-label=\"Название фичи\" ng-focus=\"vm.setValue(\'name\')\" ng-blur=\"vm.compare(\'name\')\" ng-trim=\"false\" ng-class=\"{\'bold\': !vm.isEditable, \'label\': !vm.isEditable}\" ng-style=\"vm.isEditable ? {\'background-color\':\'#f4f4f4\'} : {\'background-color\':\'transparent\'}\" class=\"wrap-title\"></md-input-container><div layout=\"row\" layout-align=\"start start\" class=\"wrap-icons\"><md-icon md-svg-src=\"/assets/images/message-text-outline.svg\" ng-click=\"vm.toggleDescription()\" ng-class=\"{\'green\': vm.item.description}\" ng-show=\"vm.isEditable || vm.item.description\" hide-tooltip=\"\" ng-style=\"vm.item.description.length &gt; 0 ? {\'fill\':\'#1b3c90\'} : {\'fill\':\'#dedede\'}\" class=\"pointer wrap-ico wrap-ico-1\"><md-tooltip ng-if=\"!vm.isEditable\" md-direction=\"top\">Комментарий</md-tooltip><md-tooltip ng-if=\"vm.isEditable\" md-direction=\"top\">Изменить комментарий</md-tooltip></md-icon><md-icon ng-click=\"vm.addNewTask($event, vm.index)\" ng-if=\"vm.isEditable\" hide-tooltip=\"\" class=\"wrap-ico wrap-add-btn\">add_circle<md-tooltip md-direction=\"top\">Добавить нормочас</md-tooltip></md-icon></div><div flex=\"15\" ng-if=\"vm.showPhases\" class=\"wrap-phases\"><div ng-class=\"{\'phase-link green\': vm.isEditable, \'phase-link-disabled\': !vm.isEditable, \'bold\': !vm.isEditable}\" ng-click=\"vm.associateGroup($event)\">{{vm.getAssociatedPhases()}}</div></div><div flex=\"none\" layout=\"row\" layout-align=\"center start\" class=\"wrap-count\"><span ng-if=\"!vm.isCountEditable\" class=\"bold text-center\">{{vm.getSumCount()}}</span><md-input-container ng-if=\"vm.isCountEditable\"><input ng-model=\"vm.count\" aria-label=\"Количество\" ng-blur=\"vm.validate($event)\" ng-focus=\"vm.setValueCount()\" ng-trim=\"false\" class=\"text-center\"></md-input-container></div><div flex=\"none\" class=\"wrap-role\"><span class=\"bold text-center\">{{vm.getSumRole()}}</span></div><div flex=\"15\" layout=\"row\" layout-align=\"start center\" class=\"wrap-time\"><div layout=\"row\" layout-align=\"center\" flex=\"50\"><span class=\"bold text-center\">{{vm.getSumMin()}}</span></div><div layout=\"row\" layout-align=\"center\" flex=\"50\"><span class=\"bold text-center\">{{vm.getSumMax()}}</span></div></div><div flex=\"10\" layout=\"row\" layout-align=\"end end\" class=\"wrap-ctrl-icons-work\"><div flex=\"50\" class=\"text-right\"></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\" class=\"ctrl-icons delete\"><md-button ng-click=\"vm.deleteFeature($event, vm.index)\" tabindex=\"-1\" ng-disabled=\"!vm.canBeDeleted\" id=\"delete-feature-button\" class=\"md-icon-button icon-button tab-icon\"><md-icon md-svg-src=\"/assets/images/close.svg\"></md-icon><md-tooltip md-direction=\"top\">Удалить фичу</md-tooltip></md-button></div></div></div><div layout=\"row\" layout-align=\"start start\" ng-if=\"vm.show()\" ng-show=\"vm.locale == \'ru\'\" class=\"wrap-main-secondrow groups-table-comments\"><md-input-container ng-if=\"vm.isEditable\"><input ng-model=\"vm.item.description\" aria-label=\"Описание\" maxlength=\"1500\" autofocus-input=\"\" autosize-textarea=\"\" ng-focus=\"vm.setValue(\'description\')\" ng-blur=\"vm.compare(\'description\')\" ng-trim=\"false\" class=\"wrap-desc\"></md-input-container><div ng-bind=\"vm.item.description\" ng-if=\"!vm.isEditable\" class=\"wrap-desc\"></div></div></div>");
$templateCache.put("/app/components/directives/headTable/headTable.html","<div ng-if=\"vm.ref === \'tasks\'\" class=\"table-head head-estimate\"><div layout=\"row\" layout-align=\"start end\" class=\"first-table-row\"><label flex-offset=\"80\" flex=\"5\" class=\"text-center\">QA,%</label> <label flex=\"5\" class=\"text-center\">PM/AM,%</label> <label flex=\"5\" class=\"text-center\">BUGS,%</label> <label flex=\"5\" class=\"text-center\">Risks,%</label></div><div layout=\"row\" layout-align=\"start end\" class=\"second-table-row\"><div layout=\"row\" layout-align=\"start center\" flex=\"\" class=\"name-estimate\"><label class=\"name-label header-text-blue\">Название, описание</label><md-icon ng-click=\"vm.toggle()\" class=\"wrap-ico header-text-blue\"><span ng-if=\"vm.collapsed\">expand_less</span><span ng-if=\"!vm.collapsed\">expand_more</span></md-icon></div><div layout=\"row\" layout-align=\"center start\" flex=\"10\" class=\"count-estimate\"><label>Кол-во</label><md-icon ng-click=\"vm.toggle()\" class=\"wrap-ico header-text-blue\"><span ng-if=\"vm.collapsed\">expand_less</span><span ng-if=\"!vm.collapsed\">expand_more</span></md-icon></div><div layout-align=\"end start\" flex=\"none\" class=\"role\"><label>Роль</label></div><div flex=\"15\" class=\"text-center wrap-time\"><div layout=\"row\" layout-align=\"end center\"><label flex=\"grow\">Часы от - до</label></div></div><div flex=\"5\" layout=\"row\" layout-align=\"center start\" class=\"wrap-qa\"><div flex=\"70\" layout=\"row\" layout-align=\"center end\" data-nodrag=\"\" class=\"edit\"><div ng-class=\"vm.item.qaEnabled ? \'cell-colored\' : \'cell-colored-gray\'\" ng-click=\"vm.setActive($event, vm.item, \'qaEnabled\', \'qa\')\" ng-if=\"!vm.active.qa\" class=\"toggle\"><div>{{vm.item.qa}}</div></div><md-input-container data-nodrag=\"\" ng-if=\"vm.active.qa\" class=\"noarrow\"><input type=\"text\" number-input-int=\"\" maxlength=\"3\" ng-model=\"vm.item.qa\" ng-blur=\"vm.changeTasks(vm.item, \'qa\')\" ng-disabled=\"!vm.isEditable\" aria-label=\"QA\" autofocus-input=\"\"></md-input-container></div></div><div flex=\"5\" layout=\"row\" layout-align=\"center start\" class=\"wrap-paam\"><div flex=\"70\" layout=\"row\" layout-align=\"center end\" data-nodrag=\"\" class=\"edit\"><div ng-class=\"vm.item.pmEnabled ? \'cell-colored\' : \'cell-colored-gray\'\" ng-click=\"vm.setActive($event, vm.item, \'pmEnabled\', \'pm\')\" ng-if=\"!vm.active.pm\" class=\"toggle\"><div>{{vm.item.pm}}</div></div><md-input-container data-nodrag=\"\" ng-if=\"vm.active.pm\" class=\"noarrow\"><input type=\"text\" number-input-int=\"\" maxlength=\"3\" ng-model=\"vm.item.pm\" ng-blur=\"vm.changeTasks(vm.item, \'pm\')\" ng-disabled=\"!vm.isEditable\" aria-label=\"PM\" autofocus-input=\"\"></md-input-container></div></div><div flex=\"5\" layout=\"row\" layout-align=\"center start\" class=\"wrap-bugs\"><div flex=\"70\" layout=\"row\" layout-align=\"center end\" data-nodrag=\"\" class=\"edit\"><div ng-class=\"vm.item.bugsEnabled ? \'cell-colored\' : \'cell-colored-gray\'\" ng-click=\"vm.setActive($event, vm.item, \'bugsEnabled\', \'bugs\')\" ng-if=\"!vm.active.bugs\" class=\"toggle\"><div>{{vm.item.bugs}}</div></div><md-input-container data-nodrag=\"\" ng-if=\"vm.active.bugs\"><input type=\"text\" number-input-int=\"\" maxlength=\"3\" ng-model=\"vm.item.bugs\" ng-blur=\"vm.changeTasks(vm.item, \'bugs\')\" ng-disabled=\"!vm.isEditable\" aria-label=\"Bugs\" autofocus-input=\"\"></md-input-container></div></div><div flex=\"5\" layout=\"row\" layout-align=\"center start\" class=\"wrap-risks\"><div flex=\"70\" layout=\"row\" layout-align=\"center end\" data-nodrag=\"\" class=\"edit\"><div ng-class=\"vm.item.risksEnabled ? \'cell-colored\' : \'cell-colored-gray\'\" ng-click=\"vm.setActive($event, vm.item, \'risksEnabled\', \'risks\')\" ng-if=\"!vm.active.risks\" class=\"toggle\"><div>{{vm.item.risks}}</div></div><md-input-container data-nodrag=\"\" ng-if=\"vm.active.risks\"><input type=\"text\" number-input-int=\"\" maxlength=\"3\" ng-model=\"vm.item.risks\" ng-blur=\"vm.changeTasks(vm.item, \'risks\')\" ng-disabled=\"!vm.isEditable\" aria-label=\"Bugs\" autofocus-input=\"\"></md-input-container></div></div></div></div><div ng-if=\"vm.ref === \'workhours\'\" class=\"table-head head-workhour\"><div layout=\"row\" layout-align=\"start end\" class=\"first-table-row\"><label flex-offset=\"75\" flex=\"15\" class=\"text-center wrap-time padding-left\">Часы</label><div flex=\"10\"><label flex=\"70\" ng-if=\"vm.isEditable\" class=\"wrap-time\">Для поиска</label><div flex=\"30\"></div></div></div><div layout=\"row\" layout-align=\"start end\" class=\"second-table-row\"><div flex=\"\" class=\"name-workhour\"><label>Название, описание, примеры</label></div><div flex=\"15\" class=\"phase-workhour\"><label>Фазы</label></div><div flex=\"none\" class=\"role-workhour\"><label>Роль</label></div><div flex=\"15\" class=\"text-center wrap-time padding-left\"><div layout=\"row\" layout-align=\"end center\"><label flex=\"45\">от</label> <label flex=\"10\">–</label> <label flex=\"45\">до</label></div></div><div flex=\"10\" layout=\"row\" layout-align=\"end end\" class=\"icons-workhour\"><div flex=\"70\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.useSearch($event)\" ng-if=\"vm.isEditable\" class=\"ctrl-icons\"><md-checkbox ng-model=\"vm.toggleUseSearch\" aria-label=\"Использовать при поиске\" class=\"md-primary\"></md-checkbox><md-tooltip md-direction=\"top\">Использовать при поиске</md-tooltip></div><div flex=\"30\"></div></div></div></div><div ng-if=\"vm.ref === \'groups\'\" class=\"table-head head-workhour\"><div layout=\"row\" layout-align=\"start end\" class=\"first-table-row\"><label flex-offset=\"75\" flex=\"15\" class=\"text-center wrap-time padding-left\">Часы</label></div><div layout=\"row\" layout-align=\"start end\" class=\"second-table-row\"><div flex=\"\" class=\"name-workhour\"><label>Название, описание</label></div><div flex=\"15\" class=\"phase-workhour\"><label>Фазы</label></div><div flex=\"none\" class=\"count-workhour\"><label>Кол-во</label></div><div layout-align=\"end start\" flex=\"none\" class=\"phase-workhour role\"><label>Роль</label></div><div flex=\"15\" class=\"text-center wrap-time padding-left\"><div layout=\"row\" layout-align=\"end center\"><label flex=\"45\">от</label> <label flex=\"10\">–</label> <label flex=\"45\">до</label></div></div><div flex=\"10\"></div></div></div><div ng-if=\"vm.ref === \'phases\'\" class=\"table-head head-templ\"><div layout=\"row\" layout-align=\"start end\" class=\"first-table-row\"><label flex-offset=\"75\" flex=\"15\" class=\"text-center wrap-time padding-left\">Часы</label></div><div layout=\"row\" layout-align=\"start end\" class=\"second-table-row\"><div layout-align=\"end start\" flex=\"\" class=\"name-templ\"><label>Название, описание</label></div><div flex=\"none\" class=\"count-templ\"><label>Кол-во</label></div><div flex=\"none\" class=\"role-templ\"><label>Роль</label></div><div flex=\"15\" class=\"text-center wrap-time padding-left\"><div layout=\"row\" layout-align=\"end center\"><label flex=\"45\">от</label> <label flex=\"10\">–</label> <label flex=\"45\">до</label></div></div><div flex=\"10\"></div></div></div><div ng-if=\"vm.ref === \'tags\'\" class=\"table-head flatHeight\"><div layout=\"row\" layout-align=\"start end\"><div layout=\"row\" layout-align=\"start end\" flex=\"grow\" class=\"name-column\"><div class=\"filter\"><md-icon aria-label=\"Сортировка\" md-svg-src=\"/assets/images/arrow.svg\" ng-click=\"vm.changeSorting(\'name\')\" ng-class=\"{\'sort-active\': vm.comparator === \'name\', \'arrow-down\': !vm.reverse}\" class=\"tab-icon material-icons pointer\"></md-icon><label>Название</label></div></div><div layout=\"row\" layout-align=\"center end\" flex=\"none\" class=\"workhours-column\"><label>Нормочасы</label></div><div layout=\"row\" layout-align=\"center end\" flex=\"none\" class=\"features-column\"><label>Фичи</label></div><div layout=\"row\" layout-align=\"start end\" flex=\"20\" class=\"roles-column\"><label>Роли</label></div><div layout=\"row\" layout-align=\"center end\" flex=\"none\" class=\"hours-column\"><label>Кол-во часов</label></div><div flex=\"none\" class=\"icons-column\"></div></div></div>");
$templateCache.put("/app/components/directives/newTask/newTask.html","<div flex=\"\" ng-if=\"vm.tableRow.name\" class=\"wrap-main\"><div class=\"wrap-main-firstrow\"><md-input-container ng-form=\"\" md-no-float=\"\" name=\"nameForm\"><input ng-disabled=\"vm.locale!=\'ru\'\" ng-keypress=\"vm.addItemOnEnter($event)\" name=\"nameInput\" ng-model=\"vm.item.name\" placeholder=\"Введите название\" class=\"gray bold wrap-title\"></md-input-container></div></div><div flex=\"15\" style=\"padding-right: 20px\" class=\"wrap-phases\"><div ng-click=\"vm.associateGroup($event)\" class=\"phase-link green\">{{vm.getAssociatedPhases()}}</div></div><div flex=\"none\" layout=\"row\" layout-align=\"center start\" ng-if=\"vm.tableRow.count\" class=\"wrap-count\"><md-input-container class=\"textarea-container\"><textarea rows=\"1\" ng-bind=\"vm.getSumCount()\" ng-disabled=\"!vm.isEditable\" aria-label=\"Количество\" class=\"gray text-center\"></textarea></md-input-container></div><div flex=\"none\" class=\"wrap-role\"><md-input-container class=\"textarea-container\"><md-select ng-model=\"vm.item.role\" placeholder=\"Выберите роль\" ng-disabled=\"!vm.isEditable\" class=\"gray wrap-title\"><md-option ng-value=\"role\" ng-repeat=\"role in vm.roleList\">{{role.name}}</md-option></md-select></md-input-container></div><div flex=\"15\" layout=\"row\" layout-align=\"start end\" class=\"wrap-time\"><div layout=\"row\" layout-align=\"center center\" flex=\"50\"><md-input-container><input ng-keypress=\"vm.addItemOnEnter($event)\" type=\"text\" number-input=\"\" ng-model=\"vm.item.minHours\" ng-disabled=\"!vm.isEditable\" maxlength=\"7\" aria-label=\"Минимальное количество часов\" class=\"gray text-center\"></md-input-container></div><div layout=\"row\" layout-align=\"center center\" flex=\"50\"><md-input-container><input ng-keypress=\"vm.addItemOnEnter($event)\" type=\"text\" number-input=\"\" ng-model=\"vm.item.maxHours\" ng-disabled=\"!vm.isEditable\" maxlength=\"7\" aria-label=\"Максимальное количество часов\" class=\"gray text-center\"></md-input-container></div></div><div flex=\"10\" layout=\"row\" layout-align=\"start center\" class=\"wrap-ctrl-icons\"><div flex=\"50\" class=\"text-right\"></div><div flex=\"50\" class=\"text-right\"><md-icon aria-label=\"Добавление\" ng-click=\"vm.addItem($event)\" ng-class=\"{\'disabled\': vm.disabled()}\" class=\"material-icons pointer\">done</md-icon></div></div>");
$templateCache.put("/app/components/directives/tasksTable/tasksTable.html","<div flex=\"\" layout=\"column\" layout-align=\"end end\" class=\"wrap-main\"><div layout=\"row\" layout-align=\"start start\" class=\"wrap-main-firstrow\"><textarea item-name=\"vm.item.name\" add-title-attr=\"{{vm.item.name}}\" max-title=\"70\" element-bind-text=\"vm.setValueModel(valueField, \'name\')\" ng-class=\"{\'no-border\': vm.descriptionOpen}\" ng-disabled=\"::!vm.isEditable\" aria-label=\"Название таски\" autosize-textarea=\"\" save-change=\"vm.saveChange(\'name\')\" ng-trim=\"false\" required=\"required\" id=\"task-name-textarea\" maxlength=\"500\" rows=\"2\" class=\"wrap-title\">{{::vm.item.name }}</textarea><div layout=\"row\" layout-align=\"start start\" class=\"wrap-icons fix\"><md-icon md-svg-src=\"/assets/images/message-text-outline.svg\" ng-click=\"vm.toggleDescription()\" ng-if=\"vm.isEditable || vm.item.description\" hide-tooltip=\"\" ng-style=\"vm.item.description.length &gt; 0 ? {\'fill\':\'#1b3c90\'} : {\'fill\':\'#dedede\'}\" class=\"wrap-ico wrap-ico-1\"><md-tooltip md-direction=\"top\">Комментарий</md-tooltip></md-icon><md-icon md-svg-src=\"/assets/images/import_contacts.svg\" ng-if=\"false\" class=\"wrap-ico wrap-ico-2\"><md-tooltip md-direction=\"top\">Показать примеры</md-tooltip></md-icon></div></div><div layout=\"row\" layout-align=\"start end\" ng-if=\"vm.descriptionOpen\" class=\"wrap-main-secondrow\"><div ng-if=\"::vm.isEditable\" class=\"description\"><textarea element-bind-text=\"vm.setValueModel(valueField, \'description\')\" element-bind-empty=\"true\" aria-label=\"Описание\" maxlength=\"1500\" ng-blur=\"vm.saveChange(\'description\')\" autofocus-input=\"\" autosize-textarea=\"\" ng-trim=\"false\" id=\"description-textarea\" class=\"wrap-desc\">{{::vm.item.description}}</textarea></div><div ng-bind=\"vm.item.description\" ng-if=\"::!vm.isEditable\" class=\"wrap-desc\"></div></div></div><div flex=\"10\" layout=\"row\" layout-align=\"center end\" class=\"wrap-count\"><md-input-container flex=\"50\" tabindex=\"-1\"><input type=\"text\" maxlength=\"4\" ng-disabled=\"::!vm.isEditable\" ng-blur=\"vm.validate($event, \'count\')\" aria-label=\"Количество\" ng-trim=\"false\" value=\"{{::vm.item.count}}\" element-bind=\"vm.setValueModel(valueField, \'count\')\" class=\"bold text-center\"></md-input-container></div><div flex=\"none\" class=\"wrap-role select\"><md-select ng-class=\"{\'error\': !vm.item.role}\" ng-model=\"vm.item.role\" placeholder=\"Выберите роль\" ng-model-options=\"{trackBy: \'$value._id || $value\'}\" md-on-close=\"vm.saveChange(\'role\')\" ng-if=\"::vm.isEditable\" id=\"choose-role-select\"><md-option ng-value=\"::role\" ng-repeat=\"role in ::vm.roleList track by role._id\">{{::role.name}}</md-option></md-select><div ng-if=\"::!vm.isEditable\" class=\"role-container gray\">{{::vm.item.role.name}}</div></div><div flex=\"15\" layout=\"row\" layout-align=\"start end\" class=\"wrap-time\"><div flex=\"50\" layout=\"row\" layout-align=\"center\" ng-class=\"{\'error\': vm.error(\'minHours\')}\"><md-input-container tabindex=\"-1\"><input type=\"text\" wh-value=\"vm.item.minHours\" element-bind-decimal=\"vm.setValueModel(valueField, \'minHours\')\" maxlength=\"7\" ng-disabled=\"::!vm.isEditable\" aria-label=\"Минимальное количество часов\" ng-blur=\"vm.saveChange(\'minHours\')\" ng-trim=\"false\" class=\"text-center\"></md-input-container></div><div flex=\"50\" layout=\"row\" layout-align=\"center\" ng-class=\"{\'error\': vm.error(\'maxHours\')}\"><md-input-container tabindex=\"-1\" class=\"max\"><input type=\"text\" wh-value=\"vm.item.maxHours\" element-bind-decimal=\"vm.setValueModel(valueField, \'maxHours\')\" maxlength=\"7\" ng-disabled=\"::!vm.isEditable\" aria-label=\"Максимальное количество часов\" ng-blur=\"vm.saveChange(\'maxHours\')\" ng-trim=\"false\" class=\"text-center\"></md-input-container></div></div><div flex=\"5\" layout=\"row\" layout-align=\"center end\" class=\"wrap-qa\"><div flex=\"70\" layout=\"row\" layout-align=\"center end\" class=\"edit\"><div ng-class=\"vm.item.qaEnabled ? \'cell-colored\' : \'cell-colored-gray\'\" ng-click=\"vm.toggle($event, \'qaEnabled\', \'qa\')\" ng-if=\"!vm.showInputs.qa\" class=\"toggle\"><div>{{vm.item.qa}}</div></div><md-input-container tabindex=\"-1\" ng-if=\"vm.showInputs.qa\"><input type=\"text\" element-bind=\"vm.setValueModel(valueField, \'qa\')\" maxlength=\"3\" ng-disabled=\"::!vm.isEditable\" ng-blur=\"vm.validate($event, \'qa\')\" aria-label=\"QA\" autofocus-input=\"\" ng-trim=\"false\" value=\"{{::vm.item.qa}}\"></md-input-container></div></div><div flex=\"5\" layout=\"row\" layout-align=\"center end\" class=\"wrap-paam\"><div flex=\"70\" layout=\"row\" layout-align=\"center end\" class=\"edit\"><div ng-class=\"vm.item.pmEnabled ? \'cell-colored\' : \'cell-colored-gray\'\" ng-click=\"vm.toggle($event, \'pmEnabled\', \'pm\')\" ng-if=\"!vm.showInputs.pm\" class=\"toggle\"><div>{{vm.item.pm}}</div></div><md-input-container tabindex=\"-1\" ng-if=\"vm.showInputs.pm\"><input type=\"text\" element-bind=\"vm.setValueModel(valueField, \'pm\')\" maxlength=\"3\" value=\"{{::vm.item.pm}}\" ng-disabled=\"::!vm.isEditable\" ng-blur=\"vm.validate($event, \'pm\')\" aria-label=\"PM\" autofocus-input=\"\" ng-trim=\"false\"></md-input-container></div></div><div flex=\"5\" layout=\"row\" layout-align=\"center end\" class=\"wrap-bugs\"><div flex=\"70\" layout=\"row\" layout-align=\"center end\" class=\"edit\"><div ng-class=\"vm.item.bugsEnabled ? \'cell-colored\' : \'cell-colored-gray\'\" ng-click=\"vm.toggle($event, \'bugsEnabled\', \'bugs\')\" ng-if=\"!vm.showInputs.bugs\" class=\"toggle\"><div>{{vm.item.bugs}}</div></div><md-input-container tabindex=\"-1\" ng-if=\"vm.showInputs.bugs\" class=\"noarrow\"><input type=\"text\" element-bind=\"vm.setValueModel(valueField, \'bugs\')\" maxlength=\"3\" value=\"{{vm.item.bugs}}\" ng-disabled=\"::!vm.isEditable\" ng-blur=\"vm.validate($event, \'bugs\')\" aria-label=\"BUGS\" autofocus-input=\"\" ng-trim=\"false\"></md-input-container></div></div><div flex=\"5\" layout=\"row\" layout-align=\"center center\" class=\"wrap-ctrl-icons\"><div flex=\"none\" layout=\"row\" layout-align=\"center center\" class=\"ctrl-icons\"><md-button ng-click=\"vm.copy($event, vm.item, vm.parent)\" tabindex=\"-1\" ng-disabled=\"::!vm.isEditable\" hide-tooltip=\"\" id=\"copy-task-button\" class=\"md-icon-button icon-button tab-icon\"><md-icon md-svg-src=\"/assets/images/content_copy.svg\"></md-icon><md-tooltip md-direction=\"top\">Копировать задачу</md-tooltip></md-button></div><div flex=\"none\" layout=\"row\" layout-align=\"center center\" class=\"ctrl-icons\"><md-button ng-click=\"vm.deleteTask($event, vm.item, vm.parent)\" tabindex=\"-1\" ng-disabled=\"::!vm.isEditable\" id=\"delete-task-button\" class=\"md-icon-button icon-button tab-icon\"><md-icon md-svg-src=\"/assets/images/close.svg\"></md-icon><md-tooltip md-direction=\"top\">Удалить задачу</md-tooltip></md-button></div></div>");
$templateCache.put("/app/components/directives/typeaheadTaskInline/typeaheadTaskInline.html","<div class=\"typeahead-task-inline\"><form flex=\"\" ng-submit=\"vm.createCustom(vm.searchText)\" layout=\"row\" layout-align=\"start center\"><md-autocomplete flex=\"\" md-input-minlength=\"3\" md-items=\"item in vm.querySearch(vm.searchText)\" md-search-text=\"vm.searchText\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-item-text=\"item.name\" md-floating-label=\"Начните вводить название задачи.\"><md-item-template><span ng-switch=\"item.type\"><md-icon md-svg-src=\"/assets/images/folder-plus.svg\" ng-switch-when=\"feature\" class=\"adding-area-icon\"></md-icon><md-icon md-svg-src=\"/assets/images/note-plus.svg\" ng-switch-when=\"task\" class=\"adding-area-icon\"></md-icon></span><div flex=\"\" layout=\"column\" layout-align=\"center start\"><div md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.name}}</div><div class=\"associated-phase\">{{vm.associatedTasks[item._id]}}</div></div></md-item-template></md-autocomplete><md-button ng-class=\"{\'md-primary\': vm.searchText.trim()}\" ng-disabled=\"!vm.searchText.trim()\" id=\"save-name-button\" class=\"md-icon-button\"><md-icon class=\"material-icons\">done</md-icon></md-button></form></div>");
$templateCache.put("/app/components/directives/typeaheadTaskPhase/typeaheadTaskPhase.html","<div layout=\"row\" layout-align=\"start center\" class=\"typeahead-task-phase\"><form flex=\"\" ng-submit=\"vm.createCustom(vm.searchText)\" layout=\"row\" layout-align=\"start center\"><md-autocomplete flex=\"\" md-input-minlength=\"3\" md-items=\"item in (vm.isFeature ? vm.querySearchFeature(vm.searchText) : vm.querySearchTasks(vm.searchText))\" md-search-text=\"vm.searchText\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-item-text=\"item.name\" placeholder=\"Начните вводить название\" md-floating-label=\"Введите название\" class=\"md-primary\"><md-item-template><md-icon md-svg-src=\"/assets/images/note-plus.svg\" class=\"adding-area-icon\"></md-icon><div flex=\"\" layout=\"column\" layout-align=\"center start\"><div md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.name}}</div><div class=\"associated-phase\">{{vm.associatedTasks[item._id]}}</div></div></md-item-template></md-autocomplete></form><div layout=\"column\" class=\"toggle\"><span class=\"type\">Тип</span><md-menu><md-button flex=\"\" layout=\"row\" layout-align=\"space-between center\" aria-label=\"Toggle feature creation\" ng-click=\"$mdOpenMenu()\"><span>{{ vm.isFeature ? \"Фича\" : \"Задача\" }}</span><md-icon>expand_more</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"vm.isFeature = false\">+ задача</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.isFeature = true\">+ фича</md-button></md-menu-item></md-menu-content></md-menu></div><md-button ng-disabled=\"!vm.searchText.trim()\" id=\"save-name-button\" style=\"text-transform: capitalize\" ng-click=\"vm.createCustom(vm.searchText)\" class=\"md-icon-button\"><md-icon class=\"material-icons\">done</md-icon></md-button></div>");
$templateCache.put("/app/components/directives/workhoursTable/workhoursTable.html","<div flex=\"\" layout=\"column\" ng-if=\"vm.tableRow.name\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex=\"grow\" class=\"wrap-main\"><md-input-container ng-show=\"vm.locale == \'ru\'\" flex=\"grow\"><input ng-model=\"vm.item.name\" autosize-textarea=\"\" add-title-attr=\"{{vm.item.name}}\" max-title=\"45\" ng-class=\"{\'no-border\': vm.show(), \'bold\': !vm.isEditable}\" ng-disabled=\"!vm.isEditable\" aria-label=\"Название нормочаса\" ng-focus=\"vm.setValue(\'name\')\" ng-blur=\"vm.compare(\'name\')\" ng-trim=\"false\" ng-style=\"vm.isEditable ? {\'background-color\': \'#f4f4f4\'} : {\'background-color\': \'transparent\'}\" class=\"wrap-title\"><md-tooltip ng-if=\"vm.isEditable\" md-direction=\"top\">Изменить описание</md-tooltip></md-input-container><md-input-container ng-show=\"vm.locale != \'ru\'\" flex=\"grow\"><input ng-model=\"vm.item.nameEn\" autosize-textarea=\"\" ng-class=\"{\'no-border\': vm.show(), \'bold\': !vm.isEditable}\" ng-disabled=\"!vm.isEditable\" aria-label=\"Название нормочаса\" ng-focus=\"vm.setValue(\'nameEn\')\" ng-blur=\"vm.compare(\'nameEn\')\" ng-trim=\"false\" ng-style=\"vm.isEditable ? {\'background-color\': \'#f4f4f4\'} : {\'background-color\': \'transparent\'}\" class=\"wrap-title\"><md-tooltip md-direction=\"top\">{{vm.item.name}}</md-tooltip></md-input-container><div layout=\"row\" layout-align=\"start start\" class=\"wrap-icons\"><md-icon md-svg-src=\"/assets/images/message-text-outline.svg\" ng-click=\"vm.toggleDescription()\" ng-class=\"{\'green\': vm.item.descriptionEn}\" ng-show=\"vm.isEditable || vm.item.description\" hide-tooltip=\"\" ng-style=\"vm.item.description.length &gt; 0 ? {\'fill\':\'#1b3c90\'} : {\'fill\':\'#dedede\'}\" class=\"pointer wrap-ico wrap-ico-1\"><md-tooltip ng-if=\"vm.isEditable\" md-direction=\"top\">Изменить комментарий</md-tooltip><md-tooltip ng-if=\"!vm.isEditable\" md-direction=\"top\">Комментарий</md-tooltip></md-icon></div></div><div flex=\"15\" ng-if=\"vm.tableRow.phases\" class=\"wrap-phases\"><div ng-class=\"{\'phase-link green\': vm.isEditable, \'phase-link-disabled\': !vm.isEditable, \'bold\': !vm.isEditable}\"><div ng-click=\"vm.associateWorkhour($event)\">{{vm.getAssociatedPhases()}}</div></div></div><div flex=\"none\" layout=\"row\" layout-align=\"center start\" ng-if=\"vm.tableRow.count\" class=\"wrap-count\"><span ng-if=\"vm.isPartOfGroup\" class=\"bold text-center\">{{vm.count}}</span><md-input-container ng-if=\"!vm.isPartOfGroup\" class=\"textarea-container\"><input type=\"text\" number-input-int=\"\" maxlength=\"4\" ng-model=\"vm.count\" aria-label=\"Количество\" ng-blur=\"vm.validate($event)\" ng-focus=\"vm.setValueCount()\" ng-trim=\"false\" class=\"text-center\"></md-input-container></div><div flex=\"none\" ng-class=\"{\'error\': !vm.item.role}\" class=\"wrap-role\"><md-input-container class=\"textarea-container\"><md-select ng-model=\"vm.item.role\" placeholder=\"Выберите роль\" ng-model-options=\"{trackBy: \'$value._id || $value\'}\" ng-change=\"vm.changeRole($event)\" ng-if=\"vm.isEditable\" md-on-close=\"vm.compare(\'role\')\" md-on-open=\"vm.setValue(\'role\')\"><md-option ng-value=\"role\" ng-repeat=\"role in vm.roleList | filter: vm.roleFilter\">{{role.name}}</md-option></md-select><div ng-if=\"!vm.isEditable\" class=\"bold wrap-title\">{{vm.roleName.name}}</div></md-input-container></div><div flex=\"15\" layout=\"row\" layout-align=\"start center\" class=\"wrap-time\"><div layout=\"row\" layout-align=\"center center\" flex=\"50\" ng-class=\"{\'error\': vm.error(\'minHours\')}\"><md-input-container ng-if=\"vm.isEditable\"><input type=\"text\" number-input=\"\" maxlength=\"7\" minlength=\"1\" ng-model=\"vm.item.minHours\" aria-label=\"Минимальное количество часов\" ng-focus=\"vm.setValue(\'minHours\')\" ng-blur=\"vm.compare(\'minHours\')\" ng-trim=\"false\" ng-style=\"vm.isEditable ? {\'background-color\': \'#f4f4f4\'} : \'\'\" class=\"text-center\"></md-input-container><span ng-if=\"!vm.isEditable\" class=\"bold text-center\">{{vm.item.minHours}}</span></div><div layout=\"row\" layout-align=\"center center\" flex=\"50\" ng-class=\"{\'error\': vm.error(\'maxHours\')}\"><md-input-container ng-if=\"vm.isEditable\"><input type=\"text\" number-input=\"\" maxlength=\"7\" minlength=\"1\" ng-model=\"vm.item.maxHours\" ng-disabled=\"!vm.isEditable\" aria-label=\"Максимальное количество часов\" ng-focus=\"vm.setValue(\'maxHours\')\" ng-blur=\"vm.compare(\'maxHours\')\" ng-trim=\"false\" ng-style=\"vm.isEditable ? {\'background-color\': \'#f4f4f4\'} : \'\'\" class=\"text-center\"></md-input-container><span ng-if=\"!vm.isEditable\" class=\"bold text-center\">{{vm.item.maxHours}}</span></div></div><div flex=\"10\" layout=\"row\" layout-align=\"end center\" class=\"wrap-ctrl-icons-work\"><div flex=\"70\" layout=\"row\" layout-align=\"center center\" ng-show=\"vm.isEditable\" class=\"ctrl-icons\"><md-checkbox ng-model=\"vm.item.useSearch\" aria-label=\"Использовать при поиске\" ng-change=\"vm.save(\'useSearch\')\" class=\"md-primary\"></md-checkbox><md-tooltip md-direction=\"top\">Использовать при поиске</md-tooltip></div><div flex=\"0\" layout=\"row\" layout-align=\"center center\" class=\"ctrl-icons\"></div><div flex=\"30\" layout=\"row\" layout-align=\"end center\" class=\"ctrl-icons delete\"><md-button ng-click=\"vm.deleteItem($event)\" tabindex=\"-1\" ng-disabled=\"!!vm.isPartOfGroup\" id=\"delete-task-button\" class=\"md-icon-button icon-button tab-icon\"><md-icon md-svg-src=\"/assets/images/close.svg\" ng-class=\"{\'disabled\': vm.isPartOfGroup}\"></md-icon><md-tooltip md-direction=\"top\">Удалить задачу</md-tooltip></md-button></div></div></div><div layout=\"row\" layout-align=\"start start\" ng-if=\"vm.show()\" class=\"wrap-main-secondrow\"><md-input-container ng-if=\"vm.isEditable\" ng-show=\"vm.locale == \'ru\'\"><textarea ng-model=\"vm.item.description\" aria-label=\"Описание\" maxlength=\"1500\" autofocus-input=\"\" autosize-textarea=\"\" ng-focus=\"vm.setValue(\'description\')\" ng-blur=\"vm.compare(\'description\')\" ng-trim=\"false\" id=\"description-textarea\" ng-style=\"{\'background-color\': \'#f4f4f4\'}\" class=\"wrap-desc work-hourhs-comments\"></textarea></md-input-container><div ng-bind=\"vm.item.description\" ng-if=\"!vm.isEditable\" class=\"wrap-desc\"></div></div></div>");}]);